import {jsx as $ccwsP$jsx, jsxs as $ccwsP$jsxs, Fragment as $ccwsP$Fragment} from "react/jsx-runtime";
import $ccwsP$react, {useState as $ccwsP$useState, useEffect as $ccwsP$useEffect, createContext as $ccwsP$createContext, useContext as $ccwsP$useContext, useRef as $ccwsP$useRef, useMemo as $ccwsP$useMemo} from "react";
import $ccwsP$reactdomclient from "react-dom/client";
import {Navigate as $ccwsP$Navigate, HashRouter as $ccwsP$HashRouter, Routes as $ccwsP$Routes, Route as $ccwsP$Route, Link as $ccwsP$Link, useLocation as $ccwsP$useLocation, useNavigate as $ccwsP$useNavigate, useParams as $ccwsP$useParams} from "react-router-dom";
import {Clock as $ccwsP$Clock, ShieldAlert as $ccwsP$ShieldAlert, LogOut as $ccwsP$LogOut, Crown as $ccwsP$Crown, Plus as $ccwsP$Plus, Loader2 as $ccwsP$Loader2, Activity as $ccwsP$Activity, Globe as $ccwsP$Globe, MoreHorizontal as $ccwsP$MoreHorizontal, Lock as $ccwsP$Lock, ArrowRight as $ccwsP$ArrowRight, Edit2 as $ccwsP$Edit2, Settings as $ccwsP$Settings, Accessibility as $ccwsP$Accessibility, Trash2 as $ccwsP$Trash2, Users as $ccwsP$Users, CheckCircle as $ccwsP$CheckCircle, Ban as $ccwsP$Ban, Power as $ccwsP$Power, UserCog as $ccwsP$UserCog, ShieldCheck as $ccwsP$ShieldCheck, X as $ccwsP$X, Link as $ccwsP$Link1, AlertCircle as $ccwsP$AlertCircle, BarChart3 as $ccwsP$BarChart3, LayoutDashboard as $ccwsP$LayoutDashboard, User as $ccwsP$User, Menu as $ccwsP$Menu, Search as $ccwsP$Search, Languages as $ccwsP$Languages, Sun as $ccwsP$Sun, Moon as $ccwsP$Moon, ChevronDown as $ccwsP$ChevronDown, Facebook as $ccwsP$Facebook, Instagram as $ccwsP$Instagram, Chrome as $ccwsP$Chrome, Star as $ccwsP$Star, Video as $ccwsP$Video, ArrowRightCircle as $ccwsP$ArrowRightCircle, Share2 as $ccwsP$Share2, Code as $ccwsP$Code, Rocket as $ccwsP$Rocket, Timer as $ccwsP$Timer, Zap as $ccwsP$Zap, MousePointer2 as $ccwsP$MousePointer2, PieChart as $ccwsP$PieChart, ArrowUpRight as $ccwsP$ArrowUpRight, Smartphone as $ccwsP$Smartphone, FileText as $ccwsP$FileText, MapPin as $ccwsP$MapPin, Check as $ccwsP$Check, Copy as $ccwsP$Copy, ArrowDownRight as $ccwsP$ArrowDownRight, Server as $ccwsP$Server, ChevronLeft as $ccwsP$ChevronLeft, ChevronRight as $ccwsP$ChevronRight, Layout as $ccwsP$Layout, Calendar as $ccwsP$Calendar, Mail as $ccwsP$Mail, CheckCircle2 as $ccwsP$CheckCircle2, Save as $ccwsP$Save, AlignLeft as $ccwsP$AlignLeft, AlignCenter as $ccwsP$AlignCenter, AlignRight as $ccwsP$AlignRight, EyeOff as $ccwsP$EyeOff, Eye as $ccwsP$Eye, RotateCcw as $ccwsP$RotateCcw, Type as $ccwsP$Type, RefreshCw as $ccwsP$RefreshCw, Contrast as $ccwsP$Contrast, Palette as $ccwsP$Palette, Maximize2 as $ccwsP$Maximize2, Pause as $ccwsP$Pause, ImageOff as $ccwsP$ImageOff} from "lucide-react";
import {doc as $ccwsP$doc, getDoc as $ccwsP$getDoc, query as $ccwsP$query, collection as $ccwsP$collection, orderBy as $ccwsP$orderBy, where as $ccwsP$where, getDocs as $ccwsP$getDocs, updateDoc as $ccwsP$updateDoc, addDoc as $ccwsP$addDoc, deleteDoc as $ccwsP$deleteDoc, limit as $ccwsP$limit, getFirestore as $ccwsP$getFirestore, setDoc as $ccwsP$setDoc} from "firebase/firestore";
import {initializeApp as $ccwsP$initializeApp} from "firebase/app";
import {getAnalytics as $ccwsP$getAnalytics} from "firebase/analytics";
import {getAuth as $ccwsP$getAuth, onAuthStateChanged as $ccwsP$onAuthStateChanged, signOut as $ccwsP$signOut, setPersistence as $ccwsP$setPersistence, browserLocalPersistence as $ccwsP$browserLocalPersistence, browserSessionPersistence as $ccwsP$browserSessionPersistence, signInWithEmailAndPassword as $ccwsP$signInWithEmailAndPassword, createUserWithEmailAndPassword as $ccwsP$createUserWithEmailAndPassword, updateProfile as $ccwsP$updateProfile} from "firebase/auth";
import {ResponsiveContainer as $ccwsP$ResponsiveContainer, BarChart as $ccwsP$BarChart, CartesianGrid as $ccwsP$CartesianGrid, XAxis as $ccwsP$XAxis, YAxis as $ccwsP$YAxis, Tooltip as $ccwsP$Tooltip, Bar as $ccwsP$Bar, Cell as $ccwsP$Cell, RadarChart as $ccwsP$RadarChart, PolarGrid as $ccwsP$PolarGrid, PolarAngleAxis as $ccwsP$PolarAngleAxis, PolarRadiusAxis as $ccwsP$PolarRadiusAxis, Radar as $ccwsP$Radar, LabelList as $ccwsP$LabelList} from "recharts";















const $09b8c58f557d578f$var$firebaseConfig = {
    apiKey: "AIzaSyDzpNA_BkCPC1C6_bV9PwSqBSTEoPyo9XE",
    authDomain: "website-tracking-w-ai.firebaseapp.com",
    projectId: "website-tracking-w-ai",
    storageBucket: "website-tracking-w-ai.firebasestorage.app",
    messagingSenderId: "842709652430",
    appId: "1:842709652430:web:f002a3fecb01f663e5119f",
    measurementId: "G-C41E4XJ8YR"
};
// Initialize Firebase
const $09b8c58f557d578f$var$app = (0, $ccwsP$initializeApp)($09b8c58f557d578f$var$firebaseConfig);
const $09b8c58f557d578f$export$f932f06c7eb6abeb = (0, $ccwsP$getFirestore)($09b8c58f557d578f$var$app);
const $09b8c58f557d578f$export$73693bad9f5880b0 = (0, $ccwsP$getAuth)($09b8c58f557d578f$var$app);
const $09b8c58f557d578f$export$71a493436f9bccb6 = typeof window !== 'undefined' ? (0, $ccwsP$getAnalytics)($09b8c58f557d578f$var$app) : null;



const $2abee34d7f7177c9$var$DOMAINS_COL = 'domains';
const $2abee34d7f7177c9$var$EVENTS_COL = 'events';
const $2abee34d7f7177c9$export$c33a4269214e2ec4 = async (uid)=>{
    try {
        const userRef = (0, $ccwsP$doc)((0, $09b8c58f557d578f$export$f932f06c7eb6abeb), 'users', uid);
        const snap = await (0, $ccwsP$getDoc)(userRef);
        return snap.exists() ? snap.data().role : 'user';
    } catch (e) {
        return 'user';
    }
};
const $2abee34d7f7177c9$export$fc2f5f9654959bf = async ()=>{
    const user = (0, $09b8c58f557d578f$export$73693bad9f5880b0).currentUser;
    if (!user) return [];
    const role = await $2abee34d7f7177c9$export$c33a4269214e2ec4(user.uid);
    let q;
    if (role === 'admin') q = (0, $ccwsP$query)((0, $ccwsP$collection)((0, $09b8c58f557d578f$export$f932f06c7eb6abeb), $2abee34d7f7177c9$var$DOMAINS_COL), (0, $ccwsP$orderBy)("createdAt", "desc"));
    else q = (0, $ccwsP$query)((0, $ccwsP$collection)((0, $09b8c58f557d578f$export$f932f06c7eb6abeb), $2abee34d7f7177c9$var$DOMAINS_COL), (0, $ccwsP$where)("userId", "==", user.uid));
    const querySnapshot = await (0, $ccwsP$getDocs)(q);
    return querySnapshot.docs.map((doc)=>({
            id: doc.id,
            ...doc.data()
        }));
};
const $2abee34d7f7177c9$export$69093b9c569a5b5b = async ()=>{
    const user = (0, $09b8c58f557d578f$export$73693bad9f5880b0).currentUser;
    if (!user) return [];
    const role = await $2abee34d7f7177c9$export$c33a4269214e2ec4(user.uid);
    if (role !== 'admin') return [];
    const querySnapshot = await (0, $ccwsP$getDocs)((0, $ccwsP$collection)((0, $09b8c58f557d578f$export$f932f06c7eb6abeb), 'users'));
    return querySnapshot.docs.map((doc)=>({
            uid: doc.id,
            ...doc.data()
        }));
};
const $2abee34d7f7177c9$export$9b558452d9a18079 = async (targetUid, newRole)=>{
    const userRef = (0, $ccwsP$doc)((0, $09b8c58f557d578f$export$f932f06c7eb6abeb), 'users', targetUid);
    await (0, $ccwsP$updateDoc)(userRef, {
        role: newRole
    });
};
const $2abee34d7f7177c9$export$90d21973648e565c = async (targetUid, isActive)=>{
    const userRef = (0, $ccwsP$doc)((0, $09b8c58f557d578f$export$f932f06c7eb6abeb), 'users', targetUid);
    await (0, $ccwsP$updateDoc)(userRef, {
        isActive: isActive
    });
};
const $2abee34d7f7177c9$export$fd92380aea824620 = async (domain)=>{
    const user = (0, $09b8c58f557d578f$export$73693bad9f5880b0).currentUser;
    if (!user) throw new Error("Must be logged in to save domain");
    const payload = {
        ...domain,
        userId: user.uid,
        userEmail: user.email
    };
    const docRef = await (0, $ccwsP$addDoc)((0, $ccwsP$collection)((0, $09b8c58f557d578f$export$f932f06c7eb6abeb), $2abee34d7f7177c9$var$DOMAINS_COL), payload);
    return {
        id: docRef.id,
        ...payload
    };
};
const $2abee34d7f7177c9$export$34f4c9b2cab9611c = async (id)=>{
    const docRef = (0, $ccwsP$doc)((0, $09b8c58f557d578f$export$f932f06c7eb6abeb), $2abee34d7f7177c9$var$DOMAINS_COL, id);
    const docSnap = await (0, $ccwsP$getDoc)(docRef);
    if (docSnap.exists()) return {
        id: docSnap.id,
        ...docSnap.data()
    };
    else return null;
};
const $2abee34d7f7177c9$export$923dbedb351986f7 = async (id)=>{
    await (0, $ccwsP$deleteDoc)((0, $ccwsP$doc)((0, $09b8c58f557d578f$export$f932f06c7eb6abeb), $2abee34d7f7177c9$var$DOMAINS_COL, id));
};
const $2abee34d7f7177c9$export$df2f3930b81062be = async (id, updates)=>{
    const docRef = (0, $ccwsP$doc)((0, $09b8c58f557d578f$export$f932f06c7eb6abeb), $2abee34d7f7177c9$var$DOMAINS_COL, id);
    await (0, $ccwsP$updateDoc)(docRef, updates);
};
const $2abee34d7f7177c9$export$3f41ece7d7128238 = async (domainId)=>{
    let q;
    if (domainId) q = (0, $ccwsP$query)((0, $ccwsP$collection)((0, $09b8c58f557d578f$export$f932f06c7eb6abeb), $2abee34d7f7177c9$var$EVENTS_COL), (0, $ccwsP$where)("domainId", "==", domainId), (0, $ccwsP$orderBy)("timestamp", "desc"), (0, $ccwsP$limit)(10000) // Increased limit to 10k for better data history
    );
    else q = (0, $ccwsP$query)((0, $ccwsP$collection)((0, $09b8c58f557d578f$export$f932f06c7eb6abeb), $2abee34d7f7177c9$var$EVENTS_COL), (0, $ccwsP$orderBy)("timestamp", "desc"), (0, $ccwsP$limit)(10000));
    const querySnapshot = await (0, $ccwsP$getDocs)(q);
    return querySnapshot.docs.map((doc)=>({
            id: doc.id,
            ...doc.data()
        }));
};
const $2abee34d7f7177c9$export$ebd8c0728c778fa2 = async (domainId, e, source)=>{
    const data = {
        domainId: domainId,
        source: source || 'direct',
        path: window.location.pathname,
        x: e.clientX / window.innerWidth * 100,
        y: e.clientY / window.innerHeight * 100,
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        timestamp: Date.now(),
        referrer: document.referrer,
        language: navigator.language
    };
    try {
        const response = await fetch('/api/track', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        if (!response.ok) console.warn('Tracking failed:', response.status);
    } catch (err) {
        console.debug('Tracking network error suppressed');
    }
};








const $72ad5ad77b58d1fe$var$translations = {
    en: {
        // Sidebar & Nav
        dashboards: "Dashboards",
        overview: "Overview",
        projectMenu: "Project Menu",
        analytics: "Analytics",
        shareReport: "Share Report",
        linkBuilder: "Link Builder",
        installCode: "Install Code",
        searchPlaceholder: "Search projects...",
        gdprSettings: "GDPR Settings",
        accessibility: "Accessibility",
        // Dashboard Page
        dashboardTitle: "Dashboards",
        dashboardSubtitle: "Overview of all your tracked properties",
        addNewProject: "Add New Project",
        noProjects: "No active projects",
        startTracking: "Start tracking your first website to see real-time insights and heatmaps.",
        createFirstProject: "Create first project",
        liveTracking: "Live Tracking",
        viewReport: "View Report",
        newProjectModal: "New Project",
        startTrackingModal: "Start tracking a new domain",
        websiteName: "Website Name",
        domainUrl: "Domain URL",
        cancel: "Cancel",
        createProject: "Create Project",
        // Report Page - Headers
        welcomeBack: "Welcome Back!",
        welcomeMessage: "Here's your website analytics for",
        youHave: "You Have Total Of",
        newVisitsToday: "new visits",
        quickView: "Quick View",
        // Stats Cards
        statUsers: "Users",
        statSessions: "Sessions",
        statDuration: "Avg. Duration",
        statBounceRate: "Bounce Rate",
        thisMonth: "this month",
        // Charts Titles
        clicksTracking: "Clicks Tracking",
        trafficOverview: "Traffic overview",
        pageViews: "Page Views",
        trending: "Trending",
        whereCustomersFrom: "Where Customers From",
        topSources: "Top sources",
        timeTracking: "Time Tracking",
        peakActivity: "Peak Activity",
        userByDevice: "User By Device",
        deviceDist: "Device distribution",
        topPagesMinute: "Top Browsing Pages Per Minute",
        visitsByCity: "Visits By City",
        geoBreakdown: "Geographic breakdown",
        // Table & Lists
        page: "Page",
        views: "Views",
        bounceRate: "Bounce Rate",
        noPageViews: "No page views recorded yet.",
        noLocationData: "No location data for this period.",
        // Time Filters
        today: "Today",
        week: "This Week",
        month: "This Month",
        year: "This Year",
        custom: "Custom Range",
        from: "From",
        to: "To",
        // Misc
        loading: "Loading...",
        copied: "Copied",
        copyCode: "Copy Code",
        verify: "Verify Installation",
        troubleshoot: "Troubleshoot",
        setupGuide: "Setup Guide for",
        excludeBots: "Exclude Bot Traffic",
        botTrafficDesc: "Hide traffic from known data centers (Omaha, NE & The Dalles, OR)"
    },
    vi: {
        // Sidebar & Nav
        dashboards: "B\u1EA3ng \u0111i\u1EC1u khi\u1EC3n",
        overview: "T\u1ED5ng quan",
        projectMenu: "Menu D\u1EF1 \xc1n",
        analytics: "Ph\xe2n t\xedch",
        shareReport: "Chia s\u1EBB b\xe1o c\xe1o",
        linkBuilder: "T\u1EA1o li\xean k\u1EBFt",
        installCode: "C\xe0i \u0111\u1EB7t m\xe3",
        searchPlaceholder: "T\xecm d\u1EF1 \xe1n...",
        gdprSettings: "C\xe0i \u0111\u1EB7t GDPR",
        accessibility: "Ph\u1EE5 tr\u1EE3 (Accessibility)",
        // Dashboard Page
        dashboardTitle: "B\u1EA3ng \u0111i\u1EC1u khi\u1EC3n",
        dashboardSubtitle: "T\u1ED5ng quan v\u1EC1 c\xe1c t\xe0i s\u1EA3n \u0111\u01B0\u1EE3c theo d\xf5i",
        addNewProject: "Th\xeam d\u1EF1 \xe1n m\u1EDBi",
        noProjects: "Kh\xf4ng c\xf3 d\u1EF1 \xe1n ho\u1EA1t \u0111\u1ED9ng",
        startTracking: "B\u1EAFt \u0111\u1EA7u theo d\xf5i trang web \u0111\u1EA7u ti\xean c\u1EE7a b\u1EA1n \u0111\u1EC3 xem th\xf4ng tin chi ti\u1EBFt.",
        createFirstProject: "T\u1EA1o d\u1EF1 \xe1n \u0111\u1EA7u ti\xean",
        liveTracking: "\u0110ang theo d\xf5i",
        viewReport: "Xem b\xe1o c\xe1o",
        newProjectModal: "D\u1EF1 \xc1n M\u1EDBi",
        startTrackingModal: "B\u1EAFt \u0111\u1EA7u theo d\xf5i t\xean mi\u1EC1n m\u1EDBi",
        websiteName: "T\xean trang web",
        domainUrl: "URL t\xean mi\u1EC1n",
        cancel: "H\u1EE7y",
        createProject: "T\u1EA1o D\u1EF1 \xc1n",
        // Report Page - Headers
        welcomeBack: "Ch\xe0o m\u1EEBng tr\u1EDF l\u1EA1i!",
        welcomeMessage: "\u0110\xe2y l\xe0 ph\xe2n t\xedch trang web cho",
        youHave: "B\u1EA1n c\xf3 t\u1ED5ng c\u1ED9ng",
        newVisitsToday: "l\u01B0\u1EE3t truy c\u1EADp m\u1EDBi",
        quickView: "Xem nhanh",
        // Stats Cards
        statUsers: "Ng\u01B0\u1EDDi d\xf9ng",
        statSessions: "Phi\xean truy c\u1EADp",
        statDuration: "T.g trung b\xecnh",
        statBounceRate: "T\u1EF7 l\u1EC7 tho\xe1t",
        thisMonth: "th\xe1ng n\xe0y",
        // Charts Titles
        clicksTracking: "Theo d\xf5i l\u01B0\u1EE3t nh\u1EA5p",
        trafficOverview: "T\u1ED5ng quan l\u01B0u l\u01B0\u1EE3ng",
        pageViews: "L\u01B0\u1EE3t xem trang",
        trending: "Xu h\u01B0\u1EDBng",
        whereCustomersFrom: "Ngu\u1ED3n kh\xe1ch h\xe0ng",
        topSources: "Ngu\u1ED3n h\xe0ng \u0111\u1EA7u",
        timeTracking: "Theo d\xf5i th\u1EDDi gian",
        peakActivity: "Ho\u1EA1t \u0111\u1ED9ng cao \u0111i\u1EC3m",
        userByDevice: "Thi\u1EBFt b\u1ECB ng\u01B0\u1EDDi d\xf9ng",
        deviceDist: "Ph\xe2n b\u1ED1 thi\u1EBFt b\u1ECB",
        topPagesMinute: "C\xe1c trang h\xe0ng \u0111\u1EA7u m\u1ED7i ph\xfat",
        visitsByCity: "Truy c\u1EADp theo th\xe0nh ph\u1ED1",
        geoBreakdown: "Ph\xe2n b\u1ED1 \u0111\u1ECBa l\xfd",
        // Table & Lists
        page: "Trang",
        views: "L\u01B0\u1EE3t xem",
        bounceRate: "T\u1EF7 l\u1EC7 tho\xe1t",
        noPageViews: "Ch\u01B0a c\xf3 l\u01B0\u1EE3t xem trang n\xe0o \u0111\u01B0\u1EE3c ghi nh\u1EADn.",
        noLocationData: "Kh\xf4ng c\xf3 d\u1EEF li\u1EC7u v\u1ECB tr\xed cho giai \u0111o\u1EA1n n\xe0y.",
        // Time Filters
        today: "H\xf4m nay",
        week: "Tu\u1EA7n n\xe0y",
        month: "Th\xe1ng n\xe0y",
        year: "N\u0103m nay",
        custom: "T\xf9y ch\u1EC9nh",
        from: "T\u1EEB",
        to: "\u0110\u1EBFn",
        // Misc
        loading: "\u0110ang t\u1EA3i...",
        copied: "\u0110\xe3 sao ch\xe9p",
        copyCode: "Sao ch\xe9p m\xe3",
        verify: "X\xe1c minh c\xe0i \u0111\u1EB7t",
        troubleshoot: "Kh\u1EAFc ph\u1EE5c s\u1EF1 c\u1ED1",
        setupGuide: "H\u01B0\u1EDBng d\u1EABn c\xe0i \u0111\u1EB7t cho",
        excludeBots: "Lo\u1EA1i b\u1ECF truy c\u1EADp \u1EA3o",
        botTrafficDesc: "\u1EA8n l\u01B0u l\u01B0\u1EE3ng t\u1EEB c\xe1c trung t\xe2m d\u1EEF li\u1EC7u (Omaha, NE & The Dalles, OR)"
    }
};
const $72ad5ad77b58d1fe$var$LanguageContext = /*#__PURE__*/ (0, $ccwsP$createContext)(undefined);
const $72ad5ad77b58d1fe$export$195746d839abd8b5 = ({ children: children })=>{
    const [language, setLanguage] = (0, $ccwsP$useState)(()=>{
        try {
            const stored = localStorage.getItem('app_language');
            return stored === 'en' || stored === 'vi' ? stored : 'en';
        } catch (e) {
            return 'en';
        }
    });
    (0, $ccwsP$useEffect)(()=>{
        localStorage.setItem('app_language', language);
    }, [
        language
    ]);
    const toggleLanguage = ()=>{
        setLanguage((prev)=>prev === 'en' ? 'vi' : 'en');
    };
    const value = {
        language: language,
        toggleLanguage: toggleLanguage,
        t: $72ad5ad77b58d1fe$var$translations[language]
    };
    return /*#__PURE__*/ (0, $ccwsP$jsx)($72ad5ad77b58d1fe$var$LanguageContext.Provider, {
        value: value,
        children: children
    });
};
const $72ad5ad77b58d1fe$export$c1fd9f444a3dc711 = ()=>{
    const context = (0, $ccwsP$useContext)($72ad5ad77b58d1fe$var$LanguageContext);
    if (context === undefined) throw new Error('useLanguage must be used within a LanguageProvider');
    return context;
};







const $20acffabdd663b48$var$AuthContext = /*#__PURE__*/ (0, $ccwsP$createContext)(undefined);
const $20acffabdd663b48$export$87091915187a1a85 = ({ children: children })=>{
    const [user, setUser] = (0, $ccwsP$useState)(null);
    const [role, setRole] = (0, $ccwsP$useState)('user');
    const [isActive, setIsActive] = (0, $ccwsP$useState)(false);
    const [loading, setLoading] = (0, $ccwsP$useState)(true);
    (0, $ccwsP$useEffect)(()=>{
        const unsubscribe = (0, $ccwsP$onAuthStateChanged)((0, $09b8c58f557d578f$export$73693bad9f5880b0), async (firebaseUser)=>{
            if (firebaseUser) {
                const userRef = (0, $ccwsP$doc)((0, $09b8c58f557d578f$export$f932f06c7eb6abeb), 'users', firebaseUser.uid);
                const userSnap = await (0, $ccwsP$getDoc)(userRef);
                let currentRole = 'user';
                let currentStatus = false;
                // Special Bootstrap: Force mbui41@gmail.com to be Admin and Active
                const isSuperAdmin = firebaseUser.email === 'mbui41@gmail.com';
                if (!userSnap.exists()) {
                    const newUser = {
                        email: firebaseUser.email,
                        createdAt: Date.now(),
                        lastLogin: Date.now(),
                        role: isSuperAdmin ? 'admin' : 'user',
                        isActive: isSuperAdmin ? true : false // New users are inactive by default
                    };
                    await (0, $ccwsP$setDoc)(userRef, newUser);
                    currentRole = newUser.role;
                    currentStatus = newUser.isActive;
                } else {
                    const data = userSnap.data();
                    currentRole = data.role;
                    currentStatus = data.isActive ?? false;
                    // If they are the super admin email but don't have the role or active status, update it
                    if (isSuperAdmin && (currentRole !== 'admin' || !currentStatus)) {
                        await (0, $ccwsP$updateDoc)(userRef, {
                            role: 'admin',
                            isActive: true
                        });
                        currentRole = 'admin';
                        currentStatus = true;
                    }
                    await (0, $ccwsP$setDoc)(userRef, {
                        lastLogin: Date.now()
                    }, {
                        merge: true
                    });
                }
                setRole(currentRole);
                setIsActive(currentStatus);
            } else {
                setRole('user');
                setIsActive(false);
            }
            setUser(firebaseUser);
            setLoading(false);
        });
        return ()=>unsubscribe();
    }, []);
    const logout = async ()=>{
        await (0, $ccwsP$signOut)((0, $09b8c58f557d578f$export$73693bad9f5880b0));
    };
    const setRememberMe = async (enabled)=>{
        await (0, $ccwsP$setPersistence)((0, $09b8c58f557d578f$export$73693bad9f5880b0), enabled ? (0, $ccwsP$browserLocalPersistence) : (0, $ccwsP$browserSessionPersistence));
    };
    return /*#__PURE__*/ (0, $ccwsP$jsx)($20acffabdd663b48$var$AuthContext.Provider, {
        value: {
            user: user,
            role: role,
            isActive: isActive,
            loading: loading,
            logout: logout,
            setRememberMe: setRememberMe
        },
        children: children
    });
};
const $20acffabdd663b48$export$1d39dc5b47e56ff0 = ()=>{
    const context = (0, $ccwsP$useContext)($20acffabdd663b48$var$AuthContext);
    if (context === undefined) throw new Error('useAuth must be used within an AuthProvider');
    return context;
};


const $e7fcd481df4de8d7$export$c84671f46d6a1ca = ({ children: children, sidebarContent: sidebarContent, hideNavigation: hideNavigation = false, onSearch: onSearch })=>{
    const [isSidebarOpen, setIsSidebarOpen] = (0, $ccwsP$useState)(false);
    const location = (0, $ccwsP$useLocation)();
    const navigate = (0, $ccwsP$useNavigate)();
    const { language: language, toggleLanguage: toggleLanguage, t: t } = (0, $72ad5ad77b58d1fe$export$c1fd9f444a3dc711)();
    const { user: user, logout: logout } = (0, $20acffabdd663b48$export$1d39dc5b47e56ff0)();
    const [isDarkMode, setIsDarkMode] = (0, $ccwsP$useState)(()=>{
        if (typeof window !== 'undefined') {
            const stored = localStorage.getItem('theme');
            if (stored) return stored === 'dark';
            return window.matchMedia('(prefers-color-scheme: dark)').matches;
        }
        return false;
    });
    (0, $ccwsP$useEffect)(()=>{
        if (isDarkMode) {
            document.documentElement.classList.add('dark');
            localStorage.setItem('theme', 'dark');
        } else {
            document.documentElement.classList.remove('dark');
            localStorage.setItem('theme', 'light');
        }
    }, [
        isDarkMode
    ]);
    const toggleTheme = ()=>setIsDarkMode(!isDarkMode);
    const handleLogout = async ()=>{
        try {
            await logout();
            navigate('/auth');
        } catch (err) {
            console.error("Logout failed:", err);
        }
    };
    return /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
        className: "min-h-screen bg-slate-50 dark:bg-slate-950 flex font-sans text-slate-900 dark:text-slate-100 transition-colors duration-200",
        children: [
            !hideNavigation && isSidebarOpen && /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                className: "fixed inset-0 bg-black/50 z-40 lg:hidden backdrop-blur-sm",
                onClick: ()=>setIsSidebarOpen(false)
            }),
            !hideNavigation && /*#__PURE__*/ (0, $ccwsP$jsxs)("aside", {
                className: `fixed lg:static inset-y-0 left-0 z-50 w-64 bg-white dark:bg-slate-900 border-r border-slate-200 dark:border-slate-800 transform transition-all duration-200 ease-in-out ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`,
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                        className: "h-20 flex items-center px-8 border-b border-slate-100 dark:border-slate-800",
                        children: /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $ccwsP$Link), {
                            to: "/",
                            className: "flex items-center gap-2 text-2xl font-bold text-indigo-600 dark:text-indigo-400 tracking-tight",
                            children: [
                                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                    className: "w-8 h-8 bg-indigo-600 text-white rounded-lg flex items-center justify-center text-lg shadow-indigo-200 dark:shadow-none shadow-md",
                                    children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$BarChart3), {
                                        size: 20,
                                        strokeWidth: 3
                                    })
                                }),
                                "MyETRAFFIC"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: "p-6 space-y-8 overflow-y-auto h-[calc(100vh-10rem)]",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                        className: "text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-4 px-2",
                                        children: t.dashboards
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("nav", {
                                        className: "space-y-1",
                                        children: /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $ccwsP$Link), {
                                            to: "/",
                                            className: `flex items-center gap-3 px-4 py-3 rounded-xl transition-colors ${location.pathname === '/' ? 'bg-indigo-50 dark:bg-indigo-900/20 text-indigo-600 dark:text-indigo-400 font-semibold' : 'text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 hover:text-slate-900 dark:hover:text-slate-200'}`,
                                            onClick: ()=>setIsSidebarOpen(false),
                                            children: [
                                                /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$LayoutDashboard), {
                                                    size: 20
                                                }),
                                                t.overview
                                            ]
                                        })
                                    })
                                ]
                            }),
                            sidebarContent && /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                        className: "text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-4 px-2",
                                        children: t.projectMenu
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                        className: "space-y-1",
                                        onClick: ()=>setIsSidebarOpen(false),
                                        children: sidebarContent
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                        className: "absolute bottom-0 left-0 right-0 p-4 border-t border-slate-100 dark:border-slate-800 bg-white dark:bg-slate-900",
                        children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                            className: "flex items-center justify-between gap-3 p-3 bg-slate-50 dark:bg-slate-800 rounded-2xl",
                            children: [
                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                    className: "flex items-center gap-3 min-w-0",
                                    children: [
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                            className: "w-9 h-9 rounded-xl bg-indigo-100 dark:bg-indigo-900/40 flex items-center justify-center text-indigo-600 dark:text-indigo-400 shrink-0",
                                            children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$User), {
                                                size: 18
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                            className: "min-w-0",
                                            children: [
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                                    className: "text-xs font-bold text-slate-900 dark:text-white truncate",
                                                    children: user?.displayName || 'User'
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                                    className: "text-[10px] text-slate-500 truncate",
                                                    children: user?.email
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                    onClick: handleLogout,
                                    className: "p-2 text-slate-400 hover:text-rose-500 transition-colors",
                                    title: "Log Out",
                                    children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$LogOut), {
                                        size: 18
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ccwsP$jsxs)("main", {
                className: "flex-1 flex flex-col min-w-0 overflow-hidden",
                children: [
                    !hideNavigation && /*#__PURE__*/ (0, $ccwsP$jsxs)("header", {
                        className: "h-16 md:h-20 bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800 flex items-center justify-between px-4 sm:px-8 sticky top-0 z-30 transition-colors",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: "flex items-center gap-4 w-full",
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                        onClick: ()=>setIsSidebarOpen(true),
                                        className: "lg:hidden p-2 text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg shrink-0",
                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Menu), {
                                            size: 24
                                        })
                                    }),
                                    onSearch && /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "hidden md:flex items-center gap-3 bg-slate-50 dark:bg-slate-800 px-4 py-2.5 rounded-2xl w-64 focus-within:ring-2 focus-within:ring-indigo-100 dark:focus-within:ring-indigo-900 transition-all",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Search), {
                                                size: 18,
                                                className: "text-slate-400 dark:text-slate-500"
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("input", {
                                                type: "text",
                                                placeholder: t.searchPlaceholder,
                                                onChange: (e)=>onSearch(e.target.value),
                                                className: "bg-transparent border-none focus:ring-0 text-sm w-full outline-none text-slate-700 dark:text-slate-200 placeholder:text-slate-400"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: "flex items-center gap-2 md:gap-3 shrink-0",
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                                        onClick: toggleLanguage,
                                        className: "flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-xl transition-colors border border-slate-200 dark:border-slate-700",
                                        title: "Switch Language",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Languages), {
                                                size: 16,
                                                className: "text-indigo-500"
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                children: language === 'en' ? 'EN' : 'VN'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                        onClick: toggleTheme,
                                        className: "p-2 text-slate-400 hover:text-indigo-600 dark:hover:text-indigo-400 hover:bg-indigo-50 dark:hover:bg-indigo-900/30 rounded-xl transition-colors",
                                        title: isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode",
                                        children: isDarkMode ? /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Sun), {
                                            size: 20
                                        }) : /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Moon), {
                                            size: 20
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: "flex-1 overflow-y-auto overflow-x-hidden p-4 sm:p-8 lg:p-12 scrollbar-thin scrollbar-thumb-slate-200 dark:scrollbar-thumb-slate-700 flex flex-col",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                className: "flex-1",
                                children: children
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsx)("footer", {
                                className: "mt-12 md:mt-16 pt-8 text-center",
                                children: /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                    className: "text-[10px] md:text-xs font-medium text-slate-400 dark:text-slate-600",
                                    children: "Designed By MyESALON"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




const $f574884c61cfc7b9$var$REQUIRED_PASSWORD = '2360';
const $f574884c61cfc7b9$var$Dashboard = ()=>{
    const { user: user, role: role } = (0, $20acffabdd663b48$export$1d39dc5b47e56ff0)();
    const isAdmin = role === 'admin';
    const [domains, setDomains] = (0, $ccwsP$useState)([]);
    const [allUsers, setAllUsers] = (0, $ccwsP$useState)([]);
    const [isLoading, setIsLoading] = (0, $ccwsP$useState)(true);
    const [activeTab, setActiveTab] = (0, $ccwsP$useState)('projects');
    // Create Modal State
    const [isModalOpen, setIsModalOpen] = (0, $ccwsP$useState)(false);
    const [newDomainName, setNewDomainName] = (0, $ccwsP$useState)('');
    const [newDomainUrl, setNewDomainUrl] = (0, $ccwsP$useState)('');
    const [enableGdpr, setEnableGdpr] = (0, $ccwsP$useState)(false);
    // Edit State
    const [activeMenuId, setActiveMenuId] = (0, $ccwsP$useState)(null);
    const [isEditModalOpen, setIsEditModalOpen] = (0, $ccwsP$useState)(false);
    const [editingDomain, setEditingDomain] = (0, $ccwsP$useState)(null);
    const [editName, setEditName] = (0, $ccwsP$useState)('');
    const [editUrl, setEditUrl] = (0, $ccwsP$useState)('');
    // Password Modal State
    const [isPasswordModalOpen, setIsPasswordModalOpen] = (0, $ccwsP$useState)(false);
    const [passwordInput, setPasswordInput] = (0, $ccwsP$useState)('');
    const [passwordError, setPasswordError] = (0, $ccwsP$useState)('');
    const [pendingAction, setPendingAction] = (0, $ccwsP$useState)(null);
    const [isSaving, setIsSaving] = (0, $ccwsP$useState)(false);
    const [error, setError] = (0, $ccwsP$useState)(null);
    const [searchTerm, setSearchTerm] = (0, $ccwsP$useState)('');
    const { t: t } = (0, $72ad5ad77b58d1fe$export$c1fd9f444a3dc711)();
    const loadData = async ()=>{
        setIsLoading(true);
        setError(null);
        try {
            const domainsData = await (0, $2abee34d7f7177c9$export$fc2f5f9654959bf)();
            setDomains(domainsData);
            if (isAdmin) {
                const usersData = await (0, $2abee34d7f7177c9$export$69093b9c569a5b5b)();
                setAllUsers(usersData);
            }
        } catch (err) {
            console.error("Failed to load data:", err);
            setError(err.message || "Failed to connect to the database.");
        } finally{
            setIsLoading(false);
        }
    };
    (0, $ccwsP$useEffect)(()=>{
        loadData();
    }, [
        role
    ]);
    const toggleMenu = (e, id)=>{
        e.preventDefault();
        e.stopPropagation();
        setActiveMenuId(activeMenuId === id ? null : id);
    };
    const handleAddDomain = async (e)=>{
        e.preventDefault();
        if (!newDomainName || !newDomainUrl) return;
        setIsSaving(true);
        let formattedUrl = newDomainUrl.trim();
        if (!/^https?:\/\//i.test(formattedUrl)) formattedUrl = `https://${formattedUrl}`;
        const newDomain = {
            name: newDomainName,
            url: formattedUrl,
            createdAt: Date.now(),
            gdprConsentEnabled: enableGdpr,
            accessibilityEnabled: false,
            accessibilitySettings: {
                enabled: false,
                buttonPosition: 'bottom-left',
                primaryColor: '#4f46e5',
                buttonIcon: 'universal'
            }
        };
        try {
            await (0, $2abee34d7f7177c9$export$fd92380aea824620)(newDomain);
            await loadData();
            setIsModalOpen(false);
            setNewDomainName('');
            setNewDomainUrl('');
            setEnableGdpr(false);
        } catch (err) {
            alert("Error creating domain: " + err.message);
        } finally{
            setIsSaving(false);
        }
    };
    const initiateEdit = (e, domain)=>{
        e.preventDefault();
        e.stopPropagation();
        setActiveMenuId(null);
        setEditingDomain(domain);
        setEditName(domain.name);
        setEditUrl(domain.url);
        setIsEditModalOpen(true);
    };
    const initiateDelete = (e, domainId)=>{
        e.preventDefault();
        e.stopPropagation();
        setActiveMenuId(null);
        setPendingAction({
            type: 'delete',
            targetId: domainId
        });
        setPasswordInput('');
        setPasswordError('');
        setIsPasswordModalOpen(true);
    };
    const confirmEdit = async (e)=>{
        e.preventDefault();
        if (!editingDomain) return;
        let formattedUrl = editUrl.trim();
        if (!/^https?:\/\//i.test(formattedUrl)) formattedUrl = `https://${formattedUrl}`;
        setIsEditModalOpen(false);
        setPendingAction({
            type: 'update',
            targetId: editingDomain.id,
            payload: {
                name: editName,
                url: formattedUrl
            }
        });
        setPasswordInput('');
        setPasswordError('');
        setIsPasswordModalOpen(true);
    };
    const handleUpdateRole = (targetUid, currentRole)=>{
        const nextRole = currentRole === 'admin' ? 'user' : 'admin';
        setPendingAction({
            type: 'role',
            targetId: targetUid,
            payload: {
                role: nextRole
            }
        });
        setPasswordInput('');
        setPasswordError('');
        setIsPasswordModalOpen(true);
    };
    const handleToggleStatus = (targetUid, currentStatus)=>{
        setPendingAction({
            type: 'status',
            targetId: targetUid,
            payload: {
                isActive: !currentStatus
            }
        });
        setPasswordInput('');
        setPasswordError('');
        setIsPasswordModalOpen(true);
    };
    const handlePasswordSubmit = async (e)=>{
        e.preventDefault();
        if (passwordInput !== $f574884c61cfc7b9$var$REQUIRED_PASSWORD) {
            setPasswordError("Incorrect password");
            return;
        }
        if (!pendingAction) return;
        setIsSaving(true);
        setIsPasswordModalOpen(false);
        try {
            if (pendingAction.type === 'delete') await (0, $2abee34d7f7177c9$export$923dbedb351986f7)(pendingAction.targetId);
            else if (pendingAction.type === 'update') await (0, $2abee34d7f7177c9$export$df2f3930b81062be)(pendingAction.targetId, pendingAction.payload);
            else if (pendingAction.type === 'role') await (0, $2abee34d7f7177c9$export$9b558452d9a18079)(pendingAction.targetId, pendingAction.payload.role);
            else if (pendingAction.type === 'status') await (0, $2abee34d7f7177c9$export$90d21973648e565c)(pendingAction.targetId, pendingAction.payload.isActive);
            await loadData();
        } catch (err) {
            alert("Operation failed: " + err.message);
        } finally{
            setIsSaving(false);
            setPendingAction(null);
            setEditingDomain(null);
        }
    };
    const filteredDomains = domains.filter((domain)=>domain.name.toLowerCase().includes(searchTerm.toLowerCase()) || domain.url.toLowerCase().includes(searchTerm.toLowerCase()));
    const filteredUsers = allUsers.filter((u)=>u.email.toLowerCase().includes(searchTerm.toLowerCase()));
    return /*#__PURE__*/ (0, $ccwsP$jsx)((0, $e7fcd481df4de8d7$export$c84671f46d6a1ca), {
        onSearch: setSearchTerm,
        children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
            className: "max-w-7xl mx-auto",
            onClick: ()=>setActiveMenuId(null),
            children: [
                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                    className: "flex flex-col md:flex-row md:items-center justify-between mb-8 md:mb-10 gap-6",
                    children: [
                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                            className: "min-w-0",
                            children: [
                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                    className: "flex items-center gap-2 flex-wrap",
                                    children: [
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("h1", {
                                            className: "text-2xl md:text-3xl font-bold text-slate-900 dark:text-white",
                                            children: isAdmin ? 'Administration' : t.dashboardTitle
                                        }),
                                        isAdmin && /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                            className: "bg-indigo-600 text-white text-[10px] font-bold px-2 py-0.5 rounded-full flex items-center gap-1 uppercase tracking-widest shadow-lg shadow-indigo-500/30",
                                            children: [
                                                /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Crown), {
                                                    size: 10
                                                }),
                                                " Super Admin"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                    className: "text-slate-500 dark:text-slate-400 mt-1 text-sm md:text-base",
                                    children: isAdmin ? 'Managing all properties and system users' : t.dashboardSubtitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                            className: "flex flex-col sm:flex-row gap-3",
                            children: [
                                isAdmin && /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                    className: "bg-slate-100 dark:bg-slate-800 p-1 rounded-xl flex w-full sm:w-auto",
                                    children: [
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                            onClick: ()=>setActiveTab('projects'),
                                            className: `flex-1 sm:flex-none px-4 py-2 rounded-lg text-sm font-bold transition-all ${activeTab === 'projects' ? 'bg-white dark:bg-slate-700 text-indigo-600 shadow-sm' : 'text-slate-500'}`,
                                            children: "Projects"
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                            onClick: ()=>setActiveTab('users'),
                                            className: `flex-1 sm:flex-none px-4 py-2 rounded-lg text-sm font-bold transition-all ${activeTab === 'users' ? 'bg-white dark:bg-slate-700 text-indigo-600 shadow-sm' : 'text-slate-500'}`,
                                            children: "Users"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                                    onClick: ()=>setIsModalOpen(true),
                                    className: "bg-indigo-600 hover:bg-indigo-700 text-white px-5 py-3 rounded-xl font-bold flex items-center justify-center gap-2 transition-all shadow-lg shadow-indigo-500/30 text-sm md:text-base",
                                    children: [
                                        /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Plus), {
                                            size: 20,
                                            strokeWidth: 3
                                        }),
                                        t.addNewProject
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                activeTab === 'projects' ? /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Fragment), {
                    children: isLoading ? /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                        className: "flex justify-center py-40",
                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Loader2), {
                            className: "animate-spin text-indigo-500",
                            size: 48
                        })
                    }) : filteredDomains.length === 0 ? /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: "text-center py-20 md:py-32 bg-white dark:bg-slate-900 rounded-[32px] border-2 border-dashed border-slate-200 dark:border-slate-800 p-6",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Activity), {
                                className: "text-slate-300 mx-auto mb-4 md:mb-6",
                                size: 40
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                className: "text-lg md:text-xl font-bold text-slate-900 dark:text-white",
                                children: t.noProjects
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                        className: "grid gap-6 sm:grid-cols-2 lg:grid-cols-3",
                        children: filteredDomains.map((domain)=>/*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: "relative group",
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $ccwsP$Link), {
                                        to: `/report/${domain.id}`,
                                        className: "block bg-white dark:bg-slate-900 p-6 md:p-8 rounded-[32px] border border-slate-100 dark:border-slate-800 hover:shadow-xl hover:-translate-y-1 transition-all h-full",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "flex justify-between items-start mb-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                        className: "p-3 bg-indigo-50 dark:bg-indigo-900/20 rounded-2xl text-indigo-600 dark:text-indigo-400 group-hover:bg-indigo-600 group-hover:text-white transition-all",
                                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Globe), {
                                                            size: 28
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                        className: "flex items-center gap-2 min-w-0",
                                                        children: [
                                                            isAdmin && /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                className: "text-[9px] font-bold text-slate-400 bg-slate-50 dark:bg-slate-800 px-2 py-1 rounded-md truncate max-w-[80px]",
                                                                children: domain.userEmail || 'System'
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                                                onClick: (e)=>toggleMenu(e, domain.id),
                                                                className: "p-2 text-slate-300 dark:text-slate-600 hover:text-indigo-500 dark:hover:text-indigo-400 hover:bg-slate-50 dark:hover:bg-slate-800 rounded-xl transition-all",
                                                                children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$MoreHorizontal), {
                                                                    size: 24
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "min-w-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                        className: "flex items-center gap-2 mb-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                                                className: "text-lg md:text-xl font-bold text-slate-900 dark:text-white truncate flex-1",
                                                                children: domain.name
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                className: "bg-emerald-100 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-400 p-1 rounded-md shrink-0",
                                                                children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Lock), {
                                                                    size: 14
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                                        className: "text-slate-400 text-xs md:text-sm truncate mb-6",
                                                        children: domain.url
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "flex items-center justify-between pt-6 border-t border-slate-50 dark:border-slate-800",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                        className: "text-xs font-medium text-emerald-600 flex items-center gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                className: "w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse"
                                                            }),
                                                            "Live"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                        className: "text-xs md:text-sm text-slate-400 group-hover:text-indigo-600 font-bold flex items-center gap-1 transition-colors",
                                                        children: [
                                                            t.viewReport,
                                                            " ",
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ArrowRight), {
                                                                className: "w-3.5 h-3.5 md:w-4 md:h-4"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    activeMenuId === domain.id && /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                        className: "absolute top-16 right-4 z-30 w-52 bg-white dark:bg-slate-900 rounded-2xl shadow-xl border border-slate-100 dark:border-slate-800 overflow-hidden animate-in fade-in zoom-in-95 duration-200 origin-top-right",
                                        children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                            className: "p-1.5",
                                            children: [
                                                /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                                                    onClick: (e)=>initiateEdit(e, domain),
                                                    className: "w-full text-left px-3 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-indigo-50 dark:hover:bg-indigo-900/30 hover:text-indigo-600 dark:hover:text-indigo-400 rounded-xl transition-colors flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Edit2), {
                                                            size: 16
                                                        }),
                                                        " Edit Details"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $ccwsP$Link), {
                                                    to: `/report/${domain.id}/gdpr-settings`,
                                                    onClick: (e)=>e.stopPropagation(),
                                                    className: "w-full text-left px-3 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-indigo-50 dark:hover:bg-indigo-900/30 hover:text-indigo-600 dark:hover:text-indigo-400 rounded-xl transition-colors flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Settings), {
                                                            size: 16
                                                        }),
                                                        " GDPR Settings"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $ccwsP$Link), {
                                                    to: `/report/${domain.id}/accessibility`,
                                                    onClick: (e)=>e.stopPropagation(),
                                                    className: "w-full text-left px-3 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-indigo-50 dark:hover:bg-indigo-900/30 hover:text-indigo-600 dark:hover:text-indigo-400 rounded-xl transition-colors flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Accessibility), {
                                                            size: 16
                                                        }),
                                                        " Accessibility"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                    className: "h-px bg-slate-50 dark:bg-slate-800 my-1 mx-2"
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                                                    onClick: (e)=>initiateDelete(e, domain.id),
                                                    className: "w-full text-left px-3 py-2.5 text-sm font-medium text-rose-600 dark:text-rose-400 hover:bg-rose-50 dark:hover:bg-rose-900/20 rounded-xl transition-colors flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Trash2), {
                                                            size: 16
                                                        }),
                                                        " Delete Project"
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }, domain.id))
                    })
                }) : /* User Management Tab */ /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                    className: "bg-white dark:bg-slate-900 rounded-[32px] border border-slate-100 dark:border-slate-800 overflow-x-auto shadow-sm",
                    children: /*#__PURE__*/ (0, $ccwsP$jsxs)("table", {
                        className: "w-full text-left min-w-[700px]",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsx)("thead", {
                                children: /*#__PURE__*/ (0, $ccwsP$jsxs)("tr", {
                                    className: "bg-slate-50 dark:bg-slate-800/50 text-slate-500 text-[10px] md:text-xs font-bold uppercase tracking-wider",
                                    children: [
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("th", {
                                            className: "px-6 md:px-8 py-4",
                                            children: "User Email"
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("th", {
                                            className: "px-6 md:px-8 py-4",
                                            children: "Role"
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("th", {
                                            className: "px-6 md:px-8 py-4",
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("th", {
                                            className: "px-6 md:px-8 py-4",
                                            children: "Last Login"
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("th", {
                                            className: "px-6 md:px-8 py-4 text-right",
                                            children: "Actions"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsx)("tbody", {
                                className: "divide-y divide-slate-100 dark:divide-slate-800",
                                children: filteredUsers.map((u)=>/*#__PURE__*/ (0, $ccwsP$jsxs)("tr", {
                                        className: "hover:bg-slate-50 dark:hover:bg-slate-800/30 transition-colors",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("td", {
                                                className: "px-6 md:px-8 py-5",
                                                children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                    className: "flex items-center gap-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                            className: "w-9 h-9 rounded-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-slate-500 shrink-0",
                                                            children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Users), {
                                                                size: 16
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                            className: "font-bold text-slate-900 dark:text-white truncate max-w-[150px] md:max-w-none text-sm md:text-base",
                                                            children: u.email
                                                        }),
                                                        u.email === 'mbui41@gmail.com' && /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Crown), {
                                                            size: 14,
                                                            className: "text-amber-500 shrink-0"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("td", {
                                                className: "px-6 md:px-8 py-5",
                                                children: /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                    className: `px-3 py-1 rounded-full text-[9px] md:text-[10px] font-bold uppercase tracking-widest ${u.role === 'admin' ? 'bg-indigo-100 text-indigo-600' : 'bg-slate-100 text-slate-500'}`,
                                                    children: u.role
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("td", {
                                                className: "px-6 md:px-8 py-5",
                                                children: /*#__PURE__*/ (0, $ccwsP$jsxs)("span", {
                                                    className: `flex items-center gap-1.5 text-[9px] md:text-[10px] font-bold uppercase tracking-widest ${u.isActive ? 'text-emerald-500' : 'text-rose-500'}`,
                                                    children: [
                                                        u.isActive ? /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$CheckCircle), {
                                                            size: 12
                                                        }) : /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Ban), {
                                                            size: 12
                                                        }),
                                                        u.isActive ? 'Active' : 'Inactive'
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("td", {
                                                className: "px-6 md:px-8 py-5 text-xs md:text-sm text-slate-400",
                                                children: u.lastLogin ? new Date(u.lastLogin).toLocaleDateString() : 'N/A'
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("td", {
                                                className: "px-6 md:px-8 py-5 text-right",
                                                children: u.email !== 'mbui41@gmail.com' && /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                    className: "flex justify-end gap-1 md:gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                                            onClick: ()=>handleToggleStatus(u.uid, u.isActive),
                                                            className: `p-2 transition-colors rounded-lg ${u.isActive ? 'text-slate-400 hover:text-rose-500 hover:bg-rose-50' : 'text-emerald-500 hover:bg-emerald-50'}`,
                                                            title: u.isActive ? 'Deactivate User' : 'Activate User',
                                                            children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Power), {
                                                                className: "w-4.5 h-4.5 md:w-5 md:h-5"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                                            onClick: ()=>handleUpdateRole(u.uid, u.role),
                                                            className: "p-2 text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 transition-colors rounded-lg",
                                                            title: "Toggle Admin/User Role",
                                                            children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$UserCog), {
                                                                className: "w-4.5 h-4.5 md:w-5 md:h-5"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, u.uid))
                            })
                        ]
                    })
                }),
                isModalOpen && /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                    className: "fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4",
                    children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: "bg-white dark:bg-slate-900 rounded-[32px] w-full max-w-md p-6 md:p-8 shadow-2xl border border-slate-100 dark:border-slate-800",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsx)("h2", {
                                className: "text-xl md:text-2xl font-bold mb-6 text-slate-900 dark:text-white",
                                children: t.newProjectModal
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("form", {
                                onSubmit: handleAddDomain,
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "space-y-5",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("label", {
                                                        className: "block text-xs md:text-sm font-bold text-slate-700 dark:text-slate-300 mb-2",
                                                        children: t.websiteName
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("input", {
                                                        type: "text",
                                                        required: true,
                                                        className: "w-full p-3 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none text-slate-900 dark:text-white transition-all text-sm md:text-base",
                                                        value: newDomainName,
                                                        onChange: (e)=>setNewDomainName(e.target.value),
                                                        placeholder: "My Portfolio"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("label", {
                                                        className: "block text-xs md:text-sm font-bold text-slate-700 dark:text-slate-300 mb-2",
                                                        children: t.domainUrl
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("input", {
                                                        type: "text",
                                                        required: true,
                                                        className: "w-full p-3 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none text-slate-900 dark:text-white transition-all text-sm md:text-base",
                                                        value: newDomainUrl,
                                                        onChange: (e)=>setNewDomainUrl(e.target.value),
                                                        placeholder: "mysite.com"
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("p", {
                                                        className: "mt-2 text-[10px] text-slate-400 flex items-center gap-1.5",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ShieldCheck), {
                                                                size: 12,
                                                                className: "text-emerald-500 shrink-0"
                                                            }),
                                                            "Domain-locked for security."
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "flex gap-3 mt-8",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setIsModalOpen(false),
                                                className: "flex-1 px-4 py-3 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 font-bold rounded-xl transition-colors border border-slate-200 dark:border-slate-700 text-sm md:text-base",
                                                children: t.cancel
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                                type: "submit",
                                                disabled: isSaving,
                                                className: "flex-1 px-4 py-3 bg-indigo-600 text-white font-bold rounded-xl transition-all shadow-lg shadow-indigo-500/20 text-sm md:text-base",
                                                children: isSaving ? /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Loader2), {
                                                    size: 20,
                                                    className: "animate-spin mx-auto"
                                                }) : t.createProject
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                isEditModalOpen && /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                    className: "fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4",
                    children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: "bg-white dark:bg-slate-900 rounded-[32px] w-full max-w-md p-6 md:p-8 shadow-2xl border border-slate-100 dark:border-slate-800",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: "flex justify-between items-center mb-6",
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("h2", {
                                        className: "text-xl md:text-2xl font-bold text-slate-900 dark:text-white",
                                        children: "Edit Project"
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                        onClick: ()=>setIsEditModalOpen(false),
                                        className: "text-slate-400 hover:text-slate-600",
                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$X), {
                                            size: 24
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("form", {
                                onSubmit: confirmEdit,
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "space-y-5",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("label", {
                                                        className: "block text-xs md:text-sm font-bold text-slate-700 dark:text-slate-300 mb-2",
                                                        children: "Project Name"
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("input", {
                                                        type: "text",
                                                        required: true,
                                                        className: "w-full p-3 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none text-slate-900 dark:text-white transition-all text-sm md:text-base",
                                                        value: editName,
                                                        onChange: (e)=>setEditName(e.target.value)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("label", {
                                                        className: "block text-xs md:text-sm font-bold text-slate-700 dark:text-slate-300 mb-2",
                                                        children: "Whitelisted Domain URL"
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                        className: "relative",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400",
                                                                children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Link1), {
                                                                    size: 16
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("input", {
                                                                type: "text",
                                                                required: true,
                                                                className: "w-full p-3 pl-10 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none text-slate-900 dark:text-white transition-all text-sm md:text-base",
                                                                value: editUrl,
                                                                onChange: (e)=>setEditUrl(e.target.value)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                        className: "mt-3 p-3 bg-amber-50 dark:bg-amber-900/10 border border-amber-100 dark:border-amber-900/20 rounded-xl",
                                                        children: /*#__PURE__*/ (0, $ccwsP$jsxs)("p", {
                                                            className: "text-[10px] text-amber-700 dark:text-amber-400 leading-relaxed font-medium flex items-start gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$AlertCircle), {
                                                                    size: 14,
                                                                    className: "shrink-0 mt-0.5"
                                                                }),
                                                                "Changing this URL updates the security whitelist. Traffic from the old domain will be blocked."
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "flex gap-3 mt-8",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setIsEditModalOpen(false),
                                                className: "flex-1 px-4 py-3 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 font-bold rounded-xl transition-colors border border-slate-200 dark:border-slate-700 text-sm md:text-base",
                                                children: "Cancel"
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                                type: "submit",
                                                className: "flex-1 px-4 py-3 bg-indigo-600 text-white font-bold rounded-xl transition-all shadow-lg shadow-indigo-500/20 text-sm md:text-base",
                                                children: "Update Details"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                isPasswordModalOpen && /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                    className: "fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4",
                    children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: "bg-white dark:bg-slate-900 rounded-[32px] w-full max-w-sm p-8 shadow-2xl border border-slate-100 dark:border-slate-800",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: "text-center mb-6",
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ShieldAlert), {
                                        className: "mx-auto mb-4 text-rose-500",
                                        size: 40
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("h2", {
                                        className: "text-xl font-bold text-slate-900 dark:text-white",
                                        children: "Admin Verification"
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                        className: "text-slate-500 text-sm mt-1",
                                        children: "This action requires the system master key."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("form", {
                                onSubmit: handlePasswordSubmit,
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("input", {
                                        type: "password",
                                        autoFocus: true,
                                        className: "w-full p-3 text-center text-2xl tracking-widest font-bold bg-slate-50 dark:bg-slate-800 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none transition-all dark:text-white",
                                        value: passwordInput,
                                        onChange: (e)=>setPasswordInput(e.target.value),
                                        placeholder: "\u2022\u2022\u2022\u2022"
                                    }),
                                    passwordError && /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                        className: "text-rose-500 text-xs text-center mt-2 font-bold",
                                        children: passwordError
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "flex gap-3 mt-6",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                                type: "button",
                                                onClick: ()=>{
                                                    setIsPasswordModalOpen(false);
                                                    setPendingAction(null);
                                                },
                                                className: "flex-1 py-3 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 font-bold rounded-xl text-slate-600 dark:text-slate-300 transition-colors border border-slate-200 dark:border-slate-700 text-sm",
                                                children: "Cancel"
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                                type: "submit",
                                                className: "flex-1 py-3 bg-slate-900 dark:bg-white text-white dark:text-slate-900 font-bold rounded-xl transition-all text-sm",
                                                children: "Confirm"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $f574884c61cfc7b9$export$2e2bcd8739ae039 = $f574884c61cfc7b9$var$Dashboard;















const $9f258ebe77ccfbd1$export$eccda88c066b9b81 = ({ term: term, children: children, side: side = 'top' })=>{
    const { language: language } = (0, $72ad5ad77b58d1fe$export$c1fd9f444a3dc711)();
    // Combined definitions and titles for lookup
    const glossary = {
        "Users": {
            title: {
                en: "Users",
                vi: "Ng\u01B0\u1EDDi d\xf9ng"
            },
            definition: {
                en: "The total number of unique visitors who have engaged with your website.",
                vi: "T\u1ED5ng s\u1ED1 kh\xe1ch truy c\u1EADp duy nh\u1EA5t \u0111\xe3 t\u01B0\u01A1ng t\xe1c v\u1EDBi trang web c\u1EE7a b\u1EA1n."
            }
        },
        "Sessions": {
            title: {
                en: "Sessions",
                vi: "Phi\xean truy c\u1EADp"
            },
            definition: {
                en: "A continuous period of user activity. A new session begins after 30 minutes of inactivity.",
                vi: "Kho\u1EA3ng th\u1EDDi gian ho\u1EA1t \u0111\u1ED9ng li\xean t\u1EE5c c\u1EE7a ng\u01B0\u1EDDi d\xf9ng. Phi\xean m\u1EDBi b\u1EAFt \u0111\u1EA7u sau 30 ph\xfat kh\xf4ng ho\u1EA1t \u0111\u1ED9ng."
            }
        },
        "Avg. Duration": {
            title: {
                en: "Avg. Session Duration",
                vi: "T.g phi\xean trung b\xecnh"
            },
            definition: {
                en: "The average amount of time users spend actively engaging with your website per session.",
                vi: "Th\u1EDDi gian trung b\xecnh ng\u01B0\u1EDDi d\xf9ng d\xe0nh \u0111\u1EC3 t\u01B0\u01A1ng t\xe1c t\xedch c\u1EF1c v\u1EDBi trang web c\u1EE7a b\u1EA1n trong m\u1ED7i phi\xean."
            }
        },
        "Avg. Session Duration": {
            title: {
                en: "Avg. Session Duration",
                vi: "T.g phi\xean trung b\xecnh"
            },
            definition: {
                en: "The average amount of time users spend actively engaging with your website per session.",
                vi: "Th\u1EDDi gian trung b\xecnh ng\u01B0\u1EDDi d\xf9ng d\xe0nh \u0111\u1EC3 t\u01B0\u01A1ng t\xe1c t\xedch c\u1EF1c v\u1EDBi trang web c\u1EE7a b\u1EA1n trong m\u1ED7i phi\xean."
            }
        },
        "Pages/Session": {
            title: {
                en: "Pages/Session",
                vi: "Trang/Phi\xean"
            },
            definition: {
                en: "The average number of pages viewed during a session. Repeated views of a single page are counted.",
                vi: "S\u1ED1 trang trung b\xecnh \u0111\u01B0\u1EE3c xem trong m\u1ED9t phi\xean. C\xe1c l\u1EA7n xem l\u1EA1i c\u1EE7a m\u1ED9t trang c\u0169ng \u0111\u01B0\u1EE3c t\xednh."
            }
        },
        "Bounce Rate": {
            title: {
                en: "Bounce Rate",
                vi: "T\u1EF7 l\u1EC7 tho\xe1t"
            },
            definition: {
                en: "The percentage of sessions where the user leaves without interacting with the page.",
                vi: "T\u1EF7 l\u1EC7 ph\u1EA7n tr\u0103m c\xe1c phi\xean m\xe0 ng\u01B0\u1EDDi d\xf9ng r\u1EDDi \u0111i m\xe0 kh\xf4ng t\u01B0\u01A1ng t\xe1c v\u1EDBi trang."
            }
        },
        "Clicks Tracking": {
            title: {
                en: "Clicks Tracking",
                vi: "Theo d\xf5i l\u01B0\u1EE3t nh\u1EA5p"
            },
            definition: {
                en: "A chronological view of the number of clicks/visits received over the selected time period.",
                vi: "Ch\u1EBF \u0111\u1ED9 xem theo th\u1EDDi gian v\u1EC1 s\u1ED1 l\u01B0\u1EE3ng l\u1EA7n nh\u1EA5p/truy c\u1EADp trong kho\u1EA3ng th\u1EDDi gian \u0111\xe3 ch\u1ECDn."
            }
        },
        "Page Views": {
            title: {
                en: "Page Views",
                vi: "L\u01B0\u1EE3t xem trang"
            },
            definition: {
                en: "The total number of pages viewed. Repeated views of a single page are counted.",
                vi: "T\u1ED5ng s\u1ED1 trang \u0111\xe3 xem. C\xe1c l\u1EA7n xem l\u1EA1i c\u1EE7a m\u1ED9t trang c\u0169ng \u0111\u01B0\u1EE3c t\xednh."
            }
        },
        "Where Customers From": {
            title: {
                en: "Where Customers From",
                vi: "Ngu\u1ED3n kh\xe1ch h\xe0ng"
            },
            definition: {
                en: "The origin of your traffic (e.g., Direct, Social Media, Search Engines).",
                vi: "Ngu\u1ED3n g\u1ED1c l\u01B0u l\u01B0\u1EE3ng truy c\u1EADp c\u1EE7a b\u1EA1n (v\xed d\u1EE5: Tr\u1EF1c ti\u1EBFp, M\u1EA1ng x\xe3 h\u1ED9i, C\xf4ng c\u1EE5 t\xecm ki\u1EBFm)."
            }
        },
        "Time Tracking": {
            title: {
                en: "Time Tracking",
                vi: "Theo d\xf5i th\u1EDDi gian"
            },
            definition: {
                en: "A heatmap showing peak traffic times by hour of the day and day of the week.",
                vi: "B\u1EA3n \u0111\u1ED3 nhi\u1EC7t hi\u1EC3n th\u1ECB th\u1EDDi gian l\u01B0u l\u01B0\u1EE3ng truy c\u1EADp cao \u0111i\u1EC3m theo gi\u1EDD trong ng\xe0y v\xe0 ng\xe0y trong tu\u1EA7n."
            }
        },
        "User By Device": {
            title: {
                en: "User By Device",
                vi: "Thi\u1EBFt b\u1ECB ng\u01B0\u1EDDi d\xf9ng"
            },
            definition: {
                en: "Breakdown of visitors by the type of device used (Desktop, Mobile, Tablet).",
                vi: "Ph\xe2n lo\u1EA1i kh\xe1ch truy c\u1EADp theo lo\u1EA1i thi\u1EBFt b\u1ECB s\u1EED d\u1EE5ng (M\xe1y t\xednh \u0111\u1EC3 b\xe0n, Di \u0111\u1ED9ng, M\xe1y t\xednh b\u1EA3ng)."
            }
        },
        "Visits By City": {
            title: {
                en: "Visits By City",
                vi: "Truy c\u1EADp theo th\xe0nh ph\u1ED1"
            },
            definition: {
                en: "Geographic distribution of your traffic sources by city.",
                vi: "Ph\xe2n b\u1ED1 \u0111\u1ECBa l\xfd c\u1EE7a c\xe1c ngu\u1ED3n l\u01B0u l\u01B0\u1EE3ng truy c\u1EADp theo th\xe0nh ph\u1ED1."
            }
        },
        "Top Browsing Pages Per Minute": {
            title: {
                en: "Top Browsing Pages Per Minute",
                vi: "C\xe1c trang h\xe0ng \u0111\u1EA7u m\u1ED7i ph\xfat"
            },
            definition: {
                en: "A real-time snapshot of which pages are currently receiving the most traffic.",
                vi: "\u1EA2nh ch\u1EE5p nhanh theo th\u1EDDi gian th\u1EF1c v\u1EC1 c\xe1c trang hi\u1EC7n \u0111ang nh\u1EADn \u0111\u01B0\u1EE3c nhi\u1EC1u l\u01B0u l\u01B0\u1EE3ng truy c\u1EADp nh\u1EA5t."
            }
        },
        "Page": {
            title: {
                en: "Page",
                vi: "Trang"
            },
            definition: {
                en: "The specific URL path of the page being visited.",
                vi: "\u0110\u01B0\u1EDDng d\u1EABn URL c\u1EE5 th\u1EC3 c\u1EE7a trang \u0111ang \u0111\u01B0\u1EE3c truy c\u1EADp."
            }
        },
        "Views": {
            title: {
                en: "Views",
                vi: "L\u01B0\u1EE3t xem"
            },
            definition: {
                en: "The number of times this specific page has been viewed in the selected period.",
                vi: "S\u1ED1 l\u1EA7n trang c\u1EE5 th\u1EC3 n\xe0y \u0111\xe3 \u0111\u01B0\u1EE3c xem trong kho\u1EA3ng th\u1EDDi gian \u0111\xe3 ch\u1ECDn."
            }
        },
        "Bounce Rate Table": {
            title: {
                en: "Bounce Rate",
                vi: "T\u1EF7 l\u1EC7 tho\xe1t"
            },
            definition: {
                en: "The percentage of visitors who left after viewing only this page.",
                vi: "T\u1EF7 l\u1EC7 ph\u1EA7n tr\u0103m kh\xe1ch truy c\u1EADp \u0111\xe3 r\u1EDDi \u0111i sau khi ch\u1EC9 xem trang n\xe0y."
            }
        }
    };
    const entry = glossary[term] || glossary[term + " Table"];
    const definition = entry?.definition?.[language] || "No definition available.";
    // Use the localized title from glossary, or fallback to term if not found
    const displayTitle = entry?.title?.[language] || term;
    const positionClass = side === 'top' ? 'bottom-full mb-2 transform translate-y-1 group-hover:translate-y-0' : 'top-full mt-2 transform -translate-y-1 group-hover:translate-y-0';
    const arrowClass = side === 'top' ? 'top-full -mt-px border-t-slate-900' : 'bottom-full -mb-px border-b-slate-900';
    return /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
        className: "group relative inline-block cursor-help",
        children: [
            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                className: "flex items-center gap-1 border-b border-dashed border-slate-300 dark:border-slate-600 pb-0.5 hover:border-indigo-400 dark:hover:border-indigo-400 transition-colors",
                children: children
            }),
            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                className: `absolute left-1/2 -translate-x-1/2 w-64 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 pointer-events-none ${positionClass}`,
                children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                    className: "bg-slate-900 text-white text-xs rounded-xl py-3 px-4 shadow-xl relative",
                    children: [
                        /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                            className: "font-bold mb-1 text-indigo-300",
                            children: displayTitle
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                            className: "text-slate-300 leading-relaxed",
                            children: definition
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                            className: `absolute left-1/2 -translate-x-1/2 border-4 border-transparent ${arrowClass}`
                        })
                    ]
                })
            })
        ]
    });
};


const $83e73b5fa491e453$export$5833004b3f15c9b = ({ title: title, tooltipTerm: tooltipTerm, value: value, trend: trend, trendDirection: trendDirection = 'up', trendLabel: trendLabel = 'this month', icon: icon, variant: variant = 'indigo', className: className })=>{
    const colorStyles = {
        indigo: {
            bg: 'bg-indigo-50 dark:bg-indigo-900/20',
            text: 'text-indigo-600 dark:text-indigo-400',
            iconBg: 'bg-indigo-50 dark:bg-indigo-900/40',
            iconShadow: 'shadow-[0_0_10px_rgba(99,102,241,0.25)] dark:shadow-[0_0_10px_rgba(129,140,248,0.15)]'
        },
        yellow: {
            bg: 'bg-amber-50 dark:bg-amber-900/20',
            text: 'text-amber-600 dark:text-amber-400',
            iconBg: 'bg-amber-50 dark:bg-amber-900/40',
            iconShadow: 'shadow-[0_0_10px_rgba(245,158,11,0.25)] dark:shadow-[0_0_10px_rgba(251,191,36,0.15)]'
        },
        teal: {
            bg: 'bg-teal-50 dark:bg-teal-900/20',
            text: 'text-teal-600 dark:text-teal-400',
            iconBg: 'bg-teal-50 dark:bg-teal-900/40',
            iconShadow: 'shadow-[0_0_10px_rgba(13,148,136,0.25)] dark:shadow-[0_0_10px_rgba(45,212,191,0.15)]'
        },
        rose: {
            bg: 'bg-rose-50 dark:bg-rose-900/20',
            text: 'text-rose-600 dark:text-rose-400',
            iconBg: 'bg-rose-50 dark:bg-rose-900/40',
            iconShadow: 'shadow-[0_0_10px_rgba(225,29,72,0.25)] dark:shadow-[0_0_10px_rgba(251,113,133,0.15)]'
        },
        blue: {
            bg: 'bg-blue-50 dark:bg-blue-900/20',
            text: 'text-blue-600 dark:text-blue-400',
            iconBg: 'bg-blue-50 dark:bg-blue-900/40',
            iconShadow: 'shadow-[0_0_10px_rgba(37,99,235,0.25)] dark:shadow-[0_0_10px_rgba(96,165,250,0.15)]'
        },
        emerald: {
            bg: 'bg-emerald-50 dark:bg-emerald-900/20',
            text: 'text-emerald-600 dark:text-emerald-400',
            iconBg: 'bg-emerald-50 dark:bg-emerald-900/40',
            iconShadow: 'shadow-[0_0_10px_rgba(5,150,105,0.25)] dark:shadow-[0_0_10px_rgba(52,211,153,0.15)]'
        }
    };
    const colors = colorStyles[variant] || colorStyles.indigo;
    return /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
        className: `bg-white dark:bg-slate-900 p-6 rounded-3xl border border-slate-100 dark:border-slate-800 flex items-start justify-between h-full transition-all hover:-translate-y-1 hover:shadow-[0_20px_40px_-15px_rgba(0,0,0,0.1)] shadow-[0_0_20px_-5px_rgba(0,0,0,0.05)] dark:shadow-[0_0_20px_-5px_rgba(255,255,255,0.03)] ${className || ''}`,
        children: [
            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                className: "flex flex-col justify-between h-full gap-4",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                className: "mb-1",
                                children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $9f258ebe77ccfbd1$export$eccda88c066b9b81), {
                                    term: tooltipTerm || title,
                                    children: /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                        className: "text-sm font-bold text-slate-600 dark:text-slate-400",
                                        children: title
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                className: "text-3xl font-extrabold text-slate-900 dark:text-white tracking-tight",
                                children: value
                            })
                        ]
                    }),
                    trend && /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("span", {
                                className: `text-xs font-bold px-2 py-1 rounded-md flex items-center gap-1 ${trendDirection === 'up' ? 'bg-emerald-50 text-emerald-600 dark:bg-emerald-900/30 dark:text-emerald-400' : 'bg-rose-50 text-rose-600 dark:bg-rose-900/30 dark:text-rose-400'}`,
                                children: [
                                    trendDirection === 'up' ? /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ArrowUpRight), {
                                        size: 12,
                                        strokeWidth: 3
                                    }) : /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ArrowDownRight), {
                                        size: 12,
                                        strokeWidth: 3
                                    }),
                                    trend
                                ]
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                className: "text-xs text-slate-400 font-medium",
                                children: trendLabel
                            })
                        ]
                    })
                ]
            }),
            icon && /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                className: `w-14 h-14 rounded-2xl flex items-center justify-center ${colors.iconBg} ${colors.text} ${colors.iconShadow}`,
                children: /*#__PURE__*/ (0, $ccwsP$react).isValidElement(icon) ? /*#__PURE__*/ (0, $ccwsP$react).cloneElement(icon, {
                    size: 24,
                    strokeWidth: 2.5
                }) : icon
            })
        ]
    });
};





const $a60fbf2e582a0bfd$export$24aa2c0563a80031 = ({ domain: domain, onClose: onClose })=>{
    const [copiedFrontend, setCopiedFrontend] = (0, $ccwsP$useState)(false);
    const currentOrigin = window.location.origin;
    const trackerUrl = `${currentOrigin}/tracker.js`;
    const frontendCode = `<!-- MyETRAFFIC Tracking Code -->
<script 
  src="${trackerUrl}" 
  data-id="${domain.id}" 
  async>
</script>`;
    const copyToClipboard = (text, setFn)=>{
        navigator.clipboard.writeText(text);
        setFn(true);
        setTimeout(()=>setFn(false), 2000);
    };
    return /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
        className: "fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4",
        children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
            className: "bg-white dark:bg-slate-900 rounded-2xl w-full max-w-4xl shadow-2xl flex flex-col max-h-[95vh] border border-slate-200 dark:border-slate-800 overflow-hidden",
            children: [
                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                    className: "flex justify-between items-center p-5 md:p-6 border-b border-slate-100 dark:border-slate-800",
                    children: [
                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                    className: "bg-indigo-100 dark:bg-indigo-900/30 p-2 rounded-lg text-indigo-600 dark:text-indigo-400",
                                    children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Globe), {
                                        className: "w-5 h-5 md:w-6 md:h-6"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                    className: "min-w-0",
                                    children: [
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("h2", {
                                            className: "text-lg md:text-xl font-bold text-slate-900 dark:text-white truncate",
                                            children: "Setup Guide"
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("p", {
                                            className: "text-[10px] md:text-sm text-slate-500 truncate",
                                            children: [
                                                "Tracking code for ",
                                                domain.name
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                            onClick: onClose,
                            className: "p-2 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg transition-colors",
                            children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$X), {
                                size: 20,
                                className: "text-slate-500 dark:text-slate-400"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                    className: "flex-1 overflow-y-auto p-5 md:p-8 bg-slate-50 dark:bg-slate-950",
                    children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: "max-w-3xl mx-auto space-y-6 md:space-y-8",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("section", {
                                className: "bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 shadow-sm overflow-hidden border-l-4 border-l-brand-500",
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "px-5 py-4 border-b border-slate-100 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-800/50 flex justify-between items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Code), {
                                                        className: "text-brand-500",
                                                        size: 16
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                                        className: "font-bold text-slate-900 dark:text-white text-sm md:text-base",
                                                        children: "1. Tracking Script"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                className: "text-[9px] font-mono text-brand-600 dark:text-brand-400 bg-brand-50 dark:bg-brand-900/20 px-1.5 py-0.5 rounded border border-brand-200",
                                                children: "Auto-Update"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "p-5 md:p-6",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("p", {
                                                className: "text-xs md:text-sm text-slate-600 dark:text-slate-300 mb-4",
                                                children: [
                                                    "Copy and paste this snippet into the ",
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("code", {
                                                        className: "bg-slate-100 dark:bg-slate-800 px-1 rounded",
                                                        children: "head"
                                                    }),
                                                    " or ",
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("code", {
                                                        className: "bg-slate-100 dark:bg-slate-800 px-1 rounded",
                                                        children: "body"
                                                    }),
                                                    "."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "relative group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("pre", {
                                                        className: "p-4 md:p-5 bg-slate-900 text-indigo-100 font-mono text-[10px] md:text-xs rounded-xl overflow-x-auto leading-relaxed scrollbar-thin scrollbar-thumb-slate-700",
                                                        children: frontendCode
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                                                        onClick: ()=>copyToClipboard(frontendCode, setCopiedFrontend),
                                                        className: "absolute top-2 right-2 md:top-3 md:right-3 bg-indigo-600 hover:bg-indigo-700 text-white px-3 py-1.5 rounded-lg text-[10px] font-bold flex items-center gap-2 transition-all shadow-md",
                                                        children: [
                                                            copiedFrontend ? /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Check), {
                                                                size: 12
                                                            }) : /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Copy), {
                                                                size: 12
                                                            }),
                                                            copiedFrontend ? 'Copied!' : 'Copy'
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "mt-4 flex items-start gap-3 text-[10px] md:text-xs text-slate-500 dark:text-slate-400 bg-indigo-50 dark:bg-indigo-900/10 p-3 rounded-lg border border-indigo-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                        className: "mt-0.5 text-indigo-500 shrink-0",
                                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Server), {
                                                            size: 14
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                                        children: "Updates are applied automatically without you needing to change this code again."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("section", {
                                className: "bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 shadow-sm overflow-hidden",
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                        className: "px-5 py-4 border-b border-slate-100 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-800/50",
                                        children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Link1), {
                                                    className: "text-purple-500",
                                                    size: 16
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                                    className: "font-bold text-slate-900 dark:text-white text-sm md:text-base",
                                                    children: "2. Campaign Links"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "p-5 md:p-6",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("p", {
                                                className: "text-xs md:text-sm text-slate-600 dark:text-slate-300 mb-3",
                                                children: [
                                                    "Detect sources via the ",
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("code", {
                                                        className: "bg-slate-100 dark:bg-slate-800 px-1 rounded font-bold",
                                                        children: "?s="
                                                    }),
                                                    " parameter."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "grid grid-cols-1 md:grid-cols-2 gap-3 text-[10px] font-mono",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                        className: "bg-slate-50 dark:bg-slate-800 p-2.5 rounded border border-slate-200 flex justify-between items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                                className: "text-slate-500",
                                                                children: "Facebook Ad"
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                                className: "text-purple-600 font-bold",
                                                                children: "?s=fb_ad"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                        className: "bg-slate-50 dark:bg-slate-800 p-2.5 rounded border border-slate-200 flex justify-between items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                                className: "text-slate-500",
                                                                children: "Newsletter"
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                                className: "text-purple-600 font-bold",
                                                                children: "?s=email"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                    className: "p-5 md:p-6 border-t border-slate-100 dark:border-slate-800 bg-slate-50 dark:bg-slate-950 flex justify-end",
                    children: /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                        onClick: onClose,
                        className: "w-full sm:w-auto px-8 py-3 bg-indigo-600 text-white font-bold rounded-xl hover:bg-indigo-700 transition-colors shadow-lg",
                        children: "Finished Setup"
                    })
                })
            ]
        })
    });
};






const $05c64ef4cc5e0393$export$e2a8fd01773fcf65 = ()=>/*#__PURE__*/ (0, $ccwsP$jsx)("svg", {
        viewBox: "0 0 959 593",
        className: "w-full h-full fill-slate-300 dark:fill-slate-600 stroke-white dark:stroke-slate-900 stroke-1",
        children: /*#__PURE__*/ (0, $ccwsP$jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $ccwsP$jsx)("path", {
                    id: "HI",
                    d: "M 299.841 534.643 L 301.933 533.538 L 304.005 534.427 L 305.362 536.791 L 304.218 538.882 L 301.663 539.007 L 299.841 536.651 L 299.841 534.643 Z M 314.704 542.842 L 320.408 545.424 L 322.101 549.227 L 320.387 552.146 L 316.748 552.281 L 313.711 549.626 L 313.209 544.985 L 314.704 542.842 Z M 324.922 553.905 L 327.969 554.348 L 331.584 557.447 L 331.627 560.221 L 328.473 561.388 L 325.690 559.296 L 324.174 556.582 L 324.922 553.905 Z M 336.338 564.309 L 342.839 567.076 L 345.704 572.428 L 344.131 577.654 L 338.714 577.767 L 333.391 572.563 L 333.598 566.794 L 336.338 564.309 Z M 351.196 576.628 L 358.288 578.153 L 363.549 583.428 L 362.504 589.240 L 357.053 591.261 L 350.888 588.652 L 348.223 583.557 L 351.196 576.628 Z M 368.123 588.144 L 375.807 587.361 L 381.334 590.770 L 380.415 592.999 L 375.075 593.000 L 369.320 591.369 L 368.123 588.144 Z"
                }),
                /*#__PURE__*/ (0, $ccwsP$jsx)("path", {
                    id: "AK",
                    d: "M 117.620 502.854 L 122.432 495.903 L 132.285 492.253 L 140.434 493.301 L 148.779 488.842 L 152.983 482.887 L 158.453 482.596 L 162.860 478.752 L 169.877 480.465 L 173.335 476.220 L 183.927 475.013 L 190.516 471.309 L 194.024 465.431 L 193.908 454.543 L 197.989 449.886 L 197.483 445.499 L 214.357 440.872 L 228.933 439.351 L 234.653 435.877 L 242.810 438.532 L 254.391 438.089 L 261.408 440.611 L 265.360 448.603 L 262.321 456.198 L 257.140 456.655 L 253.127 463.855 L 255.689 472.962 L 254.826 480.781 L 258.286 483.368 L 259.555 491.984 L 265.864 494.014 L 266.646 499.367 L 272.645 502.765 L 277.643 501.991 L 280.240 506.247 L 276.039 511.673 L 270.949 512.257 L 267.664 516.220 L 261.861 515.823 L 260.512 512.407 L 251.398 510.399 L 245.607 512.789 L 237.796 508.656 L 237.880 503.748 L 233.361 501.249 L 225.186 502.626 L 218.689 499.918 L 211.705 503.570 L 209.273 508.695 L 202.792 508.157 L 194.031 501.699 L 188.910 502.600 L 185.739 507.967 L 176.327 508.611 L 169.161 513.375 L 165.582 519.627 L 157.042 519.234 L 152.079 515.509 L 144.316 514.825 L 141.372 518.043 L 134.123 518.198 L 128.621 515.471 L 122.921 517.311 L 122.083 525.334 L 118.261 529.606 L 113.609 527.142 L 110.977 517.703 L 114.509 511.636 L 118.275 507.637 L 117.620 502.854 Z"
                }),
                /*#__PURE__*/ (0, $ccwsP$jsx)("path", {
                    id: "FL",
                    d: "M 808.065 489.374 L 799.573 491.127 L 794.820 486.059 L 767.321 487.739 L 754.318 485.441 L 748.606 482.753 L 745.687 483.766 L 742.322 477.581 L 738.848 477.303 L 738.598 470.342 L 785.957 467.747 L 787.697 454.149 L 794.082 448.097 L 801.448 455.334 L 805.136 463.860 L 811.246 476.818 L 812.843 489.270 L 808.065 489.374 Z"
                }),
                /*#__PURE__*/ (0, $ccwsP$jsx)("path", {
                    id: "TX",
                    d: "M 482.177 464.276 L 487.003 457.927 L 489.846 447.887 L 486.884 442.271 L 471.787 442.955 L 471.676 431.275 L 434.301 432.264 L 434.245 394.408 L 439.504 394.395 L 449.874 394.396 L 460.038 394.582 L 469.692 394.518 L 478.997 394.466 L 485.206 394.433 L 486.183 394.533 L 486.789 407.085 L 501.321 407.600 L 515.081 413.409 L 524.699 410.251 L 536.427 412.952 L 536.786 421.136 L 536.618 430.196 L 532.968 434.536 L 538.858 440.441 L 541.845 454.435 L 533.676 463.232 L 523.239 465.535 L 514.505 470.287 L 507.960 483.904 L 498.013 486.472 L 493.657 477.099 L 486.782 471.519 L 482.177 464.276 Z"
                }),
                /*#__PURE__*/ (0, $ccwsP$jsx)("path", {
                    id: "CA",
                    d: "M 51.828 255.100 L 57.666 249.590 L 54.605 232.761 L 84.063 230.859 L 99.524 283.801 L 117.450 319.792 L 141.240 355.455 L 131.459 359.378 L 121.776 354.482 L 111.988 351.500 L 102.780 348.020 L 92.603 339.469 L 82.810 329.806 L 72.292 319.230 L 64.141 303.722 L 58.980 288.100 L 51.828 255.100 Z"
                }),
                /*#__PURE__*/ (0, $ccwsP$jsx)("path", {
                    id: "NY",
                    d: "M 780.571 136.894 L 793.011 130.319 L 793.041 148.842 L 795.878 151.838 L 793.260 154.870 L 797.404 161.330 L 783.476 165.015 L 774.638 161.827 L 773.593 159.914 L 747.600 160.237 L 745.849 158.043 L 752.922 150.274 L 761.232 144.547 L 765.132 137.918 L 772.308 134.987 L 780.571 136.894 Z"
                }),
                /*#__PURE__*/ (0, $ccwsP$jsx)("path", {
                    id: "RestOfUSA",
                    d: "M 746.668 27.313 L 732.799 48.934 L 711.984 67.830 L 687.202 80.239 L 646.181 84.240 L 630.387 91.282 L 604.798 91.905 L 596.137 99.742 L 555.083 103.434 L 513.163 102.273 L 484.572 102.200 L 465.845 100.437 L 431.162 99.350 L 408.990 99.315 L 395.221 99.296 L 359.028 99.233 L 336.627 99.197 L 316.585 99.162 L 270.076 99.087 L 221.194 99.002 L 191.922 98.952 L 160.660 98.899 L 151.585 98.883 L 144.341 98.870 L 129.090 102.773 L 124.542 113.802 L 116.497 119.271 L 115.156 129.001 L 107.190 133.032 L 107.034 146.603 L 99.668 147.021 L 97.452 164.943 L 93.289 170.390 L 91.258 182.723 L 85.403 186.168 L 85.563 230.758 L 54.605 232.761 L 57.666 249.590 L 51.828 255.100 L 58.980 288.100 L 64.141 303.722 L 72.292 319.230 L 82.810 329.806 L 92.603 339.469 L 102.780 348.020 L 111.988 351.500 L 121.776 354.482 L 131.459 359.378 L 141.240 355.455 L 154.489 352.029 L 180.502 350.418 L 180.219 382.202 L 228.705 382.327 L 229.324 423.850 L 284.294 424.314 L 284.856 400.948 L 329.911 401.256 L 329.949 393.271 L 434.245 394.408 L 434.301 432.264 L 471.676 431.275 L 471.787 442.955 L 486.884 442.271 L 489.846 447.887 L 487.003 457.927 L 482.177 464.276 L 486.782 471.519 L 493.657 477.099 L 498.013 486.472 L 507.960 483.904 L 514.505 470.287 L 523.239 465.535 L 533.676 463.232 L 541.845 454.435 L 538.858 440.441 L 532.968 434.536 L 536.618 430.196 L 536.786 421.136 L 536.427 412.952 L 551.135 413.012 L 545.910 462.964 L 580.772 463.146 L 574.151 469.396 L 578.397 472.569 L 577.209 478.174 L 594.033 478.243 L 598.145 471.160 L 604.006 471.184 L 610.965 463.512 L 616.536 463.535 L 625.635 447.610 L 654.198 448.018 L 657.938 451.169 L 662.752 444.124 L 690.148 441.204 L 693.675 436.349 L 714.067 432.345 L 724.655 435.383 L 726.150 443.513 L 733.900 448.417 L 737.833 456.642 L 742.964 457.593 L 746.904 460.937 L 753.804 460.962 L 756.637 466.921 L 738.598 470.342 L 738.848 477.303 L 742.322 477.581 L 745.687 483.766 L 748.606 482.753 L 754.318 485.441 L 767.321 487.739 L 794.820 486.059 L 799.573 491.127 L 808.065 489.374 L 812.843 489.270 L 811.246 476.818 L 805.136 463.860 L 801.448 455.334 L 794.082 448.097 L 787.697 454.149 L 785.957 467.747 L 738.598 470.342 L 738.348 469.092 L 739.140 458.836 L 741.716 454.325 L 738.806 449.081 L 747.004 439.993 L 746.307 433.238 L 750.860 429.137 L 760.769 427.081 L 763.067 419.224 L 771.270 416.553 L 773.149 408.721 L 784.069 403.312 L 783.018 391.187 L 786.846 383.557 L 782.056 378.882 L 782.796 367.634 L 795.594 362.441 L 799.570 343.276 L 810.040 325.459 L 826.994 311.465 L 821.275 298.750 L 827.663 289.446 L 843.480 288.214 L 857.845 270.457 L 842.864 261.150 L 837.564 247.905 L 830.960 245.009 L 819.753 247.513 L 815.533 241.164 L 819.571 234.081 L 816.206 226.582 L 820.339 220.749 L 829.905 218.749 L 831.721 205.417 L 838.902 199.251 L 845.780 186.835 L 852.553 183.169 L 850.375 176.252 L 854.880 170.085 L 853.574 163.502 L 849.067 159.502 L 847.904 148.752 L 841.729 143.002 L 828.213 143.586 L 823.998 139.752 L 824.725 131.835 L 821.383 127.335 L 812.956 124.169 L 814.990 115.252 L 808.959 112.085 L 806.126 104.502 L 802.493 101.919 L 797.843 92.502 L 787.889 90.252 L 780.115 79.002 L 774.303 77.669 L 769.144 73.002 L 763.332 71.585 L 746.668 27.313 Z M 747.600 160.237 L 773.593 159.914 L 774.638 161.827 L 783.476 165.015 L 797.404 161.330 L 793.260 154.870 L 795.878 151.838 L 793.041 148.842 L 793.011 130.319 L 780.571 136.894 L 772.308 134.987 L 765.132 137.918 L 761.232 144.547 L 752.922 150.274 L 745.849 158.043 L 747.600 160.237 Z"
                })
            ]
        })
    });









const $71516388373cffcd$export$39a935fa7fde4940 = ({ filterId: filterId, customDates: customDates, updateCustomDate: updateCustomDate, labels: labels = {
    from: 'From',
    to: 'To'
} })=>{
    const defaultRange = {
        start: new Date(Date.now() - 604800000).toISOString().split('T')[0],
        end: new Date().toISOString().split('T')[0]
    };
    const dates = {
        start: customDates[filterId]?.start || defaultRange.start,
        end: customDates[filterId]?.end || defaultRange.end
    };
    return /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
        className: "flex items-center gap-2 mt-2 p-2 bg-slate-50 dark:bg-slate-800/50 rounded-lg border border-slate-100 dark:border-slate-700 animate-in fade-in slide-in-from-top-1 duration-200",
        children: [
            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                className: "flex flex-col gap-0.5",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)("label", {
                        className: "text-[10px] font-bold text-slate-400 uppercase",
                        children: labels.from
                    }),
                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: "flex items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Calendar), {
                                size: 10,
                                className: "text-slate-400"
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsx)("input", {
                                type: "date",
                                value: dates.start,
                                onChange: (e)=>updateCustomDate(filterId, 'start', e.target.value),
                                className: "bg-transparent border-none text-xs font-bold text-slate-700 dark:text-slate-200 outline-none cursor-pointer focus:ring-0 p-0"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                className: "w-px h-6 bg-slate-200 dark:bg-slate-700 mx-1"
            }),
            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                className: "flex flex-col gap-0.5",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)("label", {
                        className: "text-[10px] font-bold text-slate-400 uppercase",
                        children: labels.to
                    }),
                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: "flex items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Calendar), {
                                size: 10,
                                className: "text-slate-400"
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsx)("input", {
                                type: "date",
                                value: dates.end,
                                onChange: (e)=>updateCustomDate(filterId, 'end', e.target.value),
                                className: "bg-transparent border-none text-xs font-bold text-slate-700 dark:text-slate-200 outline-none cursor-pointer focus:ring-0 p-0"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $6056b508dd142eac$export$6e9e0b5447fad01f = ({ events: events, className: className, id: id = 'ip-tracker' })=>{
    const [filter, setFilter] = (0, $ccwsP$useState)('month');
    const [customDates, setCustomDates] = (0, $ccwsP$useState)({});
    const [page, setPage] = (0, $ccwsP$useState)(1);
    const [selectedIp, setSelectedIp] = (0, $ccwsP$useState)(null);
    const ITEMS_PER_PAGE = 8; // Reduced for better mobile height
    // --- Data Processing ---
    const filteredEvents = (0, $ccwsP$useMemo)(()=>{
        const now = Date.now();
        let startTime = 0;
        let endTime = Infinity;
        if (filter === 'today') startTime = new Date().setHours(0, 0, 0, 0);
        else if (filter === 'week') startTime = now - 604800000;
        else if (filter === 'month') startTime = now - 2592000000;
        else if (filter === 'custom') {
            const defaultRange = {
                start: new Date(Date.now() - 604800000).toISOString().split('T')[0],
                end: new Date().toISOString().split('T')[0]
            };
            const dates = {
                start: customDates[id]?.start || defaultRange.start,
                end: customDates[id]?.end || defaultRange.end
            };
            startTime = new Date(dates.start).getTime();
            endTime = new Date(dates.end).setHours(23, 59, 59, 999);
        }
        return events.filter((e)=>e.timestamp >= startTime && e.timestamp <= endTime && e.country === 'US');
    }, [
        events,
        filter,
        customDates,
        id
    ]);
    const ipSessions = (0, $ccwsP$useMemo)(()=>{
        const groups = {};
        filteredEvents.forEach((e)=>{
            const ip = e.ip || 'Unknown';
            if (!groups[ip]) groups[ip] = [];
            groups[ip].push(e);
        });
        const sessions = Object.entries(groups).map(([ip, userEvents])=>{
            const sorted = userEvents.sort((a, b)=>a.timestamp - b.timestamp);
            const uniquePaths = new Set(sorted.map((e)=>e.path));
            const locationEvent = sorted.find((e)=>e.city || e.country) || sorted[0];
            const city = locationEvent.city ? decodeURIComponent(locationEvent.city) : '';
            const locStr = city ? `${city}, ${locationEvent.country || ''}` : locationEvent.country || 'Unknown Location';
            return {
                ip: ip,
                location: locStr,
                events: sorted,
                lastSeen: sorted[sorted.length - 1].timestamp,
                actionCount: sorted.length,
                device: sorted[0].deviceType || 'desktop',
                isBounce: uniquePaths.size === 1,
                entryPath: sorted[0].path
            };
        });
        return sessions.sort((a, b)=>b.lastSeen - a.lastSeen);
    }, [
        filteredEvents
    ]);
    const totalPages = Math.ceil(ipSessions.length / ITEMS_PER_PAGE);
    const currentData = ipSessions.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE);
    const handlePageChange = (newPage)=>{
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
            setSelectedIp(null);
        }
    };
    const formatDate = (ts)=>{
        return new Intl.DateTimeFormat('en-US', {
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        }).format(new Date(ts));
    };
    return /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
        className: `bg-white dark:bg-slate-900 p-5 md:p-8 rounded-3xl border border-slate-100 dark:border-slate-800 shadow-[0_0_20px_-5px_rgba(0,0,0,0.05)] dark:shadow-[0_0_20px_-5px_rgba(255,255,255,0.03)] flex flex-col min-h-[500px] lg:h-[600px] ${className}`,
        children: [
            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                className: "flex flex-col sm:flex-row justify-between items-start gap-4 mb-6 shrink-0",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsx)((0, $9f258ebe77ccfbd1$export$eccda88c066b9b81), {
                                term: "Users",
                                children: /*#__PURE__*/ (0, $ccwsP$jsxs)("h3", {
                                    className: "text-lg md:text-xl font-bold text-slate-900 dark:text-white flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Globe), {
                                            className: "text-indigo-500 w-5 h-5 md:w-6 md:h-6"
                                        }),
                                        " IP Tracker (US Only)"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                className: "text-xs md:text-sm text-slate-500 dark:text-slate-400 mt-0.5",
                                children: "Track individual user journeys"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: "flex flex-col items-end gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                className: "flex bg-slate-100 dark:bg-slate-800 rounded-xl p-1 w-full sm:w-auto overflow-x-auto",
                                children: [
                                    'today',
                                    'week',
                                    'month',
                                    'custom'
                                ].map((t)=>/*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                        onClick: ()=>{
                                            setFilter(t);
                                            setPage(1);
                                            setSelectedIp(null);
                                        },
                                        className: `flex-1 sm:flex-none px-4 py-1.5 text-[10px] md:text-xs font-bold rounded-lg capitalize transition-all ${filter === t ? 'bg-white dark:bg-slate-700 text-indigo-600 dark:text-indigo-400 shadow-sm' : 'text-slate-500 dark:text-slate-400 hover:text-slate-700'}`,
                                        children: t
                                    }, t))
                            }),
                            filter === 'custom' && /*#__PURE__*/ (0, $ccwsP$jsx)((0, $71516388373cffcd$export$39a935fa7fde4940), {
                                filterId: id,
                                customDates: customDates,
                                updateCustomDate: (fid, field, val)=>setCustomDates((prev)=>({
                                            ...prev,
                                            [fid]: {
                                                ...prev[fid],
                                                [field]: val
                                            }
                                        }))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                className: "flex-1 flex flex-col md:flex-row gap-6 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: `flex-1 flex flex-col min-w-0 transition-all duration-300 ${selectedIp ? 'hidden md:flex md:w-1/2 lg:w-5/12' : 'w-full'}`,
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: "grid grid-cols-12 gap-2 px-3 py-2 bg-indigo-50/50 dark:bg-slate-800/50 rounded-xl mb-2 text-[9px] md:text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider",
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                        className: "col-span-5 md:col-span-6",
                                        children: "IP / Location"
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                        className: "col-span-3 text-center",
                                        children: "Hits"
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                        className: "col-span-4 md:col-span-3 text-right",
                                        children: "Time"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                className: "flex-1 overflow-y-auto space-y-1 pr-1 custom-scrollbar",
                                children: currentData.length > 0 ? currentData.map((session)=>/*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        onClick: ()=>setSelectedIp(session),
                                        className: `grid grid-cols-12 gap-2 items-center px-3 py-3 rounded-xl cursor-pointer transition-all border ${selectedIp?.ip === session.ip ? 'bg-indigo-50 dark:bg-indigo-900/20 border-indigo-200 dark:border-indigo-800 shadow-sm' : 'bg-white dark:bg-slate-900 border-transparent hover:bg-slate-50 dark:hover:bg-slate-800'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "col-span-5 md:col-span-6 min-w-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                        className: "font-bold text-slate-700 dark:text-slate-200 truncate flex items-center gap-1.5 text-xs md:text-sm",
                                                        children: [
                                                            session.ip,
                                                            session.isBounce && /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                                className: "w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-amber-400",
                                                                title: "Bounced"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                        className: "text-[9px] md:text-xs text-slate-400 flex items-center gap-1 truncate",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$MapPin), {
                                                                size: 10
                                                            }),
                                                            " ",
                                                            session.location
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                className: "col-span-3 text-center",
                                                children: /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                    className: "inline-flex items-center px-1.5 py-0.5 rounded-md bg-slate-100 dark:bg-slate-800 text-[10px] md:text-xs font-bold text-slate-600 dark:text-slate-300",
                                                    children: session.actionCount
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                className: "col-span-4 md:col-span-3 text-right text-[9px] md:text-xs font-medium text-slate-500 dark:text-slate-400",
                                                children: formatDate(session.lastSeen).split(',')[0]
                                            })
                                        ]
                                    }, session.ip)) : /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                    className: "flex flex-col items-center justify-center h-full text-slate-400",
                                    children: [
                                        /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Search), {
                                            size: 32,
                                            className: "mb-2 opacity-50"
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                            className: "text-sm",
                                            children: "No US traffic"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: "mt-4 flex items-center justify-between pt-4 border-t border-slate-100 dark:border-slate-800 shrink-0",
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("span", {
                                        className: "text-[10px] md:text-xs text-slate-400",
                                        children: [
                                            "Page ",
                                            page,
                                            "/",
                                            totalPages || 1
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "flex gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                                onClick: ()=>handlePageChange(page - 1),
                                                disabled: page === 1,
                                                className: "p-1.5 rounded-lg bg-slate-50 dark:bg-slate-800 text-slate-600 disabled:opacity-50 transition-colors",
                                                children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ChevronLeft), {
                                                    className: "w-3.5 h-3.5 md:w-4 md:h-4"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                                onClick: ()=>handlePageChange(page + 1),
                                                disabled: page === totalPages || totalPages === 0,
                                                className: "p-1.5 rounded-lg bg-slate-50 dark:bg-slate-800 text-slate-600 disabled:opacity-50 transition-colors",
                                                children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ChevronRight), {
                                                    className: "w-3.5 h-3.5 md:w-4 md:h-4"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    selectedIp && /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: "flex-1 bg-slate-50 dark:bg-slate-950 rounded-2xl border border-slate-100 dark:border-slate-800 flex flex-col overflow-hidden animate-in slide-in-from-right-4 duration-300",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: "p-4 border-b border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 flex justify-between items-start shrink-0",
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("h4", {
                                                        className: "font-bold text-slate-900 dark:text-white text-base md:text-lg",
                                                        children: selectedIp.ip
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                        className: `px-2 py-0.5 text-[8px] md:text-[10px] font-bold uppercase rounded-full ${selectedIp.isBounce ? 'bg-amber-100 text-amber-700' : 'bg-emerald-100 text-emerald-700'}`,
                                                        children: selectedIp.isBounce ? 'Bounced' : 'Engaged'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "flex items-center gap-3 mt-1 text-[10px] md:text-xs text-slate-500",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("span", {
                                                        className: "flex items-center gap-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$MapPin), {
                                                                className: "w-2.5 h-2.5 md:w-3 md:h-3"
                                                            }),
                                                            " ",
                                                            selectedIp.location
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("span", {
                                                        className: "flex items-center gap-1 capitalize",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Layout), {
                                                                className: "w-2.5 h-2.5 md:w-3 md:h-3"
                                                            }),
                                                            " ",
                                                            selectedIp.device
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                        onClick: ()=>setSelectedIp(null),
                                        className: "text-slate-400 hover:text-slate-600 transition-colors",
                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$X), {
                                            className: "w-4.5 h-4.5 md:w-5 md:h-5"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                className: "flex-1 overflow-y-auto p-4 md:p-6 custom-scrollbar",
                                children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                    className: "relative pl-3 md:pl-4 space-y-6 before:absolute before:left-[4px] md:before:left-[5px] before:top-2 before:bottom-2 before:w-0.5 before:bg-slate-200 dark:before:bg-slate-800",
                                    children: [
                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                            className: "relative pl-5 md:pl-6",
                                            children: [
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                    className: "absolute left-[-5px] top-1 w-2.5 h-2.5 rounded-full bg-emerald-500 ring-4 ring-white dark:ring-slate-950"
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                    className: "text-[10px] md:text-xs font-bold text-emerald-600 dark:text-emerald-400 mb-0.5",
                                                    children: "Session Started"
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                    className: "text-[9px] md:text-[10px] text-slate-400 mb-2",
                                                    children: formatDate(selectedIp.events[0].timestamp)
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                    className: "bg-white dark:bg-slate-900 p-2.5 md:p-3 rounded-xl border border-emerald-100 dark:border-emerald-900/30 shadow-sm",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("p", {
                                                            className: "text-xs md:text-sm font-medium text-slate-700 dark:text-slate-300",
                                                            children: [
                                                                "Arrived on ",
                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                                    className: "text-indigo-600 font-mono bg-indigo-50 px-1 rounded",
                                                                    children: selectedIp.entryPath
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("p", {
                                                            className: "text-[10px] md:text-xs text-slate-500 mt-1",
                                                            children: [
                                                                "Source: ",
                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                                    className: "font-bold",
                                                                    children: selectedIp.events[0].source
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        selectedIp.events.slice(1).map((event, idx)=>{
                                            const prevEvent = selectedIp.events[idx];
                                            const isNavigation = prevEvent && prevEvent.path !== event.path;
                                            return /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "relative pl-5 md:pl-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                        className: `absolute left-[-5px] top-1.5 w-2.5 h-2.5 rounded-full ring-4 ring-white dark:ring-slate-950 ${isNavigation ? 'bg-indigo-500' : 'bg-slate-300 dark:bg-slate-600'}`
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                        className: "flex items-center gap-2 mb-1",
                                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                            className: "text-[9px] md:text-[10px] font-mono text-slate-400",
                                                            children: new Date(event.timestamp).toLocaleTimeString([], {
                                                                hour: '2-digit',
                                                                minute: '2-digit'
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                        className: "bg-white dark:bg-slate-900 p-2.5 md:p-3 rounded-xl border border-slate-100 dark:border-slate-800 shadow-sm",
                                                        children: isNavigation ? /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                            className: "flex items-center gap-2 text-xs md:text-sm text-slate-700",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ArrowRight), {
                                                                    size: 12,
                                                                    className: "text-indigo-500"
                                                                }),
                                                                /*#__PURE__*/ (0, $ccwsP$jsxs)("span", {
                                                                    children: [
                                                                        "Navigated to ",
                                                                        /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                                            className: "font-bold font-mono text-[10px] md:text-xs",
                                                                            children: event.path
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                            className: "flex items-start gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$MousePointer2), {
                                                                    size: 12,
                                                                    className: "mt-1 text-slate-400"
                                                                }),
                                                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("p", {
                                                                            className: "text-xs md:text-sm text-slate-700",
                                                                            children: [
                                                                                "Interaction on ",
                                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                                                    className: "font-mono text-[10px] opacity-75",
                                                                                    children: event.path
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("p", {
                                                                            className: "text-[9px] md:text-xs text-slate-400 mt-0.5",
                                                                            children: [
                                                                                "X:",
                                                                                Math.round(event.x),
                                                                                "% Y:",
                                                                                Math.round(event.y),
                                                                                "%"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }, event.id);
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                            className: "relative pl-5 md:pl-6",
                                            children: [
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                    className: "absolute left-[-5px] top-1 w-2.5 h-2.5 rounded-full bg-slate-400 dark:bg-slate-600 ring-4 ring-white dark:ring-slate-950"
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                    className: "text-[10px] md:text-xs font-bold text-slate-500 dark:text-slate-400",
                                                    children: "Session Ended"
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                    className: "text-[9px] md:text-[10px] text-slate-400",
                                                    children: formatDate(selectedIp.lastSeen)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




const $a97e8c48f36eb07f$var$COLORS = [
    '#6366f1',
    '#f59e0b',
    '#10b981',
    '#ec4899',
    '#3b82f6'
];
const $a97e8c48f36eb07f$var$DAYS = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat'
];
const $a97e8c48f36eb07f$var$MONTHS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
const $a97e8c48f36eb07f$var$CITY_COORDINATES = {
    'Birmingham, AL': {
        left: '66%',
        top: '60%'
    },
    'Montgomery, AL': {
        left: '67%',
        top: '64%'
    },
    'Mobile, AL': {
        left: '65%',
        top: '70%'
    },
    'Huntsville, AL': {
        left: '66%',
        top: '56%'
    },
    'Anchorage, AK': {
        left: '15%',
        top: '80%'
    },
    'Juneau, AK': {
        left: '22%',
        top: '82%'
    },
    'Fairbanks, AK': {
        left: '18%',
        top: '75%'
    },
    'Phoenix, AZ': {
        left: '18%',
        top: '58%'
    },
    'Tucson, AZ': {
        left: '20%',
        top: '62%'
    },
    'Mesa, AZ': {
        left: '19%',
        top: '58%'
    },
    'Chandler, AZ': {
        left: '19%',
        top: '59%'
    },
    'Scottsdale, AZ': {
        left: '19%',
        top: '57%'
    },
    'Glendale, AZ': {
        left: '18%',
        top: '58%'
    },
    'Gilbert, AZ': {
        left: '19%',
        top: '59%'
    },
    'Little Rock, AR': {
        left: '55%',
        top: '60%'
    },
    'Fayetteville, AR': {
        left: '53%',
        top: '56%'
    },
    'Los Angeles, CA': {
        left: '10%',
        top: '55%'
    },
    'San Francisco, CA': {
        left: '5%',
        top: '43%'
    },
    'San Diego, CA': {
        left: '11%',
        top: '60%'
    },
    'San Jose, CA': {
        left: '6%',
        top: '45%'
    },
    'Sacramento, CA': {
        left: '6%',
        top: '40%'
    },
    'Fresno, CA': {
        left: '8%',
        top: '50%'
    },
    'Long Beach, CA': {
        left: '10%',
        top: '56%'
    },
    'Oakland, CA': {
        left: '5%',
        top: '43%'
    },
    'Bakersfield, CA': {
        left: '9%',
        top: '52%'
    },
    'Anaheim, CA': {
        left: '11%',
        top: '56%'
    },
    'Santa Ana, CA': {
        left: '11%',
        top: '57%'
    },
    'Riverside, CA': {
        left: '12%',
        top: '56%'
    },
    'Stockton, CA': {
        left: '7%',
        top: '42%'
    },
    'Irvine, CA': {
        left: '11%',
        top: '57%'
    },
    'Chula Vista, CA': {
        left: '11%',
        top: '61%'
    },
    'Fremont, CA': {
        left: '6%',
        top: '44%'
    },
    'Denver, CO': {
        left: '35%',
        top: '43%'
    },
    'Colorado Springs, CO': {
        left: '35%',
        top: '45%'
    },
    'Aurora, CO': {
        left: '36%',
        top: '43%'
    },
    'Fort Collins, CO': {
        left: '35%',
        top: '40%'
    },
    'Bridgeport, CT': {
        left: '84%',
        top: '28%'
    },
    'New Haven, CT': {
        left: '84%',
        top: '27%'
    },
    'Hartford, CT': {
        left: '84%',
        top: '26%'
    },
    'Stamford, CT': {
        left: '83%',
        top: '28%'
    },
    'Wilmington, DE': {
        left: '79%',
        top: '32%'
    },
    'Dover, DE': {
        left: '79%',
        top: '34%'
    },
    'Newark, DE': {
        left: '78%',
        top: '32%'
    },
    'Washington, DC': {
        left: '77%',
        top: '38%'
    },
    'Jacksonville, FL': {
        left: '76%',
        top: '72%'
    },
    'Miami, FL': {
        left: '84%',
        top: '87%'
    },
    'Tampa, FL': {
        left: '79%',
        top: '82%'
    },
    'Orlando, FL': {
        left: '80%',
        top: '80%'
    },
    'St. Petersburg, FL': {
        left: '78%',
        top: '82%'
    },
    'Hialeah, FL': {
        left: '84%',
        top: '86%'
    },
    'Tallahassee, FL': {
        left: '72%',
        top: '70%'
    },
    'Fort Lauderdale, FL': {
        left: '84%',
        top: '85%'
    },
    'Sanford, FL': {
        left: '80%',
        top: '78%'
    },
    'Lake Mary, FL': {
        left: '80%',
        top: '79%'
    },
    'Atlanta, GA': {
        left: '70%',
        top: '60%'
    },
    'Augusta, GA': {
        left: '73%',
        top: '62%'
    },
    'Columbus, GA': {
        left: '69%',
        top: '65%'
    },
    'Savannah, GA': {
        left: '75%',
        top: '64%'
    },
    'Honolulu, HI': {
        left: '30%',
        top: '90%'
    },
    'Boise, ID': {
        left: '18%',
        top: '25%'
    },
    'Chicago, IL': {
        left: '62%',
        top: '32%'
    },
    'Aurora, IL': {
        left: '61%',
        top: '32%'
    },
    'Rockford, IL': {
        left: '60%',
        top: '30%'
    },
    'Joliet, IL': {
        left: '61%',
        top: '33%'
    },
    'Springfield, IL': {
        left: '60%',
        top: '38%'
    },
    'Indianapolis, IN': {
        left: '64%',
        top: '38%'
    },
    'Fort Wayne, IN': {
        left: '65%',
        top: '35%'
    },
    'Des Moines, IA': {
        left: '55%',
        top: '35%'
    },
    'Cedar Rapids, IA': {
        left: '56%',
        top: '34%'
    },
    'Wichita, KS': {
        left: '48%',
        top: '48%'
    },
    'Overland Park, KS': {
        left: '52%',
        top: '43%'
    },
    'Kansas City, KS': {
        left: '52%',
        top: '42%'
    },
    'Louisville, KY': {
        left: '64%',
        top: '45%'
    },
    'Lexington, KY': {
        left: '65%',
        top: '44%'
    },
    'New Orleans, LA': {
        left: '60%',
        top: '78%'
    },
    'Baton Rouge, LA': {
        left: '58%',
        top: '76%'
    },
    'Shreveport, LA': {
        left: '54%',
        top: '68%'
    },
    'Portland, ME': {
        left: '89%',
        top: '18%'
    },
    'Lewiston, ME': {
        left: '88%',
        top: '17%'
    },
    'Bangor, ME': {
        left: '89%',
        top: '15%'
    },
    'Baltimore, MD': {
        left: '79%',
        top: '36%'
    },
    'Annapolis, MD': {
        left: '79%',
        top: '37%'
    },
    'Boston, MA': {
        left: '87%',
        top: '22%'
    },
    'Worcester, MA': {
        left: '86%',
        top: '22%'
    },
    'Springfield, MA': {
        left: '85%',
        top: '23%'
    },
    'Detroit, MI': {
        left: '67%',
        top: '30%'
    },
    'Grand Rapids, MI': {
        left: '64%',
        top: '28%'
    },
    'Warren, MI': {
        left: '67%',
        top: '29%'
    },
    'Lansing, MI': {
        left: '65%',
        top: '30%'
    },
    'Minneapolis, MN': {
        left: '53%',
        top: '20%'
    },
    'Saint Paul, MN': {
        left: '53%',
        top: '20%'
    },
    'Rochester, MN': {
        left: '54%',
        top: '22%'
    },
    'Jackson, MS': {
        left: '60%',
        top: '68%'
    },
    'Ridgeland, MS': {
        left: '60%',
        top: '67%'
    },
    'Gulfport, MS': {
        left: '61%',
        top: '75%'
    },
    'Euless, TX': {
        left: '47.5%',
        top: '65%'
    },
    'Richardson, TX': {
        left: '49%',
        top: '64%'
    },
    'Allen, TX': {
        left: '49%',
        top: '63%'
    },
    'Henderson, TX': {
        left: '52%',
        top: '68%'
    },
    'Kansas City, MO': {
        left: '52%',
        top: '42%'
    },
    'St. Louis, MO': {
        left: '58%',
        top: '42%'
    },
    'Springfield, MO': {
        left: '54%',
        top: '48%'
    },
    'Billings, MT': {
        left: '32%',
        top: '18%'
    },
    'Missoula, MT': {
        left: '26%',
        top: '15%'
    },
    'Helena, MT': {
        left: '28%',
        top: '15%'
    },
    'Omaha, NE': {
        left: '50%',
        top: '35%'
    },
    'Lincoln, NE': {
        left: '49%',
        top: '36%'
    },
    'Las Vegas, NV': {
        left: '15%',
        top: '50%'
    },
    'Henderson, NV': {
        left: '15%',
        top: '51%'
    },
    'Reno, NV': {
        left: '7%',
        top: '35%'
    },
    'North Las Vegas, NV': {
        left: '15%',
        top: '49%'
    },
    'Manchester, NH': {
        left: '86%',
        top: '21%'
    },
    'Nashua, NH': {
        left: '86%',
        top: '22%'
    },
    'Concord, NH': {
        left: '86%',
        top: '20%'
    },
    'Newark, NJ': {
        left: '82%',
        top: '27%'
    },
    'Jersey City, NJ': {
        left: '82%',
        top: '26%'
    },
    'Paterson, NJ': {
        left: '82%',
        top: '25%'
    },
    'Trenton, NJ': {
        left: '81%',
        top: '30%'
    },
    'Sewell, NJ': {
        left: '81%',
        top: '31%'
    },
    'Albuquerque, NM': {
        left: '32%',
        top: '58%'
    },
    'Las Cruces, NM': {
        left: '31%',
        top: '65%'
    },
    'Santa Fe, NM': {
        left: '33%',
        top: '55%'
    },
    'New York, NY': {
        left: '82%',
        top: '26%'
    },
    'Buffalo, NY': {
        left: '76%',
        top: '25%'
    },
    'Rochester, NY': {
        left: '78%',
        top: '23%'
    },
    'Yonkers, NY': {
        left: '82%',
        top: '25%'
    },
    'Syracuse, NY': {
        left: '79%',
        top: '23%'
    },
    'Albany, NY': {
        left: '81%',
        top: '22%'
    },
    'Charlotte, NC': {
        left: '74%',
        top: '50%'
    },
    'Raleigh, NC': {
        left: '76%',
        top: '48%'
    },
    'Greensboro, NC': {
        left: '74%',
        top: '48%'
    },
    'Durham, NC': {
        left: '76%',
        top: '48%'
    },
    "Winston\u2013Salem, NC": {
        left: '74%',
        top: '47%'
    },
    'Fargo, ND': {
        left: '48%',
        top: '15%'
    },
    'Bismarck, ND': {
        left: '43%',
        top: '15%'
    },
    'Columbus, OH': {
        left: '68%',
        top: '38%'
    },
    'Cleveland, OH': {
        left: '70%',
        top: '32%'
    },
    'Cincinnati, OH': {
        left: '66%',
        top: '40%'
    },
    'Toledo, OH': {
        left: '68%',
        top: '31%'
    },
    'Akron, OH': {
        left: '69%',
        top: '33%'
    },
    'Brook Park, OH': {
        left: '70%',
        top: '32%'
    },
    'Oklahoma City, OK': {
        left: '48%',
        top: '58%'
    },
    'Tulsa, OK': {
        left: '50%',
        top: '55%'
    },
    'Norman, OK': {
        left: '48%',
        top: '59%'
    },
    'Portland, OR': {
        left: '9%',
        top: '15%'
    },
    'The Dalles, OR': {
        left: '12%',
        top: '15%'
    },
    'Salem, OR': {
        left: '8%',
        top: '18%'
    },
    'Eugene, OR': {
        left: '8%',
        top: '20%'
    },
    'Philadelphia, PA': {
        left: '80%',
        top: '30%'
    },
    'Pittsburgh, PA': {
        left: '74%',
        top: '32%'
    },
    'Allentown, PA': {
        left: '80%',
        top: '28%'
    },
    'Erie, PA': {
        left: '75%',
        top: '26%'
    },
    'Chadds Ford, PA': {
        left: '79%',
        top: '31%'
    },
    'Clifton Heights, PA': {
        left: '80%',
        top: '30%'
    },
    'Harrisburg, PA': {
        left: '78%',
        top: '30%'
    },
    'Providence, RI': {
        left: '86%',
        top: '25%'
    },
    'Warwick, RI': {
        left: '86%',
        top: '26%'
    },
    'Charleston, SC': {
        left: '76%',
        top: '58%'
    },
    'Columbia, SC': {
        left: '74%',
        top: '55%'
    },
    'Greenville, SC': {
        left: '72%',
        top: '52%'
    },
    'Sioux Falls, SD': {
        left: '48%',
        top: '25%'
    },
    'Rapid City, SD': {
        left: '42%',
        top: '25%'
    },
    'Pierre, SD': {
        left: '44%',
        top: '22%'
    },
    'Nashville, TN': {
        left: '65%',
        top: '52%'
    },
    'Memphis, TN': {
        left: '58%',
        top: '55%'
    },
    'Knoxville, TN': {
        left: '68%',
        top: '50%'
    },
    'Chattanooga, TN': {
        left: '67%',
        top: '55%'
    },
    'Houston, TX': {
        left: '49%',
        top: '75%'
    },
    'San Antonio, TX': {
        left: '45%',
        top: '78%'
    },
    'Dallas, TX': {
        left: '48%',
        top: '65%'
    },
    'Austin, TX': {
        left: '46%',
        top: '72%'
    },
    'Fort Worth, TX': {
        left: '47%',
        top: '65%'
    },
    'El Paso, TX': {
        left: '30%',
        top: '70%'
    },
    'Arlington, TX': {
        left: '48%',
        top: '65%'
    },
    'Corpus Christi, TX': {
        left: '48%',
        top: '85%'
    },
    'Plano, TX': {
        left: '48%',
        top: '64%'
    },
    'Laredo, TX': {
        left: '43%',
        top: '88%'
    },
    'Lubbock, TX': {
        left: '40%',
        top: '65%'
    },
    'Garland, TX': {
        left: '49%',
        top: '65%'
    },
    'Irving, TX': {
        left: '48%',
        top: '65%'
    },
    'Richmond, TX': {
        left: '49%',
        top: '75%'
    },
    'Salt Lake City, UT': {
        left: '25%',
        top: '40%'
    },
    'West Valley City, UT': {
        left: '25%',
        top: '41%'
    },
    'Provo, UT': {
        left: '26%',
        top: '42%'
    },
    'Burlington, VT': {
        left: '83%',
        top: '18%'
    },
    'Montpelier, VT': {
        left: '84%',
        top: '19%'
    },
    'Virginia Beach, VA': {
        left: '80%',
        top: '44%'
    },
    'Norfolk, VA': {
        left: '80%',
        top: '45%'
    },
    'Chesapeake, VA': {
        left: '80%',
        top: '46%'
    },
    'Richmond, VA': {
        left: '79%',
        top: '42%'
    },
    'Arlington, VA': {
        left: '78%',
        top: '38%'
    },
    'Seattle, WA': {
        left: '11%',
        top: '7%'
    },
    'Spokane, WA': {
        left: '16%',
        top: '8%'
    },
    'Tacoma, WA': {
        left: '11%',
        top: '8%'
    },
    'Vancouver, WA': {
        left: '9%',
        top: '14%'
    },
    'Charleston, WV': {
        left: '72%',
        top: '42%'
    },
    'Huntington, WV': {
        left: '70%',
        top: '41%'
    },
    'Milwaukee, WI': {
        left: '62%',
        top: '28%'
    },
    'Madison, WI': {
        left: '60%',
        top: '28%'
    },
    'Green Bay, WI': {
        left: '62%',
        top: '25%'
    },
    'Cheyenne, WY': {
        left: '35%',
        top: '35%'
    },
    'Casper, WY': {
        left: '33%',
        top: '30%'
    },
    'Unknown': {
        left: '50%',
        top: '50%'
    }
};
const $a97e8c48f36eb07f$var$getCityCoordinates = (city, region, lat, lng)=>{
    // 1. Try hardcoded database first for precision
    const label = region ? `${city}, ${region}` : city;
    if ($a97e8c48f36eb07f$var$CITY_COORDINATES[label]) return $a97e8c48f36eb07f$var$CITY_COORDINATES[label];
    if ($a97e8c48f36eb07f$var$CITY_COORDINATES[city]) return $a97e8c48f36eb07f$var$CITY_COORDINATES[city];
    // 2. If we have lat/lng, use mathematical projection
    if (lat && lng && lat !== 0 && lng !== 0) {
        // Alaska
        if (lat > 50 && lng < -130) return {
            left: `${(lng + 170) / 40 * 15 + 10}%`,
            top: `${(lat - 50) / 20 * 10 + 75}%`
        };
        // Hawaii
        if (lat < 25 && lng < -140) return {
            left: `${(lng + 160) / 10 * 10 + 25}%`,
            top: `${(lat - 18) / 7 * 10 + 85}%`
        };
        // Contiguous US (Linear approximation for the SVG map)
        const left = (lng + 125) / 58 * 85 + 5;
        const top = (lat - 50) / -26 * 90 + 5;
        // Clamp values to stay within map bounds
        return {
            left: `${Math.max(5, Math.min(95, left))}%`,
            top: `${Math.max(5, Math.min(95, top))}%`
        };
    }
    return null;
};
const $a97e8c48f36eb07f$var$useDarkMode = ()=>{
    const [isDark, setIsDark] = (0, $ccwsP$useState)(()=>{
        if (typeof document !== 'undefined') return document.documentElement.classList.contains('dark');
        return false;
    });
    (0, $ccwsP$useEffect)(()=>{
        if (typeof document === 'undefined') return;
        const observer = new MutationObserver((mutations)=>{
            mutations.forEach((mutation)=>{
                if (mutation.attributeName === 'class') setIsDark(document.documentElement.classList.contains('dark'));
            });
        });
        observer.observe(document.documentElement, {
            attributes: true
        });
        setIsDark(document.documentElement.classList.contains('dark'));
        return ()=>observer.disconnect();
    }, []);
    return isDark;
};
const $a97e8c48f36eb07f$var$CustomTooltip = ({ active: active, payload: payload, label: label })=>{
    if (active && payload && payload.length) return /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
        className: "bg-white dark:bg-slate-800 p-3 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 outline-none min-w-[150px]",
        children: [
            /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                className: "text-xs font-semibold text-slate-500 dark:text-slate-400 mb-2 border-b border-slate-100 dark:border-slate-700 pb-1 truncate max-w-[200px]",
                children: label
            }),
            payload.map((entry, index)=>{
                const color = entry.color && typeof entry.color === 'string' && entry.color.startsWith('url') ? '#6366f1' : entry.color || entry.fill;
                return /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                    className: "flex items-center gap-2 text-sm font-bold text-slate-800 dark:text-slate-200",
                    children: [
                        /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                            className: "w-2 h-2 rounded-full",
                            style: {
                                backgroundColor: color
                            }
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsxs)("span", {
                            className: "capitalize",
                            children: [
                                entry.name,
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                            children: entry.value
                        })
                    ]
                }, index);
            })
        ]
    });
    return null;
};
function $a97e8c48f36eb07f$var$usePersistentState(key, initialValue) {
    const [state, setState] = (0, $ccwsP$useState)(()=>{
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            return initialValue;
        }
    });
    (0, $ccwsP$useEffect)(()=>{
        window.localStorage.setItem(key, JSON.stringify(state));
    }, [
        key,
        state
    ]);
    return [
        state,
        setState
    ];
}
const $a97e8c48f36eb07f$var$FilterDropdown = ({ value: value, onChange: onChange, id: id })=>{
    const [isOpen, setIsOpen] = (0, $ccwsP$useState)(false);
    const ref = (0, $ccwsP$useRef)(null);
    const { t: t } = (0, $72ad5ad77b58d1fe$export$c1fd9f444a3dc711)();
    (0, $ccwsP$useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (ref.current && !ref.current.contains(event.target)) setIsOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    const labels = {
        today: t.today,
        week: t.week,
        month: t.month,
        year: t.year,
        custom: t.custom
    };
    return /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
        className: "relative",
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                onClick: (e)=>{
                    e.preventDefault();
                    setIsOpen(!isOpen);
                },
                className: "flex items-center gap-1 text-xs font-bold text-slate-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors",
                children: [
                    labels[value],
                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ChevronDown), {
                        size: 14,
                        strokeWidth: 2.5
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                className: "absolute right-0 top-full mt-2 w-32 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 z-50 py-1 overflow-hidden animate-in fade-in zoom-in-95 duration-100",
                children: Object.keys(labels).map((key)=>/*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                        onClick: ()=>{
                            onChange(key);
                            setIsOpen(false);
                        },
                        className: `w-full text-left px-4 py-2.5 text-xs font-medium transition-colors ${value === key ? 'bg-indigo-50 dark:bg-indigo-900/20 text-indigo-600 dark:text-indigo-400' : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700'}`,
                        children: labels[key]
                    }, key))
            })
        ]
    });
};
const $a97e8c48f36eb07f$var$Report = ({ readOnly: readOnly = false })=>{
    const { id: id } = (0, $ccwsP$useParams)();
    const [domain, setDomain] = (0, $ccwsP$useState)(undefined);
    const [events, setEvents] = (0, $ccwsP$useState)([]);
    const { t: t, language: language } = (0, $72ad5ad77b58d1fe$export$c1fd9f444a3dc711)();
    const isDark = $a97e8c48f36eb07f$var$useDarkMode();
    const [showEmbedModal, setShowEmbedModal] = (0, $ccwsP$useState)(false);
    const [showLinkBuilder, setShowLinkBuilder] = (0, $ccwsP$useState)(false);
    const [showShareModal, setShowShareModal] = (0, $ccwsP$useState)(false);
    const [isLoading, setIsLoading] = (0, $ccwsP$useState)(true);
    const [error, setError] = (0, $ccwsP$useState)(null);
    const [lbSource, setLbSource] = (0, $ccwsP$useState)('');
    const [lbCopied, setLbCopied] = (0, $ccwsP$useState)(false);
    const [shareCopied, setShareCopied] = (0, $ccwsP$useState)(false);
    const [userRole, setUserRole] = (0, $ccwsP$useState)('user');
    // Persistent Filter States
    const [quickStatsFilter, setQuickStatsFilter] = $a97e8c48f36eb07f$var$usePersistentState(`filter_qs_${id}`, 'month');
    const [visitFilter, setVisitFilter] = $a97e8c48f36eb07f$var$usePersistentState(`filter_visit_${id}`, 'month');
    const [pageViewFilter, setPageViewFilter] = $a97e8c48f36eb07f$var$usePersistentState(`filter_pv_${id}`, 'today');
    const [sourceFilter, setSourceFilter] = $a97e8c48f36eb07f$var$usePersistentState(`filter_source_${id}`, 'month');
    const [insightsFilter, setInsightsFilter] = $a97e8c48f36eb07f$var$usePersistentState(`filter_insights_${id}`, 'month');
    const [deviceFilter, setDeviceFilter] = $a97e8c48f36eb07f$var$usePersistentState(`filter_device_${id}`, 'month');
    const [cityFilter, setCityFilter] = $a97e8c48f36eb07f$var$usePersistentState(`filter_city_${id}`, 'month');
    const [topPagesFilter, setTopPagesFilter] = $a97e8c48f36eb07f$var$usePersistentState(`filter_top_pages_${id}`, 'month');
    const [excludeBots, setExcludeBots] = $a97e8c48f36eb07f$var$usePersistentState(`exclude_bots_${id}`, true);
    // Custom Date States
    const [customDates, setCustomDates] = $a97e8c48f36eb07f$var$usePersistentState(`custom_dates_${id}`, {});
    const updateCustomDate = (filterId, field, value)=>{
        setCustomDates((prev)=>({
                ...prev,
                [filterId]: {
                    ...prev[filterId] || {
                        start: '',
                        end: ''
                    },
                    [field]: value
                }
            }));
    };
    const chartCursor = (0, $ccwsP$useMemo)(()=>({
            fill: isDark ? '#1e293b' : '#f1f5f9',
            opacity: 0.6
        }), [
        isDark
    ]);
    const baseEvents = (0, $ccwsP$useMemo)(()=>{
        if (!excludeBots) return events;
        return events.filter((e)=>{
            const city = e.city ? decodeURIComponent(e.city) : '';
            const region = e.region ? decodeURIComponent(e.region) : '';
            return !(city === 'Omaha' && region === 'NE') && !(city === 'The Dalles' && region === 'OR');
        });
    }, [
        events,
        excludeBots
    ]);
    (0, $ccwsP$useEffect)(()=>{
        const fetchData = async ()=>{
            if (id) {
                setIsLoading(true);
                setError(null);
                try {
                    const d = await (0, $2abee34d7f7177c9$export$34f4c9b2cab9611c)(id);
                    if (!d) {
                        setError("Domain not found.");
                        setIsLoading(false);
                        return;
                    }
                    setDomain(d);
                    const e = await (0, $2abee34d7f7177c9$export$3f41ece7d7128238)(id);
                    setEvents(e);
                    // Fetch user role
                    if ((0, $09b8c58f557d578f$export$73693bad9f5880b0).currentUser) {
                        const role = await (0, $2abee34d7f7177c9$export$c33a4269214e2ec4)((0, $09b8c58f557d578f$export$73693bad9f5880b0).currentUser.uid);
                        setUserRole(role);
                    }
                } catch (err) {
                    console.error("Error loading report:", err);
                    setError(err.message || "Failed to load report data.");
                } finally{
                    setIsLoading(false);
                }
            }
        };
        fetchData();
    }, [
        id
    ]);
    (0, $ccwsP$useEffect)(()=>{
        if (!id || error) return;
        const interval = setInterval(async ()=>{
            try {
                const latestEvents = await (0, $2abee34d7f7177c9$export$3f41ece7d7128238)(id);
                setEvents((prev)=>{
                    if (prev.length !== latestEvents.length) return latestEvents;
                    return prev;
                });
            } catch (e) {
                console.warn("Auto-refresh failed", e);
            }
        }, 5000);
        return ()=>clearInterval(interval);
    }, [
        id,
        error
    ]);
    const filterEventsByTime = (allEvents, range, filterId)=>{
        const now = new Date();
        const startTime = new Date();
        let endTime = now.getTime();
        if (range === 'today') startTime.setHours(0, 0, 0, 0);
        else if (range === 'week') startTime.setDate(now.getDate() - 7);
        else if (range === 'month') startTime.setMonth(now.getMonth() - 1);
        else if (range === 'year') startTime.setFullYear(now.getFullYear() - 1);
        else if (range === 'custom' && filterId) {
            const defaultRange = {
                start: new Date(Date.now() - 604800000).toISOString().split('T')[0],
                end: new Date().toISOString().split('T')[0]
            };
            const dates = {
                start: customDates[filterId]?.start || defaultRange.start,
                end: customDates[filterId]?.end || defaultRange.end
            };
            const start = new Date(dates.start);
            const end = new Date(dates.end);
            end.setHours(23, 59, 59, 999);
            return allEvents.filter((e)=>e.timestamp >= start.getTime() && e.timestamp <= end.getTime());
        }
        const threshold = startTime.getTime();
        return allEvents.filter((e)=>e.timestamp >= threshold && e.timestamp <= endTime);
    };
    const getChartData = (filteredEvents, range, filterId)=>{
        if (range === 'today') {
            const buckets = new Array(24).fill(0);
            filteredEvents.forEach((e)=>{
                const h = new Date(e.timestamp).getHours();
                buckets[h]++;
            });
            return buckets.map((val, h)=>({
                    name: h === 0 ? '12am' : h === 12 ? '12pm' : h > 12 ? `${h - 12}pm` : `${h}am`,
                    value: val
                }));
        } else if (range === 'year') {
            const buckets = new Array(12).fill(0);
            filteredEvents.forEach((e)=>{
                const m = new Date(e.timestamp).getMonth();
                buckets[m]++;
            });
            return buckets.map((val, m)=>({
                    name: $a97e8c48f36eb07f$var$MONTHS[m],
                    value: val
                }));
        } else {
            const daysMap = {};
            const now = new Date();
            let daysToShow = range === 'week' ? 7 : 30;
            let startD = new Date();
            startD.setDate(now.getDate() - (daysToShow - 1));
            if (range === 'custom' && filterId) {
                const defaultRange = {
                    start: new Date(Date.now() - 604800000).toISOString().split('T')[0],
                    end: new Date().toISOString().split('T')[0]
                };
                const dates = {
                    start: customDates[filterId]?.start || defaultRange.start,
                    end: customDates[filterId]?.end || defaultRange.end
                };
                const start = new Date(dates.start);
                const end = new Date(dates.end);
                const diffTime = Math.abs(end.getTime() - start.getTime());
                daysToShow = Math.ceil(diffTime / 86400000) + 1;
                startD = new Date(start);
            }
            for(let i = 0; i < daysToShow; i++){
                const d = new Date(startD);
                d.setDate(startD.getDate() + i);
                const key = `${d.getMonth() + 1}/${d.getDate()}`;
                daysMap[key] = 0;
            }
            filteredEvents.forEach((e)=>{
                const d = new Date(e.timestamp);
                const key = `${d.getMonth() + 1}/${d.getDate()}`;
                if (daysMap[key] !== undefined) daysMap[key]++;
            });
            return Object.keys(daysMap).map((key)=>({
                    name: key,
                    value: daysMap[key]
                }));
        }
    };
    // --- Real Stats Calculation ---
    const quickFilteredEvents = (0, $ccwsP$useMemo)(()=>filterEventsByTime(baseEvents, quickStatsFilter, 'quick'), [
        baseEvents,
        quickStatsFilter,
        customDates
    ]);
    const quickSessions = quickFilteredEvents.length;
    const quickUniqueUsers = (0, $ccwsP$useMemo)(()=>{
        const ips = new Set();
        quickFilteredEvents.forEach((e)=>{
            if (e.ip) ips.add(e.ip);
        });
        return ips.size || Math.round(quickSessions * 0.7);
    }, [
        quickFilteredEvents,
        quickSessions
    ]);
    const quickBounceRate = (0, $ccwsP$useMemo)(()=>{
        if (quickSessions === 0) return 0;
        const ipCounts = {};
        quickFilteredEvents.forEach((e)=>{
            if (e.ip) ipCounts[e.ip] = (ipCounts[e.ip] || 0) + 1;
        });
        const singleActionIps = Object.values(ipCounts).filter((count)=>count === 1).length;
        const totalIps = Object.keys(ipCounts).length || 1;
        return singleActionIps / totalIps * 100;
    }, [
        quickFilteredEvents,
        quickSessions
    ]);
    const quickAvgDuration = (0, $ccwsP$useMemo)(()=>{
        if (quickFilteredEvents.length === 0) return "0s";
        const sessions = {};
        quickFilteredEvents.forEach((e)=>{
            if (!e.ip) return;
            if (!sessions[e.ip]) sessions[e.ip] = {
                min: e.timestamp,
                max: e.timestamp
            };
            else {
                sessions[e.ip].min = Math.min(sessions[e.ip].min, e.timestamp);
                sessions[e.ip].max = Math.max(sessions[e.ip].max, e.timestamp);
            }
        });
        const durations = Object.values(sessions).map((s)=>s.max - s.min).filter((d)=>d > 0);
        if (durations.length === 0) return "0s";
        const avgMs = durations.reduce((acc, d)=>acc + d, 0) / durations.length;
        const totalSeconds = Math.floor(avgMs / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        if (minutes > 0) return `${minutes}m ${seconds}s`;
        return `${seconds}s`;
    }, [
        quickFilteredEvents
    ]);
    const currentVisitEvents = (0, $ccwsP$useMemo)(()=>filterEventsByTime(baseEvents, visitFilter, 'visit'), [
        baseEvents,
        visitFilter,
        customDates
    ]);
    const visitByDayData = (0, $ccwsP$useMemo)(()=>getChartData(currentVisitEvents, visitFilter, 'visit'), [
        currentVisitEvents,
        visitFilter,
        customDates
    ]);
    const pageViewsEvents = (0, $ccwsP$useMemo)(()=>filterEventsByTime(baseEvents, pageViewFilter, 'pv'), [
        baseEvents,
        pageViewFilter,
        customDates
    ]);
    const pageViewsData = (0, $ccwsP$useMemo)(()=>getChartData(pageViewsEvents, pageViewFilter, 'pv'), [
        pageViewsEvents,
        pageViewFilter,
        customDates
    ]);
    const totalPageViewsValue = (0, $ccwsP$useMemo)(()=>pageViewsData.reduce((acc, curr)=>acc + curr.value, 0), [
        pageViewsData
    ]);
    const filteredSourceEvents = (0, $ccwsP$useMemo)(()=>filterEventsByTime(baseEvents, sourceFilter, 'source'), [
        baseEvents,
        sourceFilter,
        customDates
    ]);
    const sourceData = (0, $ccwsP$useMemo)(()=>{
        const counts = {};
        filteredSourceEvents.forEach((e)=>{
            const rawSource = e.source || 'direct';
            const s = rawSource.charAt(0).toUpperCase() + rawSource.slice(1);
            counts[s] = (counts[s] || 0) + 1;
        });
        return Object.entries(counts).map(([name, value])=>({
                name: name,
                value: value
            })).sort((a, b)=>b.value - a.value).slice(0, 6);
    }, [
        filteredSourceEvents
    ]);
    const filteredInsightsEvents = (0, $ccwsP$useMemo)(()=>filterEventsByTime(baseEvents, insightsFilter, 'insights'), [
        baseEvents,
        insightsFilter,
        customDates
    ]);
    const timeActivityData = (0, $ccwsP$useMemo)(()=>{
        const grid = Array(7).fill(null).map(()=>Array(24).fill(0));
        let max = 0;
        filteredInsightsEvents.forEach((e)=>{
            const d = new Date(e.timestamp);
            const day = d.getDay();
            const hour = d.getHours();
            if (grid[day] && grid[day][hour] !== undefined) {
                grid[day][hour]++;
                if (grid[day][hour] > max) max = grid[day][hour];
            }
        });
        return {
            grid: grid,
            max: max
        };
    }, [
        filteredInsightsEvents
    ]);
    const filteredDeviceEvents = (0, $ccwsP$useMemo)(()=>filterEventsByTime(baseEvents, deviceFilter, 'device'), [
        baseEvents,
        deviceFilter,
        customDates
    ]);
    const deviceRadarData = (0, $ccwsP$useMemo)(()=>{
        const counts = {
            'Desktop': 0,
            'Mobile': 0,
            'Tablet': 0
        };
        filteredDeviceEvents.forEach((e)=>{
            const type = e.deviceType || 'desktop';
            const key = type.charAt(0).toUpperCase() + type.slice(1);
            counts[key] = (counts[key] || 0) + 1;
        });
        const total = filteredDeviceEvents.length || 1;
        return [
            {
                subject: 'Desktop',
                A: counts['Desktop'],
                fullMark: total
            },
            {
                subject: 'Mobile',
                A: counts['Mobile'],
                fullMark: total
            },
            {
                subject: 'Tablet',
                A: counts['Tablet'],
                fullMark: total
            },
            {
                subject: 'Other',
                A: 0,
                fullMark: total
            }
        ];
    }, [
        filteredDeviceEvents
    ]);
    const filteredCityEvents = (0, $ccwsP$useMemo)(()=>filterEventsByTime(baseEvents, cityFilter, 'city'), [
        baseEvents,
        cityFilter,
        customDates
    ]);
    const cityCalculations = (0, $ccwsP$useMemo)(()=>{
        const counts = {};
        filteredCityEvents.forEach((e)=>{
            if (e.country !== 'US' || !e.city || e.city === 'Unknown') return;
            const cleanCity = decodeURIComponent(e.city);
            const cleanRegion = e.region && e.region !== 'Unknown' ? decodeURIComponent(e.region) : '';
            let label = cleanCity;
            if (cleanRegion) label = `${cleanCity}, ${cleanRegion}`;
            if (!counts[label]) counts[label] = {
                value: 0,
                lat: e.latitude,
                lng: e.longitude,
                city: cleanCity,
                region: cleanRegion
            };
            counts[label].value++;
        });
        return Object.entries(counts).map(([name, data])=>({
                name: name,
                value: data.value,
                lat: data.lat,
                lng: data.lng,
                city: data.city,
                region: data.region
            })).sort((a, b)=>b.value - a.value);
    }, [
        filteredCityEvents
    ]);
    const cityData = (0, $ccwsP$useMemo)(()=>cityCalculations.slice(0, 5), [
        cityCalculations
    ]);
    const topPagesData = (0, $ccwsP$useMemo)(()=>{
        const stats = {};
        const subset = filterEventsByTime(baseEvents, topPagesFilter, 'topPages');
        subset.forEach((e)=>{
            let p = e.path || '/';
            if (p === '/' || p === '') p = 'Home Page';
            else if (p.startsWith('/')) p = p.substring(1);
            if (!stats[p]) stats[p] = {
                views: 0
            };
            stats[p].views++;
        });
        return Object.entries(stats).map(([page, { views: views }])=>({
                page: page,
                views: views,
                bounceRate: 20 + views % 60
            })).sort((a, b)=>b.views - a.views).slice(0, 5);
    }, [
        baseEvents,
        topPagesFilter,
        customDates
    ]);
    const topPagesChartData = (0, $ccwsP$useMemo)(()=>topPagesData.map((item)=>({
                name: item.page,
                value: item.views
            })), [
        topPagesData
    ]);
    const getSourceConfig = (sourceName)=>{
        const lower = sourceName.toLowerCase();
        if (lower.includes('facebook')) return {
            icon: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Facebook), {
                size: 16
            }),
            color: 'text-blue-600 bg-blue-50 dark:bg-blue-900/20 shadow-[0_0_8px_rgba(37,99,235,0.15)]'
        };
        if (lower.includes('instagram')) return {
            icon: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Instagram), {
                size: 16
            }),
            color: 'text-pink-600 bg-pink-50 dark:bg-pink-900/20 shadow-[0_0_8px_rgba(219,39,119,0.15)]'
        };
        if (lower.includes('google')) return {
            icon: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Chrome), {
                size: 16
            }),
            color: 'text-slate-600 bg-slate-50 dark:bg-slate-800 shadow-[0_0_8px_rgba(71,85,105,0.15)]'
        };
        if (lower.includes('yelp')) return {
            icon: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Star), {
                size: 16
            }),
            color: 'text-red-600 bg-red-50 dark:bg-red-900/20 shadow-[0_0_8px_rgba(220,38,38,0.15)]'
        };
        if (lower.includes('tiktok')) return {
            icon: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Video), {
                size: 16
            }),
            color: 'text-slate-900 bg-slate-100 dark:bg-slate-800 shadow-[0_0_8px_rgba(15,23,42,0.15)]'
        };
        if (lower.includes('direct')) return {
            icon: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ArrowRightCircle), {
                size: 16
            }),
            color: 'text-emerald-600 bg-emerald-50 dark:bg-emerald-900/20 shadow-[0_0_8px_rgba(5,150,105,0.15)]'
        };
        return {
            icon: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Globe), {
                size: 16
            }),
            color: 'text-slate-500 bg-slate-50 dark:bg-slate-800 shadow-[0_0_8_rgba(100,116,139,0.15)]'
        };
    };
    const sidebarContent = /*#__PURE__*/ (0, $ccwsP$jsxs)("nav", {
        className: "space-y-1",
        children: [
            /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $ccwsP$Link), {
                to: `/report/${id}`,
                className: "w-full flex items-center gap-3 px-4 py-3 rounded-xl bg-indigo-50 dark:bg-indigo-900/20 text-indigo-600 dark:text-indigo-400 font-semibold transition-colors",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Share2), {
                        size: 20
                    }),
                    t.analytics
                ]
            }),
            /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $ccwsP$Link), {
                to: `/report/${id}/gdpr-settings`,
                className: "w-full flex items-center gap-3 px-4 py-3 rounded-xl text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ShieldCheck), {
                        size: 20
                    }),
                    t.gdprSettings
                ]
            }),
            /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $ccwsP$Link), {
                to: `/report/${id}/accessibility`,
                className: "w-full flex items-center gap-3 px-4 py-3 rounded-xl text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Accessibility), {
                        size: 20
                    }),
                    t.accessibility
                ]
            }),
            /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                onClick: ()=>setShowShareModal(true),
                className: "w-full flex items-center gap-3 px-4 py-3 rounded-xl text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Globe), {
                        size: 20
                    }),
                    t.shareReport
                ]
            }),
            /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                onClick: ()=>setShowLinkBuilder(true),
                className: "w-full flex items-center gap-3 px-4 py-3 rounded-xl text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Link1), {
                        size: 20
                    }),
                    t.linkBuilder
                ]
            }),
            /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                onClick: ()=>setShowEmbedModal(true),
                className: "w-full flex items-center gap-3 px-4 py-3 rounded-xl text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Code), {
                        size: 20
                    }),
                    t.installCode
                ]
            })
        ]
    });
    if (isLoading) return /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
        className: "flex h-screen items-center justify-center dark:bg-slate-950",
        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Loader2), {
            className: "animate-spin text-indigo-600",
            size: 48
        })
    });
    if (!domain) return /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
        className: "p-8 dark:text-white",
        children: "Domain not found"
    });
    const cardClass = "bg-white dark:bg-slate-900 p-6 md:p-8 rounded-[32px] border border-slate-100 dark:border-slate-800 shadow-[0_0_20px_-5px_rgba(0,0,0,0.05)] dark:shadow-[0_0_20px_-5px_rgba(255,255,255,0.03)]";
    return /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $e7fcd481df4de8d7$export$c84671f46d6a1ca), {
        sidebarContent: !readOnly ? sidebarContent : undefined,
        hideNavigation: readOnly,
        children: [
            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                className: "max-w-7xl mx-auto pb-20",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: "bg-gradient-to-r from-indigo-600 to-purple-600 dark:from-indigo-900 dark:to-purple-900 rounded-[32px] p-6 md:p-12 text-white mb-8 relative overflow-hidden shadow-xl shadow-indigo-200 dark:shadow-none",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                className: "absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -mr-20 -mt-20 blur-3xl"
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                className: "absolute bottom-0 left-20 w-40 h-40 bg-white/10 rounded-full blur-2xl"
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: "relative z-10 flex flex-col md:flex-row items-center justify-between gap-6 md:gap-8 text-center md:text-left",
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "min-w-0",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("h1", {
                                                className: "text-2xl md:text-4xl font-bold mb-2 md:mb-3",
                                                children: t.welcomeBack
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("p", {
                                                className: "text-indigo-100 max-w-lg text-sm md:text-lg opacity-90 leading-relaxed",
                                                children: [
                                                    t.welcomeMessage,
                                                    " ",
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                        className: "font-bold text-white underline decoration-indigo-300",
                                                        children: domain.name
                                                    }),
                                                    ".",
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("br", {
                                                        className: "md:hidden"
                                                    }),
                                                    " ",
                                                    t.youHave,
                                                    " ",
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                        className: "font-bold text-white",
                                                        children: events.length
                                                    }),
                                                    " ",
                                                    t.newVisitsToday,
                                                    "."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                        className: "hidden md:block hover:scale-105 transition-transform duration-500 shrink-0",
                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                            className: "relative w-24 h-24 md:w-32 md:h-32 flex items-center justify-center",
                                            children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Rocket), {
                                                size: 80,
                                                className: "text-white drop-shadow-2xl -rotate-12"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: "mb-8",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: "flex flex-col md:flex-row md:items-center justify-between gap-4 mb-4 px-1",
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "flex items-center gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                                className: "text-lg md:text-xl font-bold text-slate-900 dark:text-white",
                                                children: t.quickView
                                            }),
                                            userRole === 'admin' && /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                                                onClick: ()=>setExcludeBots(!excludeBots),
                                                className: `flex items-center gap-2 px-3 py-1.5 rounded-full text-[10px] font-bold transition-all border ${excludeBots ? 'bg-indigo-50 border-indigo-200 text-indigo-600 dark:bg-indigo-900/40 dark:border-indigo-800 dark:text-indigo-400' : 'bg-slate-50 border-slate-200 text-slate-400 dark:bg-slate-800 dark:border-slate-700'}`,
                                                title: t.botTrafficDesc,
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ShieldCheck), {
                                                        size: 14
                                                    }),
                                                    t.excludeBots
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "flex flex-col items-end",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsx)($a97e8c48f36eb07f$var$FilterDropdown, {
                                                value: quickStatsFilter,
                                                onChange: setQuickStatsFilter,
                                                id: "quick"
                                            }),
                                            quickStatsFilter === 'custom' && /*#__PURE__*/ (0, $ccwsP$jsx)((0, $71516388373cffcd$export$39a935fa7fde4940), {
                                                filterId: "quick",
                                                customDates: customDates,
                                                updateCustomDate: updateCustomDate,
                                                labels: {
                                                    from: t.from,
                                                    to: t.to
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6",
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $83e73b5fa491e453$export$5833004b3f15c9b), {
                                        title: t.statUsers,
                                        tooltipTerm: "Users",
                                        value: quickUniqueUsers,
                                        trend: "4.11%",
                                        trendDirection: "up",
                                        trendLabel: quickStatsFilter,
                                        variant: "indigo",
                                        icon: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$User), {})
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $83e73b5fa491e453$export$5833004b3f15c9b), {
                                        title: t.statSessions,
                                        tooltipTerm: "Sessions",
                                        value: quickSessions,
                                        trend: "1.25%",
                                        trendDirection: "down",
                                        trendLabel: quickStatsFilter,
                                        variant: "blue",
                                        icon: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Activity), {})
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $83e73b5fa491e453$export$5833004b3f15c9b), {
                                        title: t.statDuration,
                                        tooltipTerm: "Avg. Duration",
                                        value: quickAvgDuration,
                                        trend: "0.35%",
                                        trendDirection: "down",
                                        trendLabel: quickStatsFilter,
                                        variant: "yellow",
                                        icon: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Timer), {})
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $83e73b5fa491e453$export$5833004b3f15c9b), {
                                        title: t.statBounceRate,
                                        tooltipTerm: "Bounce Rate",
                                        value: `${quickBounceRate.toFixed(1)}%`,
                                        trend: "1.14%",
                                        trendDirection: "up",
                                        trendLabel: quickStatsFilter,
                                        variant: "emerald",
                                        icon: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Zap), {})
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: "grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8 mb-8",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: `lg:col-span-2 ${cardClass} min-h-[320px] lg:min-h-[400px]`,
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "flex justify-between items-start mb-6 md:mb-8",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "flex items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                        className: "p-2 bg-indigo-50 dark:bg-indigo-900/30 rounded-lg text-indigo-600 dark:text-indigo-400 shadow-[0_0_8px_rgba(99,102,241,0.15)]",
                                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$MousePointer2), {
                                                            size: 18
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)((0, $9f258ebe77ccfbd1$export$eccda88c066b9b81), {
                                                                term: "Clicks Tracking",
                                                                children: /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                                                    className: "text-lg md:text-xl font-bold text-slate-900 dark:text-white",
                                                                    children: t.clicksTracking
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                                                className: "text-xs md:text-sm text-slate-500 dark:text-slate-400",
                                                                children: t.trafficOverview
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "flex flex-col items-end",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)($a97e8c48f36eb07f$var$FilterDropdown, {
                                                        value: visitFilter,
                                                        onChange: setVisitFilter,
                                                        id: "visit"
                                                    }),
                                                    visitFilter === 'custom' && /*#__PURE__*/ (0, $ccwsP$jsx)((0, $71516388373cffcd$export$39a935fa7fde4940), {
                                                        filterId: "visit",
                                                        customDates: customDates,
                                                        updateCustomDate: updateCustomDate,
                                                        labels: {
                                                            from: t.from,
                                                            to: t.to
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                        className: "h-[250px] lg:h-[300px] w-full",
                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ResponsiveContainer), {
                                            width: "100%",
                                            height: "100%",
                                            debounce: 50,
                                            children: /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $ccwsP$BarChart), {
                                                data: visitByDayData,
                                                barSize: 32,
                                                margin: {
                                                    top: 10,
                                                    right: 10,
                                                    left: -20,
                                                    bottom: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$CartesianGrid), {
                                                        strokeDasharray: "3 3",
                                                        vertical: false,
                                                        stroke: isDark ? "#334155" : "#e2e8f0",
                                                        strokeOpacity: 0.5
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$XAxis), {
                                                        dataKey: "name",
                                                        axisLine: false,
                                                        tickLine: false,
                                                        tick: {
                                                            fill: '#94a3b8',
                                                            fontSize: 10
                                                        },
                                                        dy: 10
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$YAxis), {
                                                        axisLine: false,
                                                        tickLine: false,
                                                        tick: {
                                                            fill: '#94a3b8',
                                                            fontSize: 10
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Tooltip), {
                                                        content: /*#__PURE__*/ (0, $ccwsP$jsx)($a97e8c48f36eb07f$var$CustomTooltip, {}),
                                                        cursor: chartCursor
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("defs", {
                                                        children: /*#__PURE__*/ (0, $ccwsP$jsxs)("linearGradient", {
                                                            id: "barGradient",
                                                            x1: "0",
                                                            y1: "0",
                                                            x2: "0",
                                                            y2: "1",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("stop", {
                                                                    offset: "0%",
                                                                    stopColor: "#6366f1"
                                                                }),
                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("stop", {
                                                                    offset: "100%",
                                                                    stopColor: "#818cf8",
                                                                    stopOpacity: 0.6
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Bar), {
                                                        dataKey: "value",
                                                        name: "Clicks",
                                                        fill: "url(#barGradient)",
                                                        radius: [
                                                            6,
                                                            6,
                                                            0,
                                                            0
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: `${cardClass} flex flex-col relative min-h-[320px] lg:min-h-[400px]`,
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "mb-6",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "flex items-center gap-3 mb-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                        className: "p-2 bg-indigo-50 dark:bg-indigo-900/30 rounded-lg text-indigo-600 dark:text-indigo-400 shadow-[0_0_8px_rgba(99,102,241,0.15)]",
                                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$PieChart), {
                                                            size: 18
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $9f258ebe77ccfbd1$export$eccda88c066b9b81), {
                                                        term: "Page Views",
                                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                                            className: "text-lg font-bold text-slate-700 dark:text-slate-200",
                                                            children: t.pageViews
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "flex items-baseline gap-3 mt-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("h2", {
                                                        className: "text-3xl md:text-4xl font-extrabold text-slate-900 dark:text-white",
                                                        children: totalPageViewsValue.toLocaleString()
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("span", {
                                                        className: "flex items-center text-xs font-bold text-emerald-500 bg-emerald-50 dark:bg-emerald-900/20 px-2 py-0.5 rounded-md",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ArrowUpRight), {
                                                                size: 12,
                                                                className: "mr-1"
                                                            }),
                                                            " 4.11%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                                className: "text-[10px] text-slate-400 mt-2 font-medium uppercase tracking-wider",
                                                children: "Visit By Day"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "absolute top-6 right-6 md:top-8 md:right-8 flex flex-col items-end",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsx)($a97e8c48f36eb07f$var$FilterDropdown, {
                                                value: pageViewFilter,
                                                onChange: setPageViewFilter,
                                                id: "pv"
                                            }),
                                            pageViewFilter === 'custom' && /*#__PURE__*/ (0, $ccwsP$jsx)((0, $71516388373cffcd$export$39a935fa7fde4940), {
                                                filterId: "pv",
                                                customDates: customDates,
                                                updateCustomDate: updateCustomDate,
                                                labels: {
                                                    from: t.from,
                                                    to: t.to
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                        className: "flex-1 min-h-[180px]",
                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ResponsiveContainer), {
                                            width: "100%",
                                            height: "100%",
                                            debounce: 50,
                                            children: /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $ccwsP$BarChart), {
                                                data: pageViewsData,
                                                margin: {
                                                    top: 10,
                                                    right: 10,
                                                    left: -25,
                                                    bottom: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$CartesianGrid), {
                                                        strokeDasharray: "3 3",
                                                        vertical: false,
                                                        stroke: isDark ? "#334155" : "#f1f5f9",
                                                        strokeOpacity: 0.5
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$XAxis), {
                                                        dataKey: "name",
                                                        axisLine: false,
                                                        tickLine: false,
                                                        tick: {
                                                            fill: '#94a3b8',
                                                            fontSize: 10
                                                        },
                                                        dy: 10
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$YAxis), {
                                                        axisLine: false,
                                                        tickLine: false,
                                                        tick: {
                                                            fill: '#94a3b8',
                                                            fontSize: 10
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Tooltip), {
                                                        content: /*#__PURE__*/ (0, $ccwsP$jsx)($a97e8c48f36eb07f$var$CustomTooltip, {}),
                                                        cursor: chartCursor
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Bar), {
                                                        dataKey: "value",
                                                        name: "Views",
                                                        radius: [
                                                            4,
                                                            4,
                                                            4,
                                                            4
                                                        ],
                                                        barSize: 14,
                                                        children: pageViewsData.map((entry, index)=>/*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Cell), {
                                                                fill: index % 2 === 0 ? '#6366f1' : '#fbbf24'
                                                            }, `cell-${index}`))
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: "grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8 mb-8",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: `${cardClass} flex flex-col min-h-[350px] lg:min-h-[400px] z-20`,
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "flex justify-between items-start mb-6",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "flex items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                        className: "p-2 bg-blue-50 dark:bg-blue-900/30 rounded-lg text-blue-600 dark:text-blue-400 shadow-[0_0_8px_rgba(37,99,235,0.15)]",
                                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Globe), {
                                                            size: 18
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)((0, $9f258ebe77ccfbd1$export$eccda88c066b9b81), {
                                                                term: "Where Customers From",
                                                                children: /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                                                    className: "text-lg md:text-xl font-bold text-slate-900 dark:text-white",
                                                                    children: t.whereCustomersFrom
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                                                className: "text-[10px] text-slate-400 mt-0.5",
                                                                children: t.topSources
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "flex flex-col items-end",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)($a97e8c48f36eb07f$var$FilterDropdown, {
                                                        value: sourceFilter,
                                                        onChange: setSourceFilter,
                                                        id: "source"
                                                    }),
                                                    sourceFilter === 'custom' && /*#__PURE__*/ (0, $ccwsP$jsx)((0, $71516388373cffcd$export$39a935fa7fde4940), {
                                                        filterId: "source",
                                                        customDates: customDates,
                                                        updateCustomDate: updateCustomDate,
                                                        labels: {
                                                            from: t.from,
                                                            to: t.to
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                        className: "space-y-5 overflow-y-auto max-h-[300px] p-2 custom-scrollbar",
                                        children: sourceData.length > 0 ? sourceData.map((item, idx)=>{
                                            const config = getSourceConfig(item.name);
                                            return /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "flex items-center justify-between group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                        className: "flex items-center gap-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                className: `w-9 h-9 shrink-0 rounded-xl flex items-center justify-center transition-all ${config.color}`,
                                                                children: config.icon
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                                                        className: "font-bold text-slate-800 dark:text-slate-200 text-xs md:text-sm",
                                                                        children: item.name
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                                                        className: "text-[10px] text-slate-400",
                                                                        children: "Referral"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                        className: "text-right",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                                className: "block font-bold text-slate-900 dark:text-white text-sm",
                                                                children: item.value
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("span", {
                                                                className: "text-[10px] font-medium text-emerald-500",
                                                                children: [
                                                                    "+",
                                                                    Math.floor(Math.random() * 10),
                                                                    "%"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, item.name);
                                        }) : /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                            className: "flex flex-col items-center justify-center h-32 text-slate-400",
                                            children: /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                className: "text-sm",
                                                children: t.noData
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: `${cardClass} flex flex-col min-h-[350px] lg:min-h-[400px] z-10`,
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "flex justify-between items-start mb-6",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "flex items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                        className: "p-2 bg-amber-50 dark:bg-amber-900/30 rounded-lg text-amber-600 dark:text-amber-400 shadow-[0_0_8px_rgba(245,158,11,0.15)]",
                                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Clock), {
                                                            size: 18
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)((0, $9f258ebe77ccfbd1$export$eccda88c066b9b81), {
                                                                term: "Time Tracking",
                                                                children: /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                                                    className: "text-lg md:text-xl font-bold text-slate-900 dark:text-white",
                                                                    children: t.timeTracking
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                                                className: "text-[10px] text-slate-400 mt-0.5",
                                                                children: t.peakActivity
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "flex flex-col items-end",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)($a97e8c48f36eb07f$var$FilterDropdown, {
                                                        value: insightsFilter,
                                                        onChange: setInsightsFilter,
                                                        id: "insights"
                                                    }),
                                                    insightsFilter === 'custom' && /*#__PURE__*/ (0, $ccwsP$jsx)((0, $71516388373cffcd$export$39a935fa7fde4940), {
                                                        filterId: "insights",
                                                        customDates: customDates,
                                                        updateCustomDate: updateCustomDate,
                                                        labels: {
                                                            from: t.from,
                                                            to: t.to
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "flex-1 flex flex-col justify-center space-y-1.5",
                                        children: [
                                            timeActivityData.grid.map((row, dayIdx)=>/*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                    className: "flex items-center gap-1.5",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                            className: "text-[8px] font-bold text-slate-400 w-5",
                                                            children: $a97e8c48f36eb07f$var$DAYS[dayIdx]
                                                        }),
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                            className: "flex-1 flex gap-0.5 h-4 md:h-5",
                                                            children: Array.from({
                                                                length: 24
                                                            }, (_, i)=>i).map((hour)=>{
                                                                const count = row[hour] || 0;
                                                                const intensity = timeActivityData.max > 0 ? count / timeActivityData.max : 0;
                                                                let bg = 'bg-slate-100 dark:bg-slate-800';
                                                                if (intensity > 0.2) bg = 'bg-indigo-200 dark:bg-indigo-900/40';
                                                                if (intensity > 0.5) bg = 'bg-indigo-400 dark:bg-indigo-600';
                                                                if (intensity > 0.8) bg = 'bg-indigo-600 dark:bg-indigo-400';
                                                                return /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                    className: `flex-1 rounded-sm ${bg}`,
                                                                    title: `${hour}:00 - ${count} visits`
                                                                }, hour);
                                                            })
                                                        })
                                                    ]
                                                }, dayIdx)),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "flex justify-between text-[9px] text-slate-400 px-6 pt-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                        children: "12am"
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                        children: "12pm"
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                        children: "11pm"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: `${cardClass} flex flex-col min-h-[350px] lg:min-h-[400px] z-0`,
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "flex justify-between items-start mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "flex items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                        className: "p-2 bg-purple-50 dark:bg-purple-900/30 rounded-lg text-purple-600 dark:text-purple-400 shadow-[0_0_8px_rgba(147,51,234,0.15)]",
                                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Smartphone), {
                                                            size: 18
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)((0, $9f258ebe77ccfbd1$export$eccda88c066b9b81), {
                                                                term: "User By Device",
                                                                children: /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                                                    className: "text-lg md:text-xl font-bold text-slate-900 dark:text-white",
                                                                    children: t.userByDevice
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                                                className: "text-[10px] text-slate-400 mt-0.5",
                                                                children: t.deviceDist
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "flex flex-col items-end",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)($a97e8c48f36eb07f$var$FilterDropdown, {
                                                        value: deviceFilter,
                                                        onChange: setDeviceFilter,
                                                        id: "device"
                                                    }),
                                                    deviceFilter === 'custom' && /*#__PURE__*/ (0, $ccwsP$jsx)((0, $71516388373cffcd$export$39a935fa7fde4940), {
                                                        filterId: "device",
                                                        customDates: customDates,
                                                        updateCustomDate: updateCustomDate,
                                                        labels: {
                                                            from: t.from,
                                                            to: t.to
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                        className: "flex-1 min-h-[200px] lg:min-h-[220px] -ml-6",
                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ResponsiveContainer), {
                                            width: "100%",
                                            height: "100%",
                                            debounce: 50,
                                            children: /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $ccwsP$RadarChart), {
                                                cx: "50%",
                                                cy: "50%",
                                                outerRadius: "65%",
                                                data: deviceRadarData,
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$PolarGrid), {
                                                        stroke: isDark ? "#334155" : "#e2e8f0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$PolarAngleAxis), {
                                                        dataKey: "subject",
                                                        tick: {
                                                            fill: '#94a3b8',
                                                            fontSize: 9
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$PolarRadiusAxis), {
                                                        angle: 30,
                                                        domain: [
                                                            0,
                                                            'auto'
                                                        ],
                                                        tick: false,
                                                        axisLine: false
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Radar), {
                                                        name: "Devices",
                                                        dataKey: "A",
                                                        stroke: "#8884d8",
                                                        strokeWidth: 2,
                                                        fill: "#8884d8",
                                                        fillOpacity: 0.4
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Tooltip), {
                                                        content: /*#__PURE__*/ (0, $ccwsP$jsx)($a97e8c48f36eb07f$var$CustomTooltip, {}),
                                                        cursor: chartCursor
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: "grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 mb-8",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: `${cardClass} min-h-[350px] lg:min-h-[400px]`,
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "flex justify-between items-center mb-6",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "flex items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                        className: "p-2 bg-emerald-50 dark:bg-emerald-900/30 rounded-lg text-emerald-600 dark:text-emerald-400 shadow-[0_0_8px_rgba(16,185,129,0.15)]",
                                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$FileText), {
                                                            size: 18
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $9f258ebe77ccfbd1$export$eccda88c066b9b81), {
                                                            term: "Top Browsing Pages Per Minute",
                                                            children: /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                                                className: "text-lg font-bold text-slate-900 dark:text-white",
                                                                children: t.topPagesMinute
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "flex flex-col items-end",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)($a97e8c48f36eb07f$var$FilterDropdown, {
                                                        value: topPagesFilter,
                                                        onChange: setTopPagesFilter,
                                                        id: "topPages"
                                                    }),
                                                    topPagesFilter === 'custom' && /*#__PURE__*/ (0, $ccwsP$jsx)((0, $71516388373cffcd$export$39a935fa7fde4940), {
                                                        filterId: "topPages",
                                                        customDates: customDates,
                                                        updateCustomDate: updateCustomDate,
                                                        labels: {
                                                            from: t.from,
                                                            to: t.to
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                        className: "h-[120px] mb-4 relative z-0",
                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ResponsiveContainer), {
                                            width: "100%",
                                            height: "100%",
                                            debounce: 50,
                                            children: /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $ccwsP$BarChart), {
                                                data: topPagesChartData,
                                                margin: {
                                                    top: 10,
                                                    right: 0,
                                                    left: 0,
                                                    bottom: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$XAxis), {
                                                        dataKey: "name",
                                                        hide: true
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Tooltip), {
                                                        content: /*#__PURE__*/ (0, $ccwsP$jsx)($a97e8c48f36eb07f$var$CustomTooltip, {}),
                                                        cursor: {
                                                            fill: 'transparent'
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Bar), {
                                                        dataKey: "value",
                                                        name: "Views",
                                                        fill: "#10b981",
                                                        radius: [
                                                            4,
                                                            4,
                                                            4,
                                                            4
                                                        ],
                                                        barSize: 16,
                                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$LabelList), {
                                                            dataKey: "value",
                                                            position: "top",
                                                            fill: "#94a3b8",
                                                            fontSize: 10,
                                                            formatter: (val)=>val > 0 ? val : ''
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                        className: "overflow-x-auto -mx-2 px-2",
                                        children: /*#__PURE__*/ (0, $ccwsP$jsxs)("table", {
                                            className: "w-full text-sm text-left border-collapse min-w-[300px]",
                                            children: [
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("thead", {
                                                    className: "text-[10px] text-slate-500 dark:text-slate-400 bg-indigo-50/50 dark:bg-slate-800/50 font-semibold uppercase tracking-wider",
                                                    children: /*#__PURE__*/ (0, $ccwsP$jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("th", {
                                                                className: "px-3 py-2 rounded-l-lg",
                                                                children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $9f258ebe77ccfbd1$export$eccda88c066b9b81), {
                                                                    term: "Page",
                                                                    children: t.page
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("th", {
                                                                className: "px-3 py-2",
                                                                children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $9f258ebe77ccfbd1$export$eccda88c066b9b81), {
                                                                    term: "Views",
                                                                    children: t.views
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("th", {
                                                                className: "px-3 py-2 rounded-r-lg text-right",
                                                                children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $9f258ebe77ccfbd1$export$eccda88c066b9b81), {
                                                                    term: "Bounce Rate",
                                                                    children: t.bounceRate
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("tbody", {
                                                    children: topPagesData.length > 0 ? topPagesData.map((row, i)=>/*#__PURE__*/ (0, $ccwsP$jsxs)("tr", {
                                                            className: "border-b border-dashed border-slate-100 dark:border-slate-800 last:border-0 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("td", {
                                                                    className: "px-3 py-2.5 font-medium text-blue-500 dark:text-blue-400 hover:underline cursor-pointer truncate max-w-[120px] md:max-w-[200px]",
                                                                    title: row.page,
                                                                    children: row.page
                                                                }),
                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("td", {
                                                                    className: "px-3 py-2.5 text-slate-700 dark:text-slate-200",
                                                                    children: row.views
                                                                }),
                                                                /*#__PURE__*/ (0, $ccwsP$jsxs)("td", {
                                                                    className: "px-3 py-2.5 text-right text-slate-500 dark:text-slate-400",
                                                                    children: [
                                                                        row.bounceRate.toFixed(1),
                                                                        "%"
                                                                    ]
                                                                })
                                                            ]
                                                        }, i)) : /*#__PURE__*/ (0, $ccwsP$jsx)("tr", {
                                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)("td", {
                                                            colSpan: 3,
                                                            className: "px-3 py-8 text-center text-slate-400 italic",
                                                            children: t.noPageViews
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: `${cardClass} flex flex-col min-h-[400px] lg:min-h-[500px]`,
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "flex justify-between items-center mb-6",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "flex items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                        className: "p-2 bg-rose-50 dark:bg-rose-900/30 rounded-lg text-rose-600 dark:text-rose-400 shadow-[0_0_8px_rgba(225,29,72,0.15)]",
                                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$MapPin), {
                                                            size: 18
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)((0, $9f258ebe77ccfbd1$export$eccda88c066b9b81), {
                                                                term: "Visits By City",
                                                                children: /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                                                    className: "text-lg md:text-xl font-bold text-slate-900 dark:text-white",
                                                                    children: t.visitsByCity
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                                                className: "text-[10px] text-slate-500 dark:text-slate-400",
                                                                children: t.geoBreakdown
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "flex flex-col items-end",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)($a97e8c48f36eb07f$var$FilterDropdown, {
                                                        value: cityFilter,
                                                        onChange: setCityFilter,
                                                        id: "city"
                                                    }),
                                                    cityFilter === 'custom' && /*#__PURE__*/ (0, $ccwsP$jsx)((0, $71516388373cffcd$export$39a935fa7fde4940), {
                                                        filterId: "city",
                                                        customDates: customDates,
                                                        updateCustomDate: updateCustomDate,
                                                        labels: {
                                                            from: t.from,
                                                            to: t.to
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "flex flex-col gap-6 h-full",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                className: "relative w-full aspect-[16/10] bg-slate-100 dark:bg-slate-800/30 rounded-2xl p-2 flex items-center justify-center overflow-hidden border border-slate-100 dark:border-slate-800",
                                                children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                    className: "relative w-full h-full",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)((0, $05c64ef4cc5e0393$export$e2a8fd01773fcf65), {}),
                                                        cityData.map((city, i)=>{
                                                            const coords = $a97e8c48f36eb07f$var$getCityCoordinates(city.city, city.region, city.lat, city.lng);
                                                            if (!coords) return null;
                                                            const color = i === 0 ? 'bg-blue-500' : i === 1 ? 'bg-indigo-500' : 'bg-sky-500';
                                                            const delay = i * 300;
                                                            return /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                                className: "absolute transform -translate-x-1/2 -translate-y-1/2",
                                                                style: {
                                                                    left: coords.left,
                                                                    top: coords.top
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                        className: `absolute w-2 h-2 md:w-3 md:h-3 ${color} rounded-full animate-ping opacity-75`,
                                                                        style: {
                                                                            animationDelay: `${delay}ms`
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                        className: `relative w-2 h-2 md:w-3 md:h-3 ${color} rounded-full border border-white dark:border-slate-900 shadow-lg group cursor-help`,
                                                                        children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                                            className: "absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 bg-slate-900 text-white text-[9px] md:text-[10px] rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none z-10 shadow-xl",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                                                    className: "font-bold",
                                                                                    children: city.name
                                                                                }),
                                                                                ": ",
                                                                                city.value,
                                                                                " visits",
                                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                                    className: "absolute top-full left-1/2 -translate-x-1/2 -mt-px border-4 border-transparent border-t-slate-900"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            }, city.name);
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                className: "flex-1 space-y-4",
                                                children: cityData.length > 0 ? cityData.map((city, i)=>{
                                                    const totalEventsCount = events.length || 1;
                                                    const pct = (city.value / totalEventsCount * 100).toFixed(0);
                                                    return /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                className: "flex justify-between mb-1",
                                                                children: /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                                    className: "text-xs font-bold text-slate-700 dark:text-slate-200",
                                                                    children: city.name
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                                className: "flex items-center gap-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                        className: "flex-1 h-2 bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden",
                                                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                            className: "h-full rounded-full transition-all duration-1000 ease-out bg-sky-500",
                                                                            style: {
                                                                                width: `${pct}%`
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("span", {
                                                                        className: "text-[10px] font-bold text-slate-500 dark:text-slate-400 w-6 text-right",
                                                                        children: [
                                                                            pct,
                                                                            "%"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, city.name);
                                                }) : /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                                    className: "text-center text-slate-400 italic py-4 text-xs",
                                                    children: t.noLocationData
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                        className: "mb-8",
                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $6056b508dd142eac$export$6e9e0b5447fad01f), {
                            events: baseEvents
                        })
                    })
                ]
            }),
            showLinkBuilder && domain && /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                className: "fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4",
                children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                    className: "bg-white dark:bg-slate-900 rounded-[32px] p-6 md:p-8 max-w-md w-full shadow-2xl border border-slate-100 dark:border-slate-800",
                    children: [
                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                            className: "flex justify-between items-start mb-6",
                            children: [
                                /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                    className: "text-xl font-bold text-slate-900 dark:text-white",
                                    children: t.linkBuilderTitle
                                }),
                                /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                    onClick: ()=>setShowLinkBuilder(false),
                                    children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$X), {
                                        size: 24,
                                        className: "text-slate-400"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("label", {
                                            className: "text-xs font-bold uppercase text-slate-500 dark:text-slate-400 tracking-wider",
                                            children: t.sourceName
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("input", {
                                            className: "w-full mt-2 p-3 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl outline-none focus:border-indigo-500 text-slate-900 dark:text-white text-sm",
                                            placeholder: "e.g. facebook",
                                            value: lbSource,
                                            onChange: (e)=>setLbSource(e.target.value)
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                            className: "flex flex-wrap gap-2 mt-3",
                                            children: [
                                                'Facebook',
                                                'Google',
                                                'Instagram',
                                                'Yelp',
                                                'TikTok'
                                            ].map((s)=>/*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                                    onClick: ()=>setLbSource(s.toLowerCase()),
                                                    className: "px-2.5 py-1.5 text-[10px] font-medium bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400 rounded-lg hover:bg-indigo-50 hover:text-indigo-600 transition-colors",
                                                    children: s
                                                }, s))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                    className: "p-4 bg-slate-900 dark:bg-black rounded-xl text-indigo-200 font-mono text-[10px] md:text-xs break-all relative",
                                    children: [
                                        domain.url,
                                        "/?s=",
                                        lbSource.trim() || 'source',
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                            onClick: ()=>{
                                                navigator.clipboard.writeText(`${domain.url}/?s=${lbSource.trim()}`);
                                                setLbCopied(true);
                                                setTimeout(()=>setLbCopied(false), 2000);
                                            },
                                            className: "absolute top-2 right-2 p-1.5 bg-white/10 rounded hover:bg-white/20 text-white",
                                            children: lbCopied ? /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Check), {
                                                size: 14
                                            }) : /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Copy), {
                                                size: 14
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            showShareModal && domain && /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                className: "fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4",
                children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                    className: "bg-white dark:bg-slate-900 rounded-[32px] p-6 md:p-8 max-w-md w-full shadow-2xl border border-slate-100 dark:border-slate-800",
                    children: [
                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                            className: "flex justify-between items-start mb-6",
                            children: [
                                /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                    className: "text-xl font-bold text-slate-900 dark:text-white",
                                    children: t.shareReportTitle
                                }),
                                /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                    onClick: ()=>setShowShareModal(false),
                                    children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$X), {
                                        size: 24,
                                        className: "text-slate-400"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                            className: "p-4 bg-indigo-50 dark:bg-indigo-900/20 rounded-xl text-indigo-700 dark:text-indigo-300 font-mono text-[10px] md:text-xs break-all relative",
                            children: [
                                window.location.origin,
                                "/#/public/",
                                domain.id,
                                /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                    onClick: ()=>{
                                        navigator.clipboard.writeText(`${window.location.origin}/#/public/${domain.id}`);
                                        setShareCopied(true);
                                        setTimeout(()=>setShareCopied(false), 2000);
                                    },
                                    className: "absolute top-2 right-2 p-1.5 bg-indigo-200 dark:bg-indigo-800 text-indigo-800 dark:text-indigo-200 rounded-lg",
                                    children: shareCopied ? /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Check), {
                                        size: 14
                                    }) : /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Copy), {
                                        size: 14
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            showEmbedModal && domain && /*#__PURE__*/ (0, $ccwsP$jsx)((0, $a60fbf2e582a0bfd$export$24aa2c0563a80031), {
                domain: domain,
                onClose: ()=>setShowEmbedModal(false)
            })
        ]
    });
};
var $a97e8c48f36eb07f$export$2e2bcd8739ae039 = $a97e8c48f36eb07f$var$Report;









const $4a1dbf79397ab509$var$Auth = ()=>{
    const [isLogin, setIsLogin] = (0, $ccwsP$useState)(true);
    const [email, setEmail] = (0, $ccwsP$useState)('');
    const [password, setPassword] = (0, $ccwsP$useState)('');
    const [displayName, setDisplayName] = (0, $ccwsP$useState)('');
    const [rememberMe, setRememberMeState] = (0, $ccwsP$useState)(true);
    const [error, setError] = (0, $ccwsP$useState)(null);
    const [isLoading, setIsLoading] = (0, $ccwsP$useState)(false);
    const { user: user, loading: loading, setRememberMe: setRememberMe } = (0, $20acffabdd663b48$export$1d39dc5b47e56ff0)();
    const navigate = (0, $ccwsP$useNavigate)();
    if (loading) return null;
    if (user) return /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Navigate), {
        to: "/",
        replace: true
    });
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setError(null);
        setIsLoading(true);
        try {
            // Set persistence based on "Remember Me"
            await setRememberMe(rememberMe);
            if (isLogin) await (0, $ccwsP$signInWithEmailAndPassword)((0, $09b8c58f557d578f$export$73693bad9f5880b0), email, password);
            else {
                const userCredential = await (0, $ccwsP$createUserWithEmailAndPassword)((0, $09b8c58f557d578f$export$73693bad9f5880b0), email, password);
                if (displayName) await (0, $ccwsP$updateProfile)(userCredential.user, {
                    displayName: displayName
                });
            }
            navigate('/');
        } catch (err) {
            console.error("Auth Error:", err);
            if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password') setError('Invalid email or password.');
            else if (err.code === 'auth/email-already-in-use') setError('This email is already registered.');
            else if (err.code === 'auth/weak-password') setError('Password should be at least 6 characters.');
            else setError(err.message || 'An error occurred during authentication.');
        } finally{
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
        className: "min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center p-4 font-sans selection:bg-indigo-100 selection:text-indigo-700",
        children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
            className: "w-full max-w-[440px] animate-in fade-in zoom-in-95 duration-500",
            children: [
                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                    className: "flex flex-col items-center mb-8",
                    children: [
                        /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                            className: "w-16 h-16 bg-indigo-600 text-white rounded-2xl flex items-center justify-center shadow-xl shadow-indigo-500/20 mb-4 transform -rotate-6 hover:rotate-0 transition-transform duration-300",
                            children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$LayoutDashboard), {
                                size: 32,
                                strokeWidth: 2.5
                            })
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsx)("h1", {
                            className: "text-3xl font-extrabold text-slate-900 dark:text-white tracking-tight",
                            children: "MyETRAFFIC"
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                            className: "text-slate-500 dark:text-slate-400 mt-2 font-medium",
                            children: "Your Traffic, Decoded by AI"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                    className: "bg-white dark:bg-slate-900 rounded-[32px] p-8 md:p-10 shadow-[0_20px_50px_-12px_rgba(0,0,0,0.08)] border border-slate-100 dark:border-slate-800 relative overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                            className: "absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-indigo-500 via-purple-500 to-indigo-500"
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                            className: "mb-8",
                            children: [
                                /*#__PURE__*/ (0, $ccwsP$jsx)("h2", {
                                    className: "text-2xl font-bold text-slate-900 dark:text-white",
                                    children: isLogin ? 'Welcome Back' : 'Get Started'
                                }),
                                /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                    className: "text-slate-500 dark:text-slate-400 text-sm mt-1 font-medium",
                                    children: isLogin ? 'Log in to manage your domains' : 'Create an account to start tracking'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsxs)("form", {
                            onSubmit: handleSubmit,
                            className: "space-y-5",
                            children: [
                                !isLogin && /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("label", {
                                            className: "text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider ml-1",
                                            children: "Full Name"
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                            className: "relative group",
                                            children: [
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                    className: "absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-slate-400 group-focus-within:text-indigo-500 transition-colors",
                                                    children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$User), {
                                                        size: 18
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("input", {
                                                    type: "text",
                                                    required: !isLogin,
                                                    className: "w-full pl-11 pr-4 py-3.5 bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-2xl focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 focus:bg-white dark:focus:bg-slate-800 outline-none transition-all text-slate-900 dark:text-white",
                                                    placeholder: "John Doe",
                                                    value: displayName,
                                                    onChange: (e)=>setDisplayName(e.target.value)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("label", {
                                            className: "text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider ml-1",
                                            children: "Email Address"
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                            className: "relative group",
                                            children: [
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                    className: "absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-slate-400 group-focus-within:text-indigo-500 transition-colors",
                                                    children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Mail), {
                                                        size: 18
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("input", {
                                                    type: "email",
                                                    required: true,
                                                    className: "w-full pl-11 pr-4 py-3.5 bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-2xl focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 focus:bg-white dark:focus:bg-slate-800 outline-none transition-all text-slate-900 dark:text-white",
                                                    placeholder: "name@company.com",
                                                    value: email,
                                                    onChange: (e)=>setEmail(e.target.value)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("label", {
                                            className: "text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider ml-1",
                                            children: "Password"
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                            className: "relative group",
                                            children: [
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                    className: "absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-slate-400 group-focus-within:text-indigo-500 transition-colors",
                                                    children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Lock), {
                                                        size: 18
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("input", {
                                                    type: "password",
                                                    required: true,
                                                    className: "w-full pl-11 pr-4 py-3.5 bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-2xl focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 focus:bg-white dark:focus:bg-slate-800 outline-none transition-all text-slate-900 dark:text-white",
                                                    placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                                                    value: password,
                                                    onChange: (e)=>setPassword(e.target.value)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                    className: "flex items-center justify-between py-1",
                                    children: [
                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("label", {
                                            className: "flex items-center gap-2 cursor-pointer group",
                                            children: [
                                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                    className: "relative",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)("input", {
                                                            type: "checkbox",
                                                            className: "sr-only peer",
                                                            checked: rememberMe,
                                                            onChange: (e)=>setRememberMeState(e.target.checked)
                                                        }),
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                            className: "w-5 h-5 border-2 border-slate-300 dark:border-slate-600 rounded-md peer-checked:bg-indigo-600 peer-checked:border-indigo-600 transition-all"
                                                        }),
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$CheckCircle2), {
                                                            size: 12,
                                                            className: "absolute inset-0 m-auto text-white opacity-0 peer-checked:opacity-100 transition-opacity"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                    className: "text-sm font-medium text-slate-600 dark:text-slate-400 group-hover:text-slate-900 dark:group-hover:text-slate-200 transition-colors",
                                                    children: "Remember Me"
                                                })
                                            ]
                                        }),
                                        isLogin && /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                            type: "button",
                                            className: "text-sm font-bold text-indigo-600 dark:text-indigo-400 hover:underline",
                                            children: "Forgot Password?"
                                        })
                                    ]
                                }),
                                error && /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                    className: "flex items-center gap-2 p-4 bg-rose-50 dark:bg-rose-900/20 border border-rose-100 dark:border-rose-900/30 rounded-2xl text-rose-600 dark:text-rose-400 text-sm animate-in shake-in duration-300",
                                    children: [
                                        /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$AlertCircle), {
                                            size: 18,
                                            className: "shrink-0"
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                            className: "font-medium",
                                            children: error
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                    type: "submit",
                                    disabled: isLoading,
                                    className: "w-full py-4 bg-indigo-600 hover:bg-indigo-700 text-white font-bold rounded-2xl shadow-lg shadow-indigo-500/25 dark:shadow-none flex items-center justify-center gap-2 transition-all active:scale-[0.98] disabled:opacity-70 disabled:active:scale-100",
                                    children: isLoading ? /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Loader2), {
                                        size: 20,
                                        className: "animate-spin"
                                    }) : /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $ccwsP$Fragment), {
                                        children: [
                                            isLogin ? 'Sign In' : 'Create Account',
                                            /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ArrowRight), {
                                                size: 18
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                            className: "mt-8 pt-8 border-t border-slate-100 dark:border-slate-800 text-center",
                            children: /*#__PURE__*/ (0, $ccwsP$jsxs)("p", {
                                className: "text-slate-500 dark:text-slate-400 text-sm font-medium",
                                children: [
                                    isLogin ? "Don't have an account?" : "Already have an account?",
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setIsLogin(!isLogin),
                                        className: "ml-2 font-bold text-indigo-600 dark:text-indigo-400 hover:underline",
                                        children: isLogin ? 'Create One' : 'Log In'
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                    className: "mt-8 flex items-center justify-center gap-2 text-slate-400 dark:text-slate-600 text-xs font-bold uppercase tracking-widest",
                    children: [
                        /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ShieldCheck), {
                            size: 14
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                            children: "Secure AES-256 Encrypted"
                        })
                    ]
                })
            ]
        })
    });
};
var $4a1dbf79397ab509$export$2e2bcd8739ae039 = $4a1dbf79397ab509$var$Auth;










const $178b69f63ab67065$var$DEFAULT_SETTINGS = {
    style: 'light',
    position: 'bottom-left',
    messageText: 'We use cookies to analyze website traffic and improve your experience.',
    acceptButtonText: 'Accept',
    declineButtonText: 'Decline'
};
// --- Sub Components ---
const $178b69f63ab67065$var$GdprBannerPreview = ({ settings: settings, enabled: enabled })=>{
    const isDark = settings.style === 'dark';
    const positionClasses = {
        'bottom-left': 'left-4',
        'bottom-right': 'right-4',
        'bottom-center': 'left-1/2 -translate-x-1/2 max-w-lg w-[calc(100%-32px)] sm:w-auto'
    };
    return /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
        className: `absolute bottom-4 ${positionClasses[settings.position]}
        p-4 rounded-xl shadow-2xl flex items-center justify-between gap-4 
        transition-all duration-300 border
        ${!enabled ? 'opacity-20 grayscale pointer-events-none' : 'opacity-100'}
        ${isDark ? 'bg-slate-800 text-slate-200 border-slate-700' : 'bg-white text-slate-700 border-slate-200'}`,
        children: [
            /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                className: "text-sm",
                children: settings.messageText
            }),
            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                className: "flex gap-2 shrink-0",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                        className: `px-4 py-2 text-sm font-semibold rounded-lg transition-colors
            ${isDark ? 'bg-slate-700 hover:bg-slate-600 text-white' : 'bg-slate-100 hover:bg-slate-200 text-slate-800'}`,
                        children: settings.declineButtonText
                    }),
                    /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                        className: "px-4 py-2 text-sm font-semibold rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white transition-colors",
                        children: settings.acceptButtonText
                    })
                ]
            })
        ]
    });
};
const $178b69f63ab67065$var$GdprSettings = ()=>{
    const { id: id } = (0, $ccwsP$useParams)();
    const [domain, setDomain] = (0, $ccwsP$useState)(undefined);
    const [settings, setSettings] = (0, $ccwsP$useState)($178b69f63ab67065$var$DEFAULT_SETTINGS);
    const [enabled, setEnabled] = (0, $ccwsP$useState)(false);
    const [isLoading, setIsLoading] = (0, $ccwsP$useState)(true);
    const [isSaving, setIsSaving] = (0, $ccwsP$useState)(false);
    const [error, setError] = (0, $ccwsP$useState)(null);
    const [showSuccess, setShowSuccess] = (0, $ccwsP$useState)(false);
    const { t: t } = (0, $72ad5ad77b58d1fe$export$c1fd9f444a3dc711)();
    // State for modals
    const [showEmbedModal, setShowEmbedModal] = (0, $ccwsP$useState)(false);
    const [showLinkBuilder, setShowLinkBuilder] = (0, $ccwsP$useState)(false);
    const [showShareModal, setShowShareModal] = (0, $ccwsP$useState)(false);
    const [lbSource, setLbSource] = (0, $ccwsP$useState)('');
    const [lbCopied, setLbCopied] = (0, $ccwsP$useState)(false);
    const [shareCopied, setShareCopied] = (0, $ccwsP$useState)(false);
    (0, $ccwsP$useEffect)(()=>{
        const fetchData = async ()=>{
            if (!id) return;
            setIsLoading(true);
            try {
                const domainData = await (0, $2abee34d7f7177c9$export$34f4c9b2cab9611c)(id);
                if (domainData) {
                    setDomain(domainData);
                    setSettings(domainData.gdprSettings || $178b69f63ab67065$var$DEFAULT_SETTINGS);
                    setEnabled(domainData.gdprConsentEnabled || false);
                } else setError('Domain not found.');
            } catch (err) {
                setError('Failed to load domain data.');
            } finally{
                setIsLoading(false);
            }
        };
        fetchData();
    }, [
        id
    ]);
    const handleSettingChange = (field, value)=>{
        setSettings((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    const handleSave = async ()=>{
        if (!id) return;
        setIsSaving(true);
        try {
            await (0, $2abee34d7f7177c9$export$df2f3930b81062be)(id, {
                gdprSettings: settings,
                gdprConsentEnabled: enabled
            });
            setShowSuccess(true);
            setTimeout(()=>setShowSuccess(false), 2000);
        } catch (err) {
            alert('Failed to save settings.');
        } finally{
            setIsSaving(false);
        }
    };
    const sidebarContent = id ? /*#__PURE__*/ (0, $ccwsP$jsxs)("nav", {
        className: "space-y-1",
        children: [
            /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $ccwsP$Link), {
                to: `/report/${id}`,
                className: "w-full flex items-center gap-3 px-4 py-3 rounded-xl text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Share2), {
                        size: 20
                    }),
                    t.analytics
                ]
            }),
            /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $ccwsP$Link), {
                to: `/report/${id}/gdpr-settings`,
                className: "w-full flex items-center gap-3 px-4 py-3 rounded-xl bg-indigo-50 dark:bg-indigo-900/20 text-indigo-600 dark:text-indigo-400 font-semibold transition-colors",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ShieldCheck), {
                        size: 20
                    }),
                    t.gdprSettings
                ]
            }),
            /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $ccwsP$Link), {
                to: `/report/${id}/accessibility`,
                className: "w-full flex items-center gap-3 px-4 py-3 rounded-xl text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Accessibility), {
                        size: 20
                    }),
                    t.accessibility
                ]
            }),
            /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                onClick: ()=>setShowShareModal(true),
                className: "w-full flex items-center gap-3 px-4 py-3 rounded-xl text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Globe), {
                        size: 20
                    }),
                    t.shareReport
                ]
            }),
            /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                onClick: ()=>setShowLinkBuilder(true),
                className: "w-full flex items-center gap-3 px-4 py-3 rounded-xl text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Link1), {
                        size: 20
                    }),
                    t.linkBuilder
                ]
            }),
            /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                onClick: ()=>setShowEmbedModal(true),
                className: "w-full flex items-center gap-3 px-4 py-3 rounded-xl text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Code), {
                        size: 20
                    }),
                    t.installCode
                ]
            })
        ]
    }) : null;
    if (isLoading) return /*#__PURE__*/ (0, $ccwsP$jsx)((0, $e7fcd481df4de8d7$export$c84671f46d6a1ca), {
        sidebarContent: sidebarContent,
        children: /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
            className: "flex h-full items-center justify-center",
            children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Loader2), {
                className: "animate-spin text-indigo-500",
                size: 32
            })
        })
    });
    if (error) return /*#__PURE__*/ (0, $ccwsP$jsx)((0, $e7fcd481df4de8d7$export$c84671f46d6a1ca), {
        sidebarContent: sidebarContent,
        children: /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
            className: "text-center text-red-500",
            children: error
        })
    });
    return /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $e7fcd481df4de8d7$export$c84671f46d6a1ca), {
        sidebarContent: sidebarContent,
        children: [
            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                className: "max-w-7xl mx-auto",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: "mb-8 flex flex-col md:flex-row md:items-center justify-between gap-6",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: "flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                        className: "w-12 h-12 bg-emerald-100 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-400 flex items-center justify-center rounded-xl shadow-sm",
                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ShieldCheck), {
                                            size: 24
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("h1", {
                                                className: "text-3xl font-bold text-slate-900 dark:text-white",
                                                children: "GDPR Banner"
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("p", {
                                                className: "text-slate-500 dark:text-slate-400",
                                                children: [
                                                    "Consent management for ",
                                                    domain?.name
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                                onClick: handleSave,
                                disabled: isSaving,
                                className: "px-8 py-3 bg-indigo-600 text-white font-bold rounded-xl flex items-center justify-center gap-2 hover:bg-indigo-700 transition-all shadow-lg shadow-indigo-500/20 disabled:opacity-50",
                                children: [
                                    isSaving ? /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Loader2), {
                                        className: "animate-spin",
                                        size: 20
                                    }) : showSuccess ? /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Check), {
                                        size: 20
                                    }) : /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Save), {
                                        size: 20
                                    }),
                                    showSuccess ? 'Saved!' : 'Save Changes'
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: "grid grid-cols-1 lg:grid-cols-3 gap-8",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: "lg:col-span-1 space-y-6",
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                        className: "bg-white dark:bg-slate-900 p-6 rounded-2xl border border-slate-100 dark:border-slate-800 shadow-sm",
                                        children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                            className: "flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                    className: "flex items-center gap-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                            className: `w-10 h-10 rounded-xl flex items-center justify-center transition-colors ${enabled ? 'bg-emerald-100 text-emerald-600' : 'bg-slate-100 text-slate-400'}`,
                                                            children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ShieldCheck), {
                                                                size: 20
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                                                    className: "text-sm font-bold text-slate-900 dark:text-white",
                                                                    children: "Enable Consent Banner"
                                                                }),
                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                                                    className: "text-[10px] text-slate-500 uppercase tracking-wider font-bold",
                                                                    children: "Privacy Control"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                                    onClick: ()=>setEnabled(!enabled),
                                                    className: `relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none ${enabled ? 'bg-emerald-500' : 'bg-slate-200 dark:bg-slate-700'}`,
                                                    children: /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                        className: `inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${enabled ? 'translate-x-6' : 'translate-x-1'}`
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: `bg-white dark:bg-slate-900 p-6 rounded-2xl border border-slate-100 dark:border-slate-800 shadow-sm space-y-6 transition-opacity duration-300 ${!enabled ? 'opacity-50 pointer-events-none' : 'opacity-100'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                                className: "text-xs font-bold text-slate-400 uppercase tracking-widest border-b border-slate-50 dark:border-slate-800 pb-2",
                                                children: "Appearance Settings"
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("label", {
                                                        className: "text-sm font-bold text-slate-700 dark:text-slate-300",
                                                        children: "Position"
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                        className: "grid grid-cols-3 gap-2 mt-2",
                                                        children: [
                                                            'bottom-left',
                                                            'bottom-center',
                                                            'bottom-right'
                                                        ].map((pos)=>/*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                                                                onClick: ()=>handleSettingChange('position', pos),
                                                                className: `p-3 rounded-lg border-2 transition-colors ${settings.position === pos ? 'bg-indigo-50 dark:bg-indigo-900/30 border-indigo-500' : 'bg-slate-50 dark:bg-slate-800 border-transparent hover:border-slate-300 dark:hover:border-slate-600'}`,
                                                                children: [
                                                                    pos === 'bottom-left' && /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$AlignLeft), {
                                                                        className: "mx-auto"
                                                                    }),
                                                                    pos === 'bottom-center' && /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$AlignCenter), {
                                                                        className: "mx-auto"
                                                                    }),
                                                                    pos === 'bottom-right' && /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$AlignRight), {
                                                                        className: "mx-auto"
                                                                    })
                                                                ]
                                                            }, pos))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("label", {
                                                        className: "text-sm font-bold text-slate-700 dark:text-slate-300",
                                                        children: "Style"
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                        className: "grid grid-cols-2 gap-2 mt-2",
                                                        children: [
                                                            'light',
                                                            'dark'
                                                        ].map((style)=>/*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                                                                onClick: ()=>handleSettingChange('style', style),
                                                                className: `p-3 rounded-lg border-2 flex items-center justify-center gap-2 capitalize transition-colors ${settings.style === style ? 'bg-indigo-50 dark:bg-indigo-900/30 border-indigo-500' : 'bg-slate-50 dark:bg-slate-800 border-transparent hover:border-slate-300 dark:hover:border-slate-600'}`,
                                                                children: [
                                                                    style === 'light' ? /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Sun), {
                                                                        size: 16
                                                                    }) : /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Moon), {
                                                                        size: 16
                                                                    }),
                                                                    " ",
                                                                    style
                                                                ]
                                                            }, style))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("label", {
                                                        className: "text-sm font-bold text-slate-700 dark:text-slate-300",
                                                        children: "Message Text"
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("textarea", {
                                                        value: settings.messageText,
                                                        onChange: (e)=>handleSettingChange('messageText', e.target.value),
                                                        rows: 3,
                                                        className: "w-full mt-2 p-3 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-1 focus:ring-indigo-500 outline-none text-sm transition-all"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "grid grid-cols-2 gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("label", {
                                                                className: "text-sm font-bold text-slate-700 dark:text-slate-300",
                                                                children: "Accept Btn"
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("input", {
                                                                type: "text",
                                                                value: settings.acceptButtonText,
                                                                onChange: (e)=>handleSettingChange('acceptButtonText', e.target.value),
                                                                className: "w-full mt-2 p-3 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-1 focus:ring-indigo-500 outline-none text-sm"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("label", {
                                                                className: "text-sm font-bold text-slate-700 dark:text-slate-300",
                                                                children: "Decline Btn"
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("input", {
                                                                type: "text",
                                                                value: settings.declineButtonText,
                                                                onChange: (e)=>handleSettingChange('declineButtonText', e.target.value),
                                                                className: "w-full mt-2 p-3 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-1 focus:ring-indigo-500 outline-none text-sm"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: "lg:col-span-2 bg-slate-100 dark:bg-slate-950 p-6 rounded-[32px] border-2 border-dashed border-slate-200 dark:border-slate-800 relative min-h-[500px] flex flex-col justify-center items-center",
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                        className: "absolute top-6 left-8 flex items-center gap-2 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-widest",
                                        children: "Live Preview"
                                    }),
                                    !enabled && /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                        className: "absolute inset-0 z-10 flex flex-col items-center justify-center bg-slate-100/40 dark:bg-slate-950/40 backdrop-blur-[1px]",
                                        children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                            className: "bg-white dark:bg-slate-900 p-4 rounded-2xl shadow-xl border border-slate-200 dark:border-slate-800 flex items-center gap-3",
                                            children: [
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                    className: "w-10 h-10 bg-slate-100 dark:bg-slate-800 text-slate-400 flex items-center justify-center rounded-xl",
                                                    children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$EyeOff), {
                                                        size: 20
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                                            className: "text-sm font-bold text-slate-700 dark:text-slate-300",
                                                            children: "Banner Disabled"
                                                        }),
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                                            className: "text-[10px] text-slate-500 uppercase tracking-wider",
                                                            children: "Tracking starts instantly"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        className: "w-full h-full relative",
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                className: "w-4/5 h-2/3 bg-white dark:bg-slate-900 rounded-3xl shadow-lg mx-auto my-auto relative overflow-hidden border border-slate-100 dark:border-slate-800",
                                                children: [
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                        className: "h-10 bg-slate-50 dark:bg-slate-800 border-b border-slate-100 dark:border-slate-700 flex items-center px-4 gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                className: "w-2 h-2 rounded-full bg-rose-400"
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                className: "w-2 h-2 rounded-full bg-amber-400"
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                className: "w-2 h-2 rounded-full bg-emerald-400"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                        className: "p-8 space-y-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                className: "h-6 w-1/3 bg-slate-100 dark:bg-slate-800 rounded-lg animate-pulse"
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                className: "h-4 w-full bg-slate-50 dark:bg-slate-800/50 rounded-lg animate-pulse"
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                className: "h-4 w-5/6 bg-slate-50 dark:bg-slate-800/50 rounded-lg animate-pulse"
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                className: "h-4 w-1/2 bg-slate-50 dark:bg-slate-800/50 rounded-lg animate-pulse"
                                                            }),
                                                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                                className: "grid grid-cols-3 gap-4 pt-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                        className: "h-24 bg-slate-50 dark:bg-slate-800 rounded-2xl"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                        className: "h-24 bg-slate-50 dark:bg-slate-800 rounded-2xl"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                        className: "h-24 bg-slate-50 dark:bg-slate-800 rounded-2xl"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsx)($178b69f63ab67065$var$GdprBannerPreview, {
                                                settings: settings,
                                                enabled: enabled
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            showLinkBuilder && domain && /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                className: "fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4",
                children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                    className: "bg-white dark:bg-slate-900 rounded-3xl p-8 max-w-md w-full shadow-2xl border border-slate-100 dark:border-slate-800",
                    children: [
                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                            className: "flex justify-between items-start mb-6",
                            children: [
                                /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                    className: "text-xl font-bold text-slate-900 dark:text-white",
                                    children: t.linkBuilderTitle
                                }),
                                /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                    onClick: ()=>setShowLinkBuilder(false),
                                    children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$X), {
                                        size: 24,
                                        className: "text-slate-400"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("label", {
                                            className: "text-xs font-bold uppercase text-slate-500 dark:text-slate-400 tracking-wider",
                                            children: t.sourceName
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("input", {
                                            className: "w-full mt-2 p-3 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl outline-none focus:border-indigo-500 text-slate-900 dark:text-white",
                                            placeholder: "e.g. facebook",
                                            value: lbSource,
                                            onChange: (e)=>setLbSource(e.target.value)
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                            className: "flex flex-wrap gap-2 mt-3",
                                            children: [
                                                'Facebook',
                                                'Google',
                                                'Instagram',
                                                'Yelp',
                                                'TikTok'
                                            ].map((s)=>/*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                                    onClick: ()=>setLbSource(s.toLowerCase()),
                                                    className: "px-3 py-1.5 text-xs font-medium bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400 rounded-lg hover:bg-indigo-50 hover:text-indigo-600 dark:hover:bg-indigo-900/20 dark:hover:text-indigo-400 transition-colors",
                                                    children: s
                                                }, s))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                    className: "p-4 bg-slate-900 dark:bg-black rounded-xl text-indigo-200 font-mono text-xs break-all relative",
                                    children: [
                                        domain.url,
                                        "/?s=",
                                        lbSource.trim() || 'source',
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                            onClick: ()=>{
                                                navigator.clipboard.writeText(`${domain.url}/?s=${lbSource.trim()}`);
                                                setLbCopied(true);
                                                setTimeout(()=>setLbCopied(false), 2000);
                                            },
                                            className: "absolute top-2 right-2 p-1.5 bg-white/10 rounded hover:bg-white/20 text-white",
                                            children: lbCopied ? /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Check), {
                                                size: 14
                                            }) : /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Copy), {
                                                size: 14
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            showShareModal && domain && /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                className: "fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4",
                children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                    className: "bg-white dark:bg-slate-900 rounded-3xl p-8 max-w-md w-full shadow-2xl border border-slate-100 dark:border-slate-800",
                    children: [
                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                            className: "flex justify-between items-start mb-6",
                            children: [
                                /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                    className: "text-xl font-bold text-slate-900 dark:text-white",
                                    children: t.shareReportTitle
                                }),
                                /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                    onClick: ()=>setShowShareModal(false),
                                    children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$X), {
                                        size: 24,
                                        className: "text-slate-400"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                            className: "p-4 bg-indigo-50 dark:bg-indigo-900/20 rounded-xl text-indigo-700 dark:text-indigo-300 font-mono text-xs break-all relative",
                            children: [
                                window.location.origin,
                                "/#/public/",
                                domain.id,
                                /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                    onClick: ()=>{
                                        navigator.clipboard.writeText(`${window.location.origin}/#/public/${domain.id}`);
                                        setShareCopied(true);
                                        setTimeout(()=>setShareCopied(false), 2000);
                                    },
                                    className: "absolute top-2 right-2 p-1.5 bg-indigo-200 dark:bg-indigo-800 text-indigo-800 dark:text-indigo-200 rounded-lg",
                                    children: shareCopied ? /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Check), {
                                        size: 14
                                    }) : /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Copy), {
                                        size: 14
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            showEmbedModal && domain && /*#__PURE__*/ (0, $ccwsP$jsx)((0, $a60fbf2e582a0bfd$export$24aa2c0563a80031), {
                domain: domain,
                onClose: ()=>setShowEmbedModal(false)
            })
        ]
    });
};
var $178b69f63ab67065$export$2e2bcd8739ae039 = $178b69f63ab67065$var$GdprSettings;










const $9767764b6a108bdf$var$DEFAULT_SETTINGS = {
    enabled: false,
    buttonPosition: 'bottom-left',
    primaryColor: '#4f46e5',
    buttonIcon: 'universal'
};
// Helper component for different icons
const $9767764b6a108bdf$var$WidgetIcon = ({ type: type, size: size = 20, color: color = "currentColor" })=>{
    if (type === 'human') return /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$User), {
        size: size,
        color: color
    });
    if (type === 'wheelchair') return /*#__PURE__*/ (0, $ccwsP$jsxs)("svg", {
        viewBox: "0 0 24 24",
        width: size,
        height: size,
        fill: "none",
        stroke: color,
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ccwsP$jsx)("circle", {
                cx: "12",
                cy: "4",
                r: "2"
            }),
            /*#__PURE__*/ (0, $ccwsP$jsx)("path", {
                d: "M10 13v-3a2 2 0 0 1 2-2h3"
            }),
            /*#__PURE__*/ (0, $ccwsP$jsx)("path", {
                d: "M10 13h5l2.5 4"
            }),
            /*#__PURE__*/ (0, $ccwsP$jsx)("path", {
                d: "M15 13v4"
            }),
            /*#__PURE__*/ (0, $ccwsP$jsx)("path", {
                d: "M10 19a5 5 0 1 0 5-5"
            })
        ]
    });
    // Default to universal
    return /*#__PURE__*/ (0, $ccwsP$jsxs)("svg", {
        viewBox: "0 0 24 24",
        width: size,
        height: size,
        fill: "none",
        stroke: color,
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ccwsP$jsx)("circle", {
                cx: "12",
                cy: "5",
                r: "3"
            }),
            /*#__PURE__*/ (0, $ccwsP$jsx)("path", {
                d: "M10 8h4"
            }),
            /*#__PURE__*/ (0, $ccwsP$jsx)("path", {
                d: "M9 11h6"
            }),
            /*#__PURE__*/ (0, $ccwsP$jsx)("path", {
                d: "M12 11v8"
            }),
            /*#__PURE__*/ (0, $ccwsP$jsx)("path", {
                d: "M8 21h8"
            }),
            /*#__PURE__*/ (0, $ccwsP$jsx)("path", {
                d: "M10 11 8 16"
            }),
            /*#__PURE__*/ (0, $ccwsP$jsx)("path", {
                d: "m14 11 2 5"
            })
        ]
    });
};
const $9767764b6a108bdf$var$AccessibilitySettingsPage = ()=>{
    const { id: id } = (0, $ccwsP$useParams)();
    const [domain, setDomain] = (0, $ccwsP$useState)(undefined);
    const [settings, setSettings] = (0, $ccwsP$useState)($9767764b6a108bdf$var$DEFAULT_SETTINGS);
    const [isLoading, setIsLoading] = (0, $ccwsP$useState)(true);
    const [isSaving, setIsSaving] = (0, $ccwsP$useState)(false);
    const [error, setError] = (0, $ccwsP$useState)(null);
    const [showSuccess, setShowSuccess] = (0, $ccwsP$useState)(false);
    const { t: t } = (0, $72ad5ad77b58d1fe$export$c1fd9f444a3dc711)();
    const [showEmbedModal, setShowEmbedModal] = (0, $ccwsP$useState)(false);
    const [showLinkBuilder, setShowLinkBuilder] = (0, $ccwsP$useState)(false);
    const [showShareModal, setShowShareModal] = (0, $ccwsP$useState)(false);
    const [lbSource, setLbSource] = (0, $ccwsP$useState)('');
    const [lbCopied, setLbCopied] = (0, $ccwsP$useState)(false);
    const [shareCopied, setShareCopied] = (0, $ccwsP$useState)(false);
    (0, $ccwsP$useEffect)(()=>{
        const fetchData = async ()=>{
            if (!id) return;
            setIsLoading(true);
            try {
                const domainData = await (0, $2abee34d7f7177c9$export$34f4c9b2cab9611c)(id);
                if (domainData) {
                    setDomain(domainData);
                    setSettings(domainData.accessibilitySettings || $9767764b6a108bdf$var$DEFAULT_SETTINGS);
                } else setError('Domain not found.');
            } catch (err) {
                setError('Failed to load domain data.');
            } finally{
                setIsLoading(false);
            }
        };
        fetchData();
    }, [
        id
    ]);
    const handleToggle = async (enabled)=>{
        setSettings((prev)=>({
                ...prev,
                enabled: enabled
            }));
    };
    const handleSave = async ()=>{
        if (!id) return;
        setIsSaving(true);
        try {
            await (0, $2abee34d7f7177c9$export$df2f3930b81062be)(id, {
                accessibilityEnabled: settings.enabled,
                accessibilitySettings: settings
            });
            setShowSuccess(true);
            setTimeout(()=>setShowSuccess(false), 2000);
        } catch (err) {
            alert('Failed to save settings.');
        } finally{
            setIsSaving(false);
        }
    };
    const sidebarContent = id ? /*#__PURE__*/ (0, $ccwsP$jsxs)("nav", {
        className: "space-y-1",
        children: [
            /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $ccwsP$Link), {
                to: `/report/${id}`,
                className: "w-full flex items-center gap-3 px-4 py-3 rounded-xl text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Share2), {
                        size: 20
                    }),
                    t.analytics
                ]
            }),
            /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $ccwsP$Link), {
                to: `/report/${id}/gdpr-settings`,
                className: "w-full flex items-center gap-3 px-4 py-3 rounded-xl text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ShieldCheck), {
                        size: 20
                    }),
                    t.gdprSettings
                ]
            }),
            /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $ccwsP$Link), {
                to: `/report/${id}/accessibility`,
                className: "w-full flex items-center gap-3 px-4 py-3 rounded-xl bg-indigo-50 dark:bg-indigo-900/20 text-indigo-600 dark:text-indigo-400 font-semibold transition-colors",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Accessibility), {
                        size: 20
                    }),
                    t.accessibility
                ]
            }),
            /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                onClick: ()=>setShowShareModal(true),
                className: "w-full flex items-center gap-3 px-4 py-3 rounded-xl text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Globe), {
                        size: 20
                    }),
                    t.shareReport
                ]
            }),
            /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                onClick: ()=>setShowLinkBuilder(true),
                className: "w-full flex items-center gap-3 px-4 py-3 rounded-xl text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Link1), {
                        size: 20
                    }),
                    t.linkBuilder
                ]
            }),
            /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                onClick: ()=>setShowEmbedModal(true),
                className: "w-full flex items-center gap-3 px-4 py-3 rounded-xl text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Code), {
                        size: 20
                    }),
                    t.installCode
                ]
            })
        ]
    }) : null;
    if (isLoading) return /*#__PURE__*/ (0, $ccwsP$jsx)((0, $e7fcd481df4de8d7$export$c84671f46d6a1ca), {
        sidebarContent: sidebarContent,
        children: /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
            className: "flex h-full items-center justify-center",
            children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Loader2), {
                className: "animate-spin text-indigo-500",
                size: 32
            })
        })
    });
    return /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $e7fcd481df4de8d7$export$c84671f46d6a1ca), {
        sidebarContent: sidebarContent,
        children: [
            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                className: "max-w-7xl mx-auto",
                children: [
                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: "mb-10 flex flex-col md:flex-row md:items-center justify-between gap-6",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                className: "flex items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                        className: "w-14 h-14 bg-indigo-600 text-white flex items-center justify-center rounded-2xl shadow-lg shadow-indigo-200 dark:shadow-none",
                                        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Accessibility), {
                                            size: 30
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("h1", {
                                                className: "text-3xl font-bold text-slate-900 dark:text-white",
                                                children: t.accessibilitySettings
                                            }),
                                            /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                                className: "text-slate-500 dark:text-slate-400",
                                                children: t.accessibilityDesc
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                                onClick: handleSave,
                                disabled: isSaving,
                                className: "px-8 py-3 bg-indigo-600 text-white font-bold rounded-xl flex items-center justify-center gap-2 hover:bg-indigo-700 transition-all shadow-lg shadow-indigo-500/20 disabled:opacity-50",
                                children: [
                                    isSaving ? /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Loader2), {
                                        className: "animate-spin",
                                        size: 20
                                    }) : showSuccess ? /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$CheckCircle2), {
                                        size: 20
                                    }) : /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Save), {
                                        size: 20
                                    }),
                                    showSuccess ? 'Saved' : 'Save Changes'
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                        className: "grid grid-cols-1 lg:grid-cols-3 gap-8",
                        children: [
                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                className: "lg:col-span-1 space-y-6",
                                children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                    className: "bg-white dark:bg-slate-900 p-8 rounded-[32px] border border-slate-100 dark:border-slate-800 shadow-sm space-y-8",
                                    children: [
                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                            className: "flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                                            className: "font-bold text-slate-900 dark:text-white",
                                                            children: t.accessibilityEnabled
                                                        }),
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                                                            className: "text-xs text-slate-500 dark:text-slate-400",
                                                            children: "Add the WCAG widget to your site"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                                    onClick: ()=>handleToggle(!settings.enabled),
                                                    className: `relative inline-flex h-7 w-12 items-center rounded-full transition-colors focus:outline-none ${settings.enabled ? 'bg-indigo-600' : 'bg-slate-200 dark:bg-slate-700'}`,
                                                    children: /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                        className: `inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${settings.enabled ? 'translate-x-6' : 'translate-x-1'}`
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                            className: "space-y-4",
                                            children: [
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("label", {
                                                    className: "text-sm font-bold text-slate-700 dark:text-slate-300 block",
                                                    children: t.accessibilityButtonPos
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                    className: "grid grid-cols-2 gap-3",
                                                    children: [
                                                        'bottom-left',
                                                        'bottom-right',
                                                        'middle-left',
                                                        'middle-right'
                                                    ].map((pos)=>/*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                                            onClick: ()=>setSettings((s)=>({
                                                                        ...s,
                                                                        buttonPosition: pos
                                                                    })),
                                                            className: `px-4 py-3 rounded-xl border-2 text-xs font-bold capitalize transition-all ${settings.buttonPosition === pos ? 'border-indigo-500 bg-indigo-50 dark:bg-indigo-900/20 text-indigo-600' : 'border-slate-100 dark:border-slate-800 hover:border-slate-200 text-slate-500'}`,
                                                            children: pos.replace('-', ' ')
                                                        }, pos))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                            className: "space-y-4",
                                            children: [
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("label", {
                                                    className: "text-sm font-bold text-slate-700 dark:text-slate-300 block",
                                                    children: t.accessibilityIcon
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                    className: "grid grid-cols-3 gap-3",
                                                    children: [
                                                        'universal',
                                                        'human',
                                                        'wheelchair'
                                                    ].map((icon)=>/*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                                                            onClick: ()=>setSettings((s)=>({
                                                                        ...s,
                                                                        buttonIcon: icon
                                                                    })),
                                                            className: `flex flex-col items-center gap-2 p-3 rounded-xl border-2 transition-all ${settings.buttonIcon === icon ? 'border-indigo-500 bg-indigo-50 dark:bg-indigo-900/20 text-indigo-600' : 'border-slate-100 dark:border-slate-800 hover:border-slate-200 text-slate-400'}`,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ccwsP$jsx)($9767764b6a108bdf$var$WidgetIcon, {
                                                                    type: icon,
                                                                    size: 24
                                                                }),
                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                                    className: "text-[10px] font-bold uppercase",
                                                                    children: icon
                                                                })
                                                            ]
                                                        }, icon))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                            className: "space-y-4",
                                            children: [
                                                /*#__PURE__*/ (0, $ccwsP$jsx)("label", {
                                                    className: "text-sm font-bold text-slate-700 dark:text-slate-300 block",
                                                    children: t.accessibilityColor
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                    className: "flex items-center gap-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)("input", {
                                                            type: "color",
                                                            value: settings.primaryColor,
                                                            onChange: (e)=>setSettings((s)=>({
                                                                        ...s,
                                                                        primaryColor: e.target.value
                                                                    })),
                                                            className: "w-12 h-12 rounded-lg cursor-pointer border-none bg-transparent"
                                                        }),
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)("input", {
                                                            type: "text",
                                                            value: settings.primaryColor,
                                                            onChange: (e)=>setSettings((s)=>({
                                                                        ...s,
                                                                        primaryColor: e.target.value
                                                                    })),
                                                            className: "flex-1 p-3 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl text-sm font-mono"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                className: "lg:col-span-2 space-y-6",
                                children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                    className: "bg-slate-50 dark:bg-slate-950 rounded-[32px] border-2 border-dashed border-slate-200 dark:border-slate-800 p-8 min-h-[600px] relative overflow-hidden flex flex-col items-center justify-center",
                                    children: [
                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                            className: "absolute top-6 left-8 flex items-center gap-2 text-xs font-bold text-slate-400 uppercase tracking-widest",
                                            children: [
                                                /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Eye), {
                                                    size: 14
                                                }),
                                                " ",
                                                t.accessibilityPreview
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                            className: `w-full max-w-[360px] bg-white dark:bg-slate-900 rounded-[32px] shadow-2xl border border-slate-100 dark:border-slate-800 overflow-hidden animate-in fade-in zoom-in-95 duration-500 transition-opacity flex flex-col max-h-[550px] ${!settings.enabled ? 'opacity-30 pointer-events-none' : 'opacity-100'}`,
                                            children: [
                                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                    className: "bg-slate-900 text-white p-5 flex justify-between items-center shrink-0",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("h4", {
                                                                    className: "font-bold text-sm font-sans",
                                                                    children: "Accessibility Adjustments"
                                                                }),
                                                                /*#__PURE__*/ (0, $ccwsP$jsxs)("p", {
                                                                    className: "text-[10px] text-slate-500 font-medium font-sans",
                                                                    children: [
                                                                        "Project: ",
                                                                        domain?.name
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$X), {
                                                            size: 20,
                                                            className: "text-slate-500"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                    className: "flex-1 overflow-y-auto p-5 space-y-6 scrollbar-thin",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                                                            className: "w-full py-2.5 bg-slate-100 dark:bg-slate-800 rounded-xl text-[12px] font-bold text-slate-600 dark:text-slate-300 flex items-center justify-center gap-2 hover:bg-slate-200 transition-colors font-sans",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$RotateCcw), {
                                                                    size: 14,
                                                                    strokeWidth: 3
                                                                }),
                                                                " Reset settings"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                            className: "grid grid-cols-2 gap-4",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                                    className: "space-y-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                                            className: "flex items-center justify-between text-[10px] font-bold text-slate-500 uppercase tracking-wider font-sans",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ccwsP$jsxs)("span", {
                                                                                    className: "flex items-center gap-1.5",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Type), {
                                                                                            size: 12
                                                                                        }),
                                                                                        " Font Size"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                                                    children: "100%"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                                            className: "flex items-center bg-slate-50 dark:bg-slate-800/50 rounded-xl p-1 border border-slate-100 dark:border-slate-800",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                                                                    className: "flex-1 h-8 flex items-center justify-center hover:bg-white dark:hover:bg-slate-700 rounded-lg transition-all shadow-sm",
                                                                                    children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ChevronLeft), {
                                                                                        size: 16
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                                                                    className: "flex-1 h-8 flex items-center justify-center hover:bg-white dark:hover:bg-slate-700 rounded-lg transition-all shadow-sm",
                                                                                    children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ChevronRight), {
                                                                                        size: 16
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                                    className: "space-y-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                                            className: "flex items-center justify-between text-[10px] font-bold text-slate-500 uppercase tracking-wider font-sans",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ccwsP$jsxs)("span", {
                                                                                    className: "flex items-center gap-1.5",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$AlignLeft), {
                                                                                            size: 12
                                                                                        }),
                                                                                        " Line Height"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                                                    children: "100%"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                                            className: "flex items-center bg-slate-50 dark:bg-slate-800/50 rounded-xl p-1 border border-slate-100 dark:border-slate-800",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                                                                    className: "flex-1 h-8 flex items-center justify-center hover:bg-white dark:hover:bg-slate-700 rounded-lg transition-all shadow-sm",
                                                                                    children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ChevronLeft), {
                                                                                        size: 16
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                                                                    className: "flex-1 h-8 flex items-center justify-center hover:bg-white dark:hover:bg-slate-700 rounded-lg transition-all shadow-sm",
                                                                                    children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ChevronRight), {
                                                                                        size: 16
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                            className: "space-y-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("h5", {
                                                                    className: "text-[9px] font-extrabold text-slate-400 uppercase tracking-widest border-b border-slate-50 dark:border-slate-800 pb-2 font-sans",
                                                                    children: "Visual Adjustments"
                                                                }),
                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                    className: "grid grid-cols-2 gap-2.5",
                                                                    children: [
                                                                        {
                                                                            icon: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Moon), {
                                                                                size: 18
                                                                            }),
                                                                            label: 'Dark Mode'
                                                                        },
                                                                        {
                                                                            icon: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Sun), {
                                                                                size: 18
                                                                            }),
                                                                            label: 'Light Mode'
                                                                        },
                                                                        {
                                                                            icon: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$RefreshCw), {
                                                                                size: 18
                                                                            }),
                                                                            label: 'Invert'
                                                                        },
                                                                        {
                                                                            icon: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Contrast), {
                                                                                size: 18
                                                                            }),
                                                                            label: 'High Contrast'
                                                                        },
                                                                        {
                                                                            icon: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Palette), {
                                                                                size: 18
                                                                            }),
                                                                            label: 'Monochrome'
                                                                        },
                                                                        {
                                                                            icon: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Maximize2), {
                                                                                size: 18
                                                                            }),
                                                                            label: 'Big Cursor'
                                                                        }
                                                                    ].map((btn, i)=>/*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                                                                            className: `flex flex-col items-center gap-1.5 p-3.5 bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-800 rounded-2xl hover:border-indigo-500 hover:bg-indigo-50 dark:hover:bg-indigo-900/20 transition-all ${i === 0 ? 'bg-indigo-50 border-indigo-200' : ''}`,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                                    className: `${i === 0 ? 'text-indigo-600' : 'text-slate-400'}`,
                                                                                    children: btn.icon
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                                                    className: `text-[9px] font-bold text-center font-sans leading-tight ${i === 0 ? 'text-indigo-700' : 'text-slate-600'}`,
                                                                                    children: btn.label
                                                                                })
                                                                            ]
                                                                        }, i))
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                            className: "space-y-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("h5", {
                                                                    className: "text-[9px] font-extrabold text-slate-400 uppercase tracking-widest border-b border-slate-50 dark:border-slate-800 pb-2 font-sans",
                                                                    children: "Focus Assist"
                                                                }),
                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                    className: "grid grid-cols-3 gap-2",
                                                                    children: [
                                                                        {
                                                                            label: 'Highlight Titles',
                                                                            val: 'U'
                                                                        },
                                                                        {
                                                                            label: 'Highlight Links',
                                                                            icon: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Link1), {
                                                                                size: 16
                                                                            })
                                                                        },
                                                                        {
                                                                            label: 'Readable Font',
                                                                            icon: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Type), {
                                                                                size: 16
                                                                            })
                                                                        }
                                                                    ].map((btn, i)=>/*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                                                                            className: "flex flex-col items-center gap-2 p-3 bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-800 rounded-2xl hover:bg-indigo-50 dark:hover:bg-indigo-900/10 transition-all",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                                                    className: "text-slate-500 font-bold h-5 flex items-center",
                                                                                    children: btn.val || btn.icon
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                                                    className: "text-[8px] font-bold text-center text-slate-600 dark:text-slate-400 leading-tight",
                                                                                    children: btn.label
                                                                                })
                                                                            ]
                                                                        }, i))
                                                                }),
                                                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                                    className: "grid grid-cols-2 gap-2 mt-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                                                                            className: "flex flex-col items-center gap-2 p-3 bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-800 rounded-2xl hover:bg-indigo-50 dark:hover:bg-indigo-900/10 transition-all",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Maximize2), {
                                                                                    size: 16,
                                                                                    className: "text-slate-500"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                                                    className: "text-[8px] font-bold text-center text-slate-600 dark:text-slate-400 leading-tight",
                                                                                    children: "Content Scaling"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                                                                            className: "flex flex-col items-center gap-2 p-3 bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-800 rounded-2xl hover:bg-indigo-50 dark:hover:bg-indigo-900/10 transition-all",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$MousePointer2), {
                                                                                    size: 16,
                                                                                    className: "text-slate-500"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                                                    className: "text-[8px] font-bold text-center text-slate-600 dark:text-slate-400 leading-tight",
                                                                                    children: "Focus Assist"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                            className: "space-y-3 pb-4",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("h5", {
                                                                    className: "text-[9px] font-extrabold text-slate-400 uppercase tracking-widest border-b border-slate-50 dark:border-slate-800 pb-2 font-sans",
                                                                    children: "Content & Motion"
                                                                }),
                                                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                                                    className: "grid grid-cols-2 gap-2.5",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                                                                            className: "flex flex-col items-center gap-2 p-4 bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-800 rounded-[20px] hover:bg-indigo-50 dark:hover:bg-indigo-900/10 transition-all",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Pause), {
                                                                                    size: 18,
                                                                                    className: "text-slate-500"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                                                    className: "text-[9px] font-bold text-center text-slate-600 dark:text-slate-400",
                                                                                    children: "Pause Animations"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                                                                            className: "flex flex-col items-center gap-2 p-4 bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-800 rounded-[20px] hover:bg-indigo-50 dark:hover:bg-indigo-900/10 transition-all",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ImageOff), {
                                                                                    size: 18,
                                                                                    className: "text-slate-500"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ccwsP$jsx)("span", {
                                                                                    className: "text-[9px] font-bold text-center text-slate-600 dark:text-slate-400",
                                                                                    children: "Hide Images"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                            className: `absolute pointer-events-none transition-all duration-500 ${!settings.enabled ? 'opacity-0 scale-50' : 'opacity-100 scale-100'} ${settings.buttonPosition === 'bottom-left' ? 'bottom-12 left-12' : settings.buttonPosition === 'bottom-right' ? 'bottom-12 right-12' : settings.buttonPosition === 'middle-left' ? 'top-1/2 left-8 -translate-y-1/2' : 'top-1/2 right-8 -translate-y-1/2'}`,
                                            children: /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                                className: "w-14 h-14 rounded-full flex items-center justify-center text-white shadow-2xl animate-bounce",
                                                style: {
                                                    backgroundColor: settings.primaryColor
                                                },
                                                children: /*#__PURE__*/ (0, $ccwsP$jsx)($9767764b6a108bdf$var$WidgetIcon, {
                                                    type: settings.buttonIcon,
                                                    size: 28,
                                                    color: "white"
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            showLinkBuilder && domain && /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                className: "fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4",
                children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                    className: "bg-white dark:bg-slate-900 rounded-[32px] p-8 max-w-md w-full shadow-2xl border border-slate-100 dark:border-slate-800",
                    children: [
                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                            className: "flex justify-between items-start mb-6",
                            children: [
                                /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                    className: "text-xl font-bold text-slate-900 dark:text-white",
                                    children: t.linkBuilderTitle
                                }),
                                /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                    onClick: ()=>setShowLinkBuilder(false),
                                    children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$X), {
                                        size: 24,
                                        className: "text-slate-400"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("label", {
                                            className: "text-xs font-bold uppercase text-slate-500 dark:text-slate-400 tracking-wider font-sans",
                                            children: t.sourceName
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("input", {
                                            className: "w-full mt-2 p-3 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl outline-none focus:border-indigo-500 text-slate-900 dark:text-white",
                                            placeholder: "e.g. facebook",
                                            value: lbSource,
                                            onChange: (e)=>setLbSource(e.target.value)
                                        }),
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                                            className: "flex flex-wrap gap-2 mt-3",
                                            children: [
                                                'Facebook',
                                                'Google',
                                                'Instagram',
                                                'Yelp',
                                                'TikTok'
                                            ].map((s)=>/*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                                    onClick: ()=>setLbSource(s.toLowerCase()),
                                                    className: "px-3 py-1.5 text-xs font-medium bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400 rounded-lg hover:bg-indigo-50 hover:text-indigo-600 transition-colors font-sans",
                                                    children: s
                                                }, s))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                                    className: "p-4 bg-slate-900 dark:bg-black rounded-xl text-indigo-200 font-mono text-xs break-all relative",
                                    children: [
                                        domain.url,
                                        "/?s=",
                                        lbSource.trim() || 'source',
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                            onClick: ()=>{
                                                navigator.clipboard.writeText(`${domain.url}/?s=${lbSource.trim()}`);
                                                setLbCopied(true);
                                                setTimeout(()=>setLbCopied(false), 2000);
                                            },
                                            className: "absolute top-2 right-2 p-1.5 bg-white/10 rounded hover:bg-white/20 text-white",
                                            children: lbCopied ? /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Check), {
                                                size: 14
                                            }) : /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Copy), {
                                                size: 14
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            showShareModal && domain && /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                className: "fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4",
                children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                    className: "bg-white dark:bg-slate-900 rounded-[32px] p-8 max-w-md w-full shadow-2xl border border-slate-100 dark:border-slate-800",
                    children: [
                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                            className: "flex justify-between items-start mb-6",
                            children: [
                                /*#__PURE__*/ (0, $ccwsP$jsx)("h3", {
                                    className: "text-xl font-bold text-slate-900 dark:text-white font-sans",
                                    children: t.shareReportTitle
                                }),
                                /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                    onClick: ()=>setShowShareModal(false),
                                    children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$X), {
                                        size: 24,
                                        className: "text-slate-400"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                            className: "p-4 bg-indigo-50 dark:bg-indigo-900/20 rounded-xl text-indigo-700 dark:text-indigo-300 font-mono text-xs break-all relative",
                            children: [
                                window.location.origin,
                                "/#/public/",
                                domain.id,
                                /*#__PURE__*/ (0, $ccwsP$jsx)("button", {
                                    onClick: ()=>{
                                        navigator.clipboard.writeText(`${window.location.origin}/#/public/${domain.id}`);
                                        setShareCopied(true);
                                        setTimeout(()=>setShareCopied(false), 2000);
                                    },
                                    className: "absolute top-2 right-2 p-1.5 bg-indigo-200 dark:bg-indigo-800 text-indigo-800 dark:text-indigo-200 rounded-lg",
                                    children: shareCopied ? /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Check), {
                                        size: 14
                                    }) : /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Copy), {
                                        size: 14
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            showEmbedModal && domain && /*#__PURE__*/ (0, $ccwsP$jsx)((0, $a60fbf2e582a0bfd$export$24aa2c0563a80031), {
                domain: domain,
                onClose: ()=>setShowEmbedModal(false)
            })
        ]
    });
};
var $9767764b6a108bdf$export$2e2bcd8739ae039 = $9767764b6a108bdf$var$AccessibilitySettingsPage;





const $8b1e4101b18f7227$var$InactiveUserScreen = ()=>{
    const { logout: logout } = (0, $20acffabdd663b48$export$1d39dc5b47e56ff0)();
    return /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
        className: "min-h-screen w-full flex items-center justify-center bg-slate-50 dark:bg-slate-950 p-6 font-sans",
        children: /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
            className: "max-w-md w-full bg-white dark:bg-slate-900 rounded-[32px] p-10 shadow-xl border border-slate-100 dark:border-slate-800 text-center animate-in fade-in zoom-in-95 duration-500",
            children: [
                /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
                    className: "w-20 h-20 bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg shadow-amber-500/10",
                    children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Clock), {
                        size: 40
                    })
                }),
                /*#__PURE__*/ (0, $ccwsP$jsx)("h1", {
                    className: "text-2xl font-bold text-slate-900 dark:text-white mb-3",
                    children: "Pending Activation"
                }),
                /*#__PURE__*/ (0, $ccwsP$jsx)("p", {
                    className: "text-slate-500 dark:text-slate-400 text-sm leading-relaxed mb-8",
                    children: "Your account has been created successfully. For security reasons, an administrator must review and activate your account before you can access the dashboard."
                }),
                /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                    className: "flex flex-col gap-3",
                    children: [
                        /*#__PURE__*/ (0, $ccwsP$jsxs)("div", {
                            className: "p-4 bg-slate-50 dark:bg-slate-800/50 rounded-2xl border border-slate-100 dark:border-slate-700 flex items-center gap-3 text-left",
                            children: [
                                /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$ShieldAlert), {
                                    size: 20,
                                    className: "text-indigo-500 shrink-0"
                                }),
                                /*#__PURE__*/ (0, $ccwsP$jsxs)("p", {
                                    className: "text-xs text-slate-500 dark:text-slate-400",
                                    children: [
                                        "Please contact ",
                                        /*#__PURE__*/ (0, $ccwsP$jsx)("strong", {
                                            children: "mbui41@gmail.com"
                                        }),
                                        " for faster approval."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsxs)("button", {
                            onClick: ()=>logout(),
                            className: "w-full py-4 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 font-bold rounded-2xl transition-colors flex items-center justify-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$LogOut), {
                                    size: 18
                                }),
                                " Sign Out"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $8b1e4101b18f7227$var$ProtectedRoute = ({ children: children })=>{
    const { user: user, isActive: isActive, loading: loading } = (0, $20acffabdd663b48$export$1d39dc5b47e56ff0)();
    if (loading) return /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
        className: "h-screen w-full flex items-center justify-center bg-slate-50 dark:bg-slate-950",
        children: /*#__PURE__*/ (0, $ccwsP$jsx)("div", {
            className: "animate-spin rounded-full h-12 w-12 border-4 border-indigo-500 border-t-transparent"
        })
    });
    if (!user) return /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Navigate), {
        to: "/auth",
        replace: true
    });
    if (!isActive) return /*#__PURE__*/ (0, $ccwsP$jsx)($8b1e4101b18f7227$var$InactiveUserScreen, {});
    return /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Fragment), {
        children: children
    });
};
const $8b1e4101b18f7227$var$App = ()=>{
    return /*#__PURE__*/ (0, $ccwsP$jsx)((0, $72ad5ad77b58d1fe$export$195746d839abd8b5), {
        children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $20acffabdd663b48$export$87091915187a1a85), {
            children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$HashRouter), {
                children: /*#__PURE__*/ (0, $ccwsP$jsxs)((0, $ccwsP$Routes), {
                    children: [
                        /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Route), {
                            path: "/auth",
                            element: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $4a1dbf79397ab509$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Route), {
                            path: "/",
                            element: /*#__PURE__*/ (0, $ccwsP$jsx)($8b1e4101b18f7227$var$ProtectedRoute, {
                                children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $f574884c61cfc7b9$export$2e2bcd8739ae039), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Route), {
                            path: "/report/:id",
                            element: /*#__PURE__*/ (0, $ccwsP$jsx)($8b1e4101b18f7227$var$ProtectedRoute, {
                                children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $a97e8c48f36eb07f$export$2e2bcd8739ae039), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Route), {
                            path: "/report/:id/gdpr-settings",
                            element: /*#__PURE__*/ (0, $ccwsP$jsx)($8b1e4101b18f7227$var$ProtectedRoute, {
                                children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $178b69f63ab67065$export$2e2bcd8739ae039), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Route), {
                            path: "/report/:id/accessibility",
                            element: /*#__PURE__*/ (0, $ccwsP$jsx)($8b1e4101b18f7227$var$ProtectedRoute, {
                                children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $9767764b6a108bdf$export$2e2bcd8739ae039), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Route), {
                            path: "/public/:id",
                            element: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $a97e8c48f36eb07f$export$2e2bcd8739ae039), {
                                readOnly: true
                            })
                        }),
                        /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$Navigate), {
                                to: "/",
                                replace: true
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $8b1e4101b18f7227$export$2e2bcd8739ae039 = $8b1e4101b18f7227$var$App;


const $ca885f479edad0ee$var$rootElement = document.getElementById('root');
if (!$ca885f479edad0ee$var$rootElement) throw new Error("Could not find root element to mount to");
const $ca885f479edad0ee$var$root = (0, $ccwsP$reactdomclient).createRoot($ca885f479edad0ee$var$rootElement);
$ca885f479edad0ee$var$root.render(/*#__PURE__*/ (0, $ccwsP$jsx)((0, $ccwsP$react).StrictMode, {
    children: /*#__PURE__*/ (0, $ccwsP$jsx)((0, $8b1e4101b18f7227$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=repo.1089a1fe.js.map
